// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Sale from "../../modules/Sale/Sale.res.js";
import * as View from "../../primitives/View.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Media from "../../primitives/Media.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Table from "../../resources/tables/Table.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as BigJs from "big.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Breakpoints from "../../resources/theme/Breakpoints.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as SalesRoutes from "./SalesRoutes.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as CatalogRoutes from "../Catalog/CatalogRoutes.res.js";
import * as PaymentMethod from "../../modules/PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StockQuantity from "../../core/StockQuantity.res.js";
import * as Client from "@apollo/client";
import * as CustomerRoutes from "../Customer/CustomerRoutes.res.js";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as Stylex from "@stylexjs/stylex";
import * as CanaryDisclosure from "../../resources/data-visualizations/CanaryDisclosure.res.js";
import * as CanaryStatsCount from "../../resources/data-visualizations/CanaryStatsCount.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CanaryCardInfoSwap from "../../resources/layout-and-structure/CanaryCardInfoSwap.res.js";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as CanaryInformationList from "../../resources/data-visualizations/CanaryInformationList.res.js";
import * as CanaryToolbarDocument from "../../resources/layout-and-structure/CanaryToolbarDocument.res.js";
import * as SaleCartSummaryAmounts from "../../modules/Sale/SaleCartSummaryAmounts.res.js";
import * as NextResourceDetailsPage from "../../core/NextResourceDetailsPage.res.js";
import * as ProductReferenceTableCell from "../../modules/Product/ProductReferenceTableCell.res.js";
import * as ElectronicInvoicingWorkflowState from "../../modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let nonApplicableString = "—";
let Raw = {};
let query = Client.gql(["fragment SalesVariantFragment on Variant   {\n__typename  \nid  \ncku  \nname  \nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \nproduct  {\n__typename  \nid  \nkind  \nname  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \n}\n\nsupplier  {\n__typename  \nid  \ncompanyName  \n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.stockKeepingUnit;
  let value$2 = value.priceLookUpCode;
  let value$3 = value.internalCode;
  let value$4 = value.product;
  let value$5 = value$4.kind;
  let tmp;
  switch (value$5) {
    case "BEER":
      tmp = "BEER";
      break;
    case "SIMPLE":
      tmp = "SIMPLE";
      break;
    case "SPIRITUOUS":
      tmp = "SPIRITUOUS";
      break;
    case "WINE":
      tmp = "WINE";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$6 = value$4.producer;
  let value$7 = value$4.designation;
  let value$8 = value$4.family;
  let value$9 = value$4.region;
  let value$10 = value$4.country;
  let value$11 = value$4.color;
  let tmp$1;
  if (value$11 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$11) {
      case "AMBER":
        tmp$2 = "AMBER";
        break;
      case "BLACK":
        tmp$2 = "BLACK";
        break;
      case "BLOND":
        tmp$2 = "BLOND";
        break;
      case "DARK":
        tmp$2 = "DARK";
        break;
      case "ORANGE":
        tmp$2 = "ORANGE";
        break;
      case "RED":
        tmp$2 = "RED";
        break;
      case "ROSE":
        tmp$2 = "ROSE";
        break;
      case "WHITE":
        tmp$2 = "WHITE";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$1 = tmp$2;
  }
  let value$12 = value$4.wineType;
  let tmp$3;
  if (value$12 == null) {
    tmp$3 = undefined;
  } else {
    let tmp$4;
    switch (value$12) {
      case "EFFERVESCENT":
        tmp$4 = "EFFERVESCENT";
        break;
      case "STILL":
        tmp$4 = "STILL";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$3 = tmp$4;
  }
  let value$13 = value$4.whiteWineType;
  let tmp$5;
  if (value$13 == null) {
    tmp$5 = undefined;
  } else {
    let tmp$6;
    switch (value$13) {
      case "DRY":
        tmp$6 = "DRY";
        break;
      case "SEMIDRY":
        tmp$6 = "SEMIDRY";
        break;
      case "SOFT":
        tmp$6 = "SOFT";
        break;
      case "SWEET":
        tmp$6 = "SWEET";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$5 = tmp$6;
  }
  let value$14 = value$4.beerType;
  let value$15 = value.supplier;
  return {
    __typename: value.__typename,
    id: value.id,
    cku: Scalar.CKU.parse(value.cku),
    name: value.name,
    stockKeepingUnit: !(value$1 == null) ? value$1 : undefined,
    priceLookUpCode: !(value$2 == null) ? value$2 : undefined,
    internalCode: !(value$3 == null) ? value$3 : undefined,
    product: {
      __typename: value$4.__typename,
      id: value$4.id,
      kind: tmp,
      name: value$4.name,
      producer: !(value$6 == null) ? value$6 : undefined,
      designation: !(value$7 == null) ? value$7 : undefined,
      family: !(value$8 == null) ? value$8 : undefined,
      region: !(value$9 == null) ? value$9 : undefined,
      country: !(value$10 == null) ? value$10 : undefined,
      color: tmp$1,
      wineType: tmp$3,
      whiteWineType: tmp$5,
      beerType: !(value$14 == null) ? value$14 : undefined
    },
    supplier: !(value$15 == null) ? {
      __typename: value$15.__typename,
      id: value$15.id,
      companyName: value$15.companyName
    } : undefined
  };
}
function serialize(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.companyName;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    supplier = {
      __typename: value$4,
      id: value$3,
      companyName: value$2
    };
  } else {
    supplier = null;
  }
  let value$5 = value.product;
  let value$6 = value$5.beerType;
  let beerType = value$6 !== undefined ? value$6 : null;
  let value$7 = value$5.whiteWineType;
  let whiteWineType = value$7 !== undefined ? value$7 === "SWEET" ? "SWEET" : value$7 === "SEMIDRY" ? "SEMIDRY" : value$7 === "SOFT" ? "SOFT" : "DRY" : null;
  let value$8 = value$5.wineType;
  let wineType = value$8 !== undefined ? value$8 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL" : null;
  let value$9 = value$5.color;
  let color = value$9 !== undefined ? value$9 === "ORANGE" ? "ORANGE" : value$9 === "RED" ? "RED" : value$9 === "AMBER" ? "AMBER" : value$9 === "DARK" ? "DARK" : value$9 === "BLACK" ? "BLACK" : value$9 === "BLOND" ? "BLOND" : value$9 === "ROSE" ? "ROSE" : "WHITE" : null;
  let value$10 = value$5.country;
  let country = value$10 !== undefined ? value$10 : null;
  let value$11 = value$5.region;
  let region = value$11 !== undefined ? value$11 : null;
  let value$12 = value$5.family;
  let family = value$12 !== undefined ? value$12 : null;
  let value$13 = value$5.designation;
  let designation = value$13 !== undefined ? value$13 : null;
  let value$14 = value$5.producer;
  let producer = value$14 !== undefined ? value$14 : null;
  let value$15 = value$5.name;
  let value$16 = value$5.kind;
  let kind = value$16 === "SPIRITUOUS" ? "SPIRITUOUS" : value$16 === "BEER" ? "BEER" : value$16 === "WINE" ? "WINE" : "SIMPLE";
  let value$17 = value$5.id;
  let value$18 = value$5.__typename;
  let product = {
    __typename: value$18,
    id: value$17,
    kind: kind,
    name: value$15,
    producer: producer,
    designation: designation,
    family: family,
    region: region,
    country: country,
    color: color,
    wineType: wineType,
    whiteWineType: whiteWineType,
    beerType: beerType
  };
  let value$19 = value.internalCode;
  let internalCode = value$19 !== undefined ? value$19 : null;
  let value$20 = value.priceLookUpCode;
  let priceLookUpCode = value$20 !== undefined ? value$20 : null;
  let value$21 = value.stockKeepingUnit;
  let stockKeepingUnit = value$21 !== undefined ? value$21 : null;
  let value$22 = value.name;
  let value$23 = value.cku;
  let value$24 = Scalar.CKU.serialize(value$23);
  let value$25 = value.id;
  let value$26 = value.__typename;
  return {
    __typename: value$26,
    id: value$25,
    cku: value$24,
    name: value$22,
    stockKeepingUnit: stockKeepingUnit,
    priceLookUpCode: priceLookUpCode,
    internalCode: internalCode,
    product: product,
    supplier: supplier
  };
}
function verifyArgsAndParse(_SalesVariantFragment, value) {
  return parse(value);
}
function verifyName(_fragmentName) {}
let SalesVariantFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
let Raw$1 = {};
let query$1 = Client.gql(["query SalesDetailsInvoiceQuery($invoiceId: ID!)  {\ninvoice(id: $invoiceId)  {\n__typename  \nid  \nname  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \nstatus  \nelectronicInvoicingWorkflowState  {\n...ElectronicInvoicingWorkflowStateResultFragment   \n}\n\ncustomerInvoicingEndpointIdSchemeCode  \ncustomerInvoicingEndpointIdSchemeType  \ncustomerInvoicingEndpointId  \nnote  \ntermsOfPayment  \npayments  {\n__typename  \nid  \nmethod  \ndate  \namountReceived  \namountReturned  \n}\n\ndeliveryNotes  {\n__typename  \nid  \nname  \ndate  \nstatus  \n}\n\nparentQuote  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\nsalesReceipt  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\ncreditNotes  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\nissueDate  \ndueDate  \ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ntaxesIncluded  \nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on InvoiceItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on InvoiceCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\ndiscounts  {\n__typename\n...on InvoiceItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on InvoiceFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", "", ""], query, ElectronicInvoicingWorkflowState.ResultFragment.query);
function parse$1(value) {
  let value$1 = value.invoice;
  let value$2 = value$1.status;
  let tmp;
  switch (value$2) {
    case "DRAFT":
      tmp = "DRAFT";
      break;
    case "PAID":
      tmp = "PAID";
      break;
    case "UNPAID":
      tmp = "UNPAID";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$3 = value$1.electronicInvoicingWorkflowState;
  let value$4 = value$1.customerInvoicingEndpointIdSchemeCode;
  let value$5 = value$1.customerInvoicingEndpointIdSchemeType;
  let tmp$1;
  if (value$5 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$5) {
      case "BE_BCE":
        tmp$2 = "BE_BCE";
        break;
      case "BE_TVA":
        tmp$2 = "BE_TVA";
        break;
      case "FR_SIREN":
        tmp$2 = "FR_SIREN";
        break;
      case "FR_SIREN_SIRET":
        tmp$2 = "FR_SIREN_SIRET";
        break;
      case "FR_SIREN_SIRET_CODEROUTAGE":
        tmp$2 = "FR_SIREN_SIRET_CODEROUTAGE";
        break;
      case "FR_SIREN_SUFFIX":
        tmp$2 = "FR_SIREN_SUFFIX";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$1 = tmp$2;
  }
  let value$6 = value$1.customerInvoicingEndpointId;
  let value$7 = value$1.note;
  let value$8 = value$1.payments;
  let value$9 = value$1.deliveryNotes;
  let value$10 = value$1.parentQuote;
  let value$11 = value$1.salesReceipt;
  let value$12 = value$1.creditNotes;
  let value$13 = value$1.dueDate;
  let value$14 = value$1.customerAddress;
  let value$15 = value$1.customerCity;
  let value$16 = value$1.customerPostalCode;
  let value$17 = value$1.customerCountry;
  let value$18 = value$1.customerEmail;
  let value$19 = value$1.customerIntraCommunityVAT;
  let value$20 = value$1.customerPhoneNumber;
  let value$21 = value$1.customer;
  let tmp$3;
  if (value$21 == null) {
    tmp$3 = undefined;
  } else {
    let value$22 = value$21.kind;
    let tmp$4;
    switch (value$22) {
      case "BUSINESS":
        tmp$4 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$4 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$3 = {
      __typename: value$21.__typename,
      id: value$21.id,
      kind: tmp$4,
      hasSubscribedToLoyaltyProgram: value$21.hasSubscribedToLoyaltyProgram
    };
  }
  let value$23 = value$1.price;
  let value$24 = value$1.shop;
  let value$25 = value$1.staff;
  let value$26 = value$1.device;
  let value$27 = value$1.items;
  let value$28 = value$1.discounts;
  let value$29 = value$1.taxes;
  return {
    invoice: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      status: tmp,
      electronicInvoicingWorkflowState: ElectronicInvoicingWorkflowState.ResultFragment.verifyArgsAndParse("ElectronicInvoicingWorkflowStateResultFragment", value$3),
      customerInvoicingEndpointIdSchemeCode: !(value$4 == null) ? value$4 : undefined,
      customerInvoicingEndpointIdSchemeType: tmp$1,
      customerInvoicingEndpointId: !(value$6 == null) ? value$6 : undefined,
      note: !(value$7 == null) ? value$7 : undefined,
      termsOfPayment: value$1.termsOfPayment,
      payments: value$8.map(value => {
        let value$1 = value.method;
        let tmp;
        switch (value$1) {
          case "AMEX":
            tmp = "AMEX";
            break;
          case "BANK_TRANSFER":
            tmp = "BANK_TRANSFER";
            break;
          case "BARNABY":
            tmp = "BARNABY";
            break;
          case "CASH":
            tmp = "CASH";
            break;
          case "CHEQUE":
            tmp = "CHEQUE";
            break;
          case "CONTACTLESS_AMEX":
            tmp = "CONTACTLESS_AMEX";
            break;
          case "CONTACTLESS_DEBIT_CARD":
            tmp = "CONTACTLESS_DEBIT_CARD";
            break;
          case "CREDIT_MEMO":
            tmp = "CREDIT_MEMO";
            break;
          case "DEBIT_CARD":
            tmp = "DEBIT_CARD";
            break;
          case "DISTANCE_SELLING":
            tmp = "DISTANCE_SELLING";
            break;
          case "EUSKO_CASH":
            tmp = "EUSKO_CASH";
            break;
          case "EUSKO_DIGITAL":
            tmp = "EUSKO_DIGITAL";
            break;
          case "GIFT_VOUCHER":
            tmp = "GIFT_VOUCHER";
            break;
          case "LESHABITUES":
            tmp = "LESHABITUES";
            break;
          case "LYDIA":
            tmp = "LYDIA";
            break;
          case "PAYPAL":
            tmp = "PAYPAL";
            break;
          case "TICKET_RESTAURANT":
            tmp = "TICKET_RESTAURANT";
            break;
          case "TOWN_HALL_GIFT_VOUCHER":
            tmp = "TOWN_HALL_GIFT_VOUCHER";
            break;
          case "WINO_PAY":
            tmp = "WINO_PAY";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          method: tmp,
          date: Scalar.Datetime.parse(value.date),
          amountReceived: value.amountReceived,
          amountReturned: value.amountReturned
        };
      }),
      deliveryNotes: value$9.map(value => {
        let value$1 = value.status;
        let tmp;
        switch (value$1) {
          case "DRAFT":
            tmp = "DRAFT";
            break;
          case "PUBLISHED":
            tmp = "PUBLISHED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          name: value.name,
          date: Scalar.Datetime.parse(value.date),
          status: tmp
        };
      }),
      parentQuote: !(value$10 == null) ? {
        __typename: value$10.__typename,
        id: value$10.id,
        name: value$10.name,
        createdAt: Scalar.Datetime.parse(value$10.createdAt)
      } : undefined,
      salesReceipt: !(value$11 == null) ? {
        __typename: value$11.__typename,
        id: value$11.id,
        name: value$11.name,
        createdAt: Scalar.Datetime.parse(value$11.createdAt)
      } : undefined,
      creditNotes: value$12.map(value => ({
        __typename: value.__typename,
        id: value.id,
        name: value.name,
        createdAt: Scalar.Datetime.parse(value.createdAt)
      })),
      issueDate: Scalar.Datetime.parse(value$1.issueDate),
      dueDate: !(value$13 == null) ? Scalar.Datetime.parse(value$13) : undefined,
      customerName: value$1.customerName,
      customerAddress: !(value$14 == null) ? value$14 : undefined,
      customerCity: !(value$15 == null) ? value$15 : undefined,
      customerPostalCode: !(value$16 == null) ? value$16 : undefined,
      customerCountry: !(value$17 == null) ? value$17 : undefined,
      customerEmail: !(value$18 == null) ? value$18 : undefined,
      customerIntraCommunityVAT: !(value$19 == null) ? value$19 : undefined,
      customerPhoneNumber: !(value$20 == null) ? value$20 : undefined,
      customer: tmp$3,
      taxesIncluded: value$1.taxesIncluded,
      price: !(value$23 == null) ? {
        __typename: value$23.__typename,
        id: value$23.id,
        name: value$23.name
      } : undefined,
      shop: {
        __typename: value$24.__typename,
        id: value$24.id,
        name: value$24.name
      },
      staff: {
        __typename: value$25.__typename,
        id: value$25.id,
        name: value$25.name
      },
      device: {
        __typename: value$26.__typename,
        id: value$26.id,
        name: value$26.name,
        slug: value$26.slug
      },
      items: value$27.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "InvoiceCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxesIncluded;
            let value$4 = value.taxes;
            let value$5 = value.variant;
            return {
              NAME: "InvoiceCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: !(value$3 == null) ? value$3 : undefined,
                taxes: value$4.map(value => ({
                  __typename: value.__typename,
                  name: value.name,
                  ratio: value.ratio
                })),
                variant: !(value$5 == null) ? parse(value$5) : undefined
              }
            };
          case "InvoiceItem":
            let value$6 = value.capacityUnit;
            let value$7 = value.capacityPrecision;
            let value$8 = value.taxesIncluded;
            let value$9 = value.taxes;
            let value$10 = value.variant;
            return {
              NAME: "InvoiceItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$6 == null) ? value$6 : undefined,
                capacityPrecision: !(value$7 == null) ? value$7 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: !(value$8 == null) ? value$8 : undefined,
                taxes: value$9.map(value => ({
                  __typename: value.__typename,
                  name: value.name
                })),
                variant: !(value$10 == null) ? parse(value$10) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      discounts: value$28.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "InvoiceFooterDiscount":
            let value$1 = value.valueType;
            let tmp;
            switch (value$1) {
              case "Currency":
                tmp = "Currency";
                break;
              case "Percentage":
                tmp = "Percentage";
                break;
              default:
                tmp = {
                  NAME: "FutureAddedValue",
                  VAL: value$1
                };
            }
            return {
              NAME: "InvoiceFooterDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                value: value.value,
                valueType: tmp,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          case "InvoiceItemDiscount":
            let value$2 = value.appliedTo;
            let value$3 = value.valueType;
            let tmp$1;
            switch (value$3) {
              case "Currency":
                tmp$1 = "Currency";
                break;
              case "Percentage":
                tmp$1 = "Percentage";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$3
                };
            }
            return {
              NAME: "InvoiceItemDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                appliedTo: value$2.map(value => value),
                value: value.value,
                valueType: tmp$1,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      taxes: value$29.map(value => {
        let value$1 = value.baseAmount;
        return {
          __typename: value.__typename,
          rate: value.rate,
          baseAmount: !(value$1 == null) ? value$1 : undefined,
          taxAmount: value.taxAmount
        };
      })
    }
  };
}
function serialize$1(value) {
  let value$1 = value.invoice;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let baseAmount = value$2 !== undefined ? value$2 : null;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: baseAmount,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.discounts;
  let discounts = value$3.map(value => {
    if (value.NAME === "InvoiceFooterDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.name;
      let value$7 = value$1.id;
      return {
        __typename: "InvoiceFooterDiscount",
        id: value$7,
        name: value$6,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$8 = value.VAL;
    let value$9 = value$8.totalAmountExcludingTaxes;
    let value$10 = value$8.totalAmountIncludingTaxes;
    let value$11 = value$8.valueType;
    let valueType$1 = typeof value$11 === "object" ? value$11.VAL : value$11 === "Currency" ? "Currency" : "Percentage";
    let value$12 = value$8.value;
    let value$13 = value$8.appliedTo;
    let appliedTo = value$13.map(value => value);
    let value$14 = value$8.name;
    let value$15 = value$8.id;
    return {
      __typename: "InvoiceItemDiscount",
      id: value$15,
      name: value$14,
      appliedTo: appliedTo,
      value: value$12,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$10,
      totalAmountExcludingTaxes: value$9
    };
  });
  let value$4 = value$1.items;
  let items = value$4.map(value => {
    if (value.NAME === "InvoiceItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.name;
        let value$2 = value.__typename;
        return {
          __typename: value$2,
          name: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let taxesIncluded = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.totalPrice;
      let value$6 = value$1.price;
      let value$7 = value$1.capacityPrecision;
      let capacityPrecision = value$7 !== undefined ? value$7 : null;
      let value$8 = value$1.capacityUnit;
      let capacityUnit = value$8 !== undefined ? value$8 : null;
      let value$9 = value$1.quantity;
      let value$10 = value$1.category;
      let value$11 = value$1.name;
      let value$12 = value$1.id;
      return {
        __typename: "InvoiceItem",
        id: value$12,
        name: value$11,
        category: value$10,
        quantity: value$9,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$6,
        totalPrice: value$5,
        taxesIncluded: taxesIncluded,
        taxes: taxes,
        variant: variant
      };
    }
    let value$13 = value.VAL;
    let value$14 = value$13.variant;
    let variant$1 = value$14 !== undefined ? serialize(value$14) : null;
    let value$15 = value$13.taxes;
    let taxes$1 = value$15.map(value => {
      let value$1 = value.ratio;
      let value$2 = value.name;
      let value$3 = value.__typename;
      return {
        __typename: value$3,
        name: value$2,
        ratio: value$1
      };
    });
    let value$16 = value$13.taxesIncluded;
    let taxesIncluded$1 = value$16 !== undefined ? value$16 : null;
    let value$17 = value$13.totalAmountIncludingTaxes;
    let value$18 = value$13.totalAmountExcludingTaxes;
    let value$19 = value$13.totalPrice;
    let value$20 = value$13.price;
    let value$21 = value$13.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$13.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$13.quantity;
    let value$24 = value$13.category;
    let value$25 = value$13.name;
    let value$26 = value$13.id;
    return {
      __typename: "InvoiceCompoundItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      totalAmountExcludingTaxes: value$18,
      totalAmountIncludingTaxes: value$17,
      taxesIncluded: taxesIncluded$1,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$5 = value$1.device;
  let value$6 = value$5.slug;
  let value$7 = value$5.name;
  let value$8 = value$5.id;
  let value$9 = value$5.__typename;
  let device = {
    __typename: value$9,
    id: value$8,
    name: value$7,
    slug: value$6
  };
  let value$10 = value$1.staff;
  let value$11 = value$10.name;
  let value$12 = value$10.id;
  let value$13 = value$10.__typename;
  let staff = {
    __typename: value$13,
    id: value$12,
    name: value$11
  };
  let value$14 = value$1.shop;
  let value$15 = value$14.name;
  let value$16 = value$14.id;
  let value$17 = value$14.__typename;
  let shop = {
    __typename: value$17,
    id: value$16,
    name: value$15
  };
  let value$18 = value$1.price;
  let price;
  if (value$18 !== undefined) {
    let value$19 = value$18.name;
    let value$20 = value$18.id;
    let value$21 = value$18.__typename;
    price = {
      __typename: value$21,
      id: value$20,
      name: value$19
    };
  } else {
    price = null;
  }
  let value$22 = value$1.taxesIncluded;
  let value$23 = value$1.customer;
  let customer;
  if (value$23 !== undefined) {
    let value$24 = value$23.hasSubscribedToLoyaltyProgram;
    let value$25 = value$23.kind;
    let kind = value$25 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$26 = value$23.id;
    let value$27 = value$23.__typename;
    customer = {
      __typename: value$27,
      id: value$26,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$24
    };
  } else {
    customer = null;
  }
  let value$28 = value$1.customerPhoneNumber;
  let customerPhoneNumber = value$28 !== undefined ? value$28 : null;
  let value$29 = value$1.customerIntraCommunityVAT;
  let customerIntraCommunityVAT = value$29 !== undefined ? value$29 : null;
  let value$30 = value$1.customerEmail;
  let customerEmail = value$30 !== undefined ? value$30 : null;
  let value$31 = value$1.customerCountry;
  let customerCountry = value$31 !== undefined ? value$31 : null;
  let value$32 = value$1.customerPostalCode;
  let customerPostalCode = value$32 !== undefined ? value$32 : null;
  let value$33 = value$1.customerCity;
  let customerCity = value$33 !== undefined ? value$33 : null;
  let value$34 = value$1.customerAddress;
  let customerAddress = value$34 !== undefined ? value$34 : null;
  let value$35 = value$1.customerName;
  let value$36 = value$1.dueDate;
  let dueDate = value$36 !== undefined ? Scalar.Datetime.serialize(value$36) : null;
  let value$37 = value$1.issueDate;
  let value$38 = Scalar.Datetime.serialize(value$37);
  let value$39 = value$1.creditNotes;
  let creditNotes = value$39.map(value => {
    let value$1 = value.createdAt;
    let value$2 = Scalar.Datetime.serialize(value$1);
    let value$3 = value.name;
    let value$4 = value.id;
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      id: value$4,
      name: value$3,
      createdAt: value$2
    };
  });
  let value$40 = value$1.salesReceipt;
  let salesReceipt;
  if (value$40 !== undefined) {
    let value$41 = value$40.createdAt;
    let value$42 = Scalar.Datetime.serialize(value$41);
    let value$43 = value$40.name;
    let value$44 = value$40.id;
    let value$45 = value$40.__typename;
    salesReceipt = {
      __typename: value$45,
      id: value$44,
      name: value$43,
      createdAt: value$42
    };
  } else {
    salesReceipt = null;
  }
  let value$46 = value$1.parentQuote;
  let parentQuote;
  if (value$46 !== undefined) {
    let value$47 = value$46.createdAt;
    let value$48 = Scalar.Datetime.serialize(value$47);
    let value$49 = value$46.name;
    let value$50 = value$46.id;
    let value$51 = value$46.__typename;
    parentQuote = {
      __typename: value$51,
      id: value$50,
      name: value$49,
      createdAt: value$48
    };
  } else {
    parentQuote = null;
  }
  let value$52 = value$1.deliveryNotes;
  let deliveryNotes = value$52.map(value => {
    let value$1 = value.status;
    let status = value$1 === "DRAFT" ? "DRAFT" : "PUBLISHED";
    let value$2 = value.date;
    let value$3 = Scalar.Datetime.serialize(value$2);
    let value$4 = value.name;
    let value$5 = value.id;
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      id: value$5,
      name: value$4,
      date: value$3,
      status: status
    };
  });
  let value$53 = value$1.payments;
  let payments = value$53.map(value => {
    let value$1 = value.amountReturned;
    let value$2 = value.amountReceived;
    let value$3 = value.date;
    let value$4 = Scalar.Datetime.serialize(value$3);
    let value$5 = value.method;
    let method_ = value$5 === "LESHABITUES" ? "LESHABITUES" : value$5 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$5 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$5 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$5 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$5 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$5 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$5 === "CHEQUE" ? "CHEQUE" : value$5 === "LYDIA" ? "LYDIA" : value$5 === "DEBIT_CARD" ? "DEBIT_CARD" : value$5 === "EUSKO_CASH" ? "EUSKO_CASH" : value$5 === "BARNABY" ? "BARNABY" : value$5 === "PAYPAL" ? "PAYPAL" : value$5 === "AMEX" ? "AMEX" : value$5 === "CASH" ? "CASH" : value$5 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$5 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$5 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
    let value$6 = value.id;
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      id: value$6,
      method: method_,
      date: value$4,
      amountReceived: value$2,
      amountReturned: value$1
    };
  });
  let value$54 = value$1.termsOfPayment;
  let value$55 = value$1.note;
  let note = value$55 !== undefined ? value$55 : null;
  let value$56 = value$1.customerInvoicingEndpointId;
  let customerInvoicingEndpointId = value$56 !== undefined ? value$56 : null;
  let value$57 = value$1.customerInvoicingEndpointIdSchemeType;
  let customerInvoicingEndpointIdSchemeType = value$57 !== undefined ? value$57 === "BE_TVA" ? "BE_TVA" : value$57 === "FR_SIREN" ? "FR_SIREN" : value$57 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : value$57 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : value$57 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : null;
  let value$58 = value$1.customerInvoicingEndpointIdSchemeCode;
  let customerInvoicingEndpointIdSchemeCode = value$58 !== undefined ? value$58 : null;
  let value$59 = value$1.electronicInvoicingWorkflowState;
  let electronicInvoicingWorkflowState = ElectronicInvoicingWorkflowState.ResultFragment.serialize(value$59);
  let value$60 = value$1.status;
  let status = value$60 === "UNPAID" ? "UNPAID" : value$60 === "PAID" ? "PAID" : "DRAFT";
  let value$61 = value$1.totalAmountExcludingTaxes;
  let value$62 = value$1.totalAmountIncludingTaxes;
  let value$63 = value$1.name;
  let value$64 = value$1.id;
  let value$65 = value$1.__typename;
  let invoice = {
    __typename: value$65,
    id: value$64,
    name: value$63,
    totalAmountIncludingTaxes: value$62,
    totalAmountExcludingTaxes: value$61,
    status: status,
    electronicInvoicingWorkflowState: electronicInvoicingWorkflowState,
    customerInvoicingEndpointIdSchemeCode: customerInvoicingEndpointIdSchemeCode,
    customerInvoicingEndpointIdSchemeType: customerInvoicingEndpointIdSchemeType,
    customerInvoicingEndpointId: customerInvoicingEndpointId,
    note: note,
    termsOfPayment: value$54,
    payments: payments,
    deliveryNotes: deliveryNotes,
    parentQuote: parentQuote,
    salesReceipt: salesReceipt,
    creditNotes: creditNotes,
    issueDate: value$38,
    dueDate: dueDate,
    customerName: value$35,
    customerAddress: customerAddress,
    customerCity: customerCity,
    customerPostalCode: customerPostalCode,
    customerCountry: customerCountry,
    customerEmail: customerEmail,
    customerIntraCommunityVAT: customerIntraCommunityVAT,
    customerPhoneNumber: customerPhoneNumber,
    customer: customer,
    taxesIncluded: value$22,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    discounts: discounts,
    taxes: taxes
  };
  return {
    invoice: invoice
  };
}
function serializeVariables(inp) {
  return {
    invoiceId: inp.invoiceId
  };
}
function makeVariables(invoiceId, param) {
  return {
    invoiceId: invoiceId
  };
}
let SalesDetailsInvoiceQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});
let use = include.use;
let SalesDetailsInvoiceQuery_refetchQueryDescription = include.refetchQueryDescription;
let SalesDetailsInvoiceQuery_useLazy = include.useLazy;
let SalesDetailsInvoiceQuery_useLazyWithVariables = include.useLazyWithVariables;
let SalesDetailsInvoiceQuery = {
  SalesDetailsInvoiceQuery_inner: SalesDetailsInvoiceQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SalesDetailsInvoiceQuery_refetchQueryDescription,
  use: use,
  useLazy: SalesDetailsInvoiceQuery_useLazy,
  useLazyWithVariables: SalesDetailsInvoiceQuery_useLazyWithVariables
};
let Raw$2 = {};
let query$2 = Client.gql(["query SalesDetailsReceiptQuery($receiptId: ID!)  {\nsalesReceipt(id: $receiptId)  {\n__typename  \nid  \nname  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ncreatedAt  \npayments  {\n__typename  \nid  \nmethod  \namountReceived  \namountReturned  \n}\n\ninvoice  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\nrefundReceipts  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\ncustomer  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nemail  \nintraCommunityVAT  \nphoneNumber  \nlocations  {\n__typename  \naddress  \ncity  \npostalCode  \ncountry  \n}\n\nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ntaxesIncluded  \nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on SalesReceiptItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nrate  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on SalesReceiptCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nrate  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\ndiscounts  {\n__typename\n...on SalesReceiptItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on SalesReceiptFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", ""], query);
function parse$2(value) {
  let value$1 = value.salesReceipt;
  let value$2 = value$1.payments;
  let value$3 = value$1.invoice;
  let value$4 = value$1.refundReceipts;
  let value$5 = value$1.customer;
  let tmp;
  if (value$5 == null) {
    tmp = undefined;
  } else {
    let value$6 = value$5.firstName;
    let value$7 = value$5.lastName;
    let value$8 = value$5.companyName;
    let value$9 = value$5.email;
    let value$10 = value$5.intraCommunityVAT;
    let value$11 = value$5.phoneNumber;
    let value$12 = value$5.locations;
    let value$13 = value$5.kind;
    let tmp$1;
    switch (value$13) {
      case "BUSINESS":
        tmp$1 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$1 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = {
      __typename: value$5.__typename,
      id: value$5.id,
      firstName: !(value$6 == null) ? value$6 : undefined,
      lastName: !(value$7 == null) ? value$7 : undefined,
      companyName: !(value$8 == null) ? value$8 : undefined,
      email: !(value$9 == null) ? value$9 : undefined,
      intraCommunityVAT: !(value$10 == null) ? value$10 : undefined,
      phoneNumber: !(value$11 == null) ? value$11 : undefined,
      locations: value$12.map(value => {
        let value$1 = value.address;
        let value$2 = value.city;
        let value$3 = value.postalCode;
        let value$4 = value.country;
        return {
          __typename: value.__typename,
          address: !(value$1 == null) ? value$1 : undefined,
          city: !(value$2 == null) ? value$2 : undefined,
          postalCode: !(value$3 == null) ? value$3 : undefined,
          country: !(value$4 == null) ? value$4 : undefined
        };
      }),
      kind: tmp$1,
      hasSubscribedToLoyaltyProgram: value$5.hasSubscribedToLoyaltyProgram
    };
  }
  let value$14 = value$1.price;
  let value$15 = value$1.shop;
  let value$16 = value$1.staff;
  let value$17 = value$1.device;
  let value$18 = value$1.items;
  let value$19 = value$1.discounts;
  let value$20 = value$1.taxes;
  return {
    salesReceipt: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      payments: value$2.map(value => {
        let value$1 = value.method;
        let tmp;
        switch (value$1) {
          case "AMEX":
            tmp = "AMEX";
            break;
          case "BANK_TRANSFER":
            tmp = "BANK_TRANSFER";
            break;
          case "BARNABY":
            tmp = "BARNABY";
            break;
          case "CASH":
            tmp = "CASH";
            break;
          case "CHEQUE":
            tmp = "CHEQUE";
            break;
          case "CONTACTLESS_AMEX":
            tmp = "CONTACTLESS_AMEX";
            break;
          case "CONTACTLESS_DEBIT_CARD":
            tmp = "CONTACTLESS_DEBIT_CARD";
            break;
          case "CREDIT_MEMO":
            tmp = "CREDIT_MEMO";
            break;
          case "DEBIT_CARD":
            tmp = "DEBIT_CARD";
            break;
          case "DISTANCE_SELLING":
            tmp = "DISTANCE_SELLING";
            break;
          case "EUSKO_CASH":
            tmp = "EUSKO_CASH";
            break;
          case "EUSKO_DIGITAL":
            tmp = "EUSKO_DIGITAL";
            break;
          case "GIFT_VOUCHER":
            tmp = "GIFT_VOUCHER";
            break;
          case "LESHABITUES":
            tmp = "LESHABITUES";
            break;
          case "LYDIA":
            tmp = "LYDIA";
            break;
          case "PAYPAL":
            tmp = "PAYPAL";
            break;
          case "TICKET_RESTAURANT":
            tmp = "TICKET_RESTAURANT";
            break;
          case "TOWN_HALL_GIFT_VOUCHER":
            tmp = "TOWN_HALL_GIFT_VOUCHER";
            break;
          case "WINO_PAY":
            tmp = "WINO_PAY";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          method: tmp,
          amountReceived: value.amountReceived,
          amountReturned: value.amountReturned
        };
      }),
      invoice: !(value$3 == null) ? {
        __typename: value$3.__typename,
        id: value$3.id,
        name: value$3.name,
        createdAt: Scalar.Datetime.parse(value$3.createdAt)
      } : undefined,
      refundReceipts: value$4.map(value => ({
        __typename: value.__typename,
        id: value.id,
        name: value.name,
        createdAt: Scalar.Datetime.parse(value.createdAt)
      })),
      customer: tmp,
      taxesIncluded: value$1.taxesIncluded,
      price: !(value$14 == null) ? {
        __typename: value$14.__typename,
        id: value$14.id,
        name: value$14.name
      } : undefined,
      shop: {
        __typename: value$15.__typename,
        id: value$15.id,
        name: value$15.name
      },
      staff: {
        __typename: value$16.__typename,
        id: value$16.id,
        name: value$16.name
      },
      device: {
        __typename: value$17.__typename,
        id: value$17.id,
        name: value$17.name,
        slug: value$17.slug
      },
      items: value$18.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "SalesReceiptCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxesIncluded;
            let value$4 = value.taxes;
            let value$5 = value.variant;
            return {
              NAME: "SalesReceiptCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: !(value$3 == null) ? value$3 : undefined,
                taxes: value$4.map(value => ({
                  __typename: value.__typename,
                  rate: value.rate,
                  ratio: value.ratio
                })),
                variant: !(value$5 == null) ? parse(value$5) : undefined
              }
            };
          case "SalesReceiptItem":
            let value$6 = value.capacityUnit;
            let value$7 = value.capacityPrecision;
            let value$8 = value.taxesIncluded;
            let value$9 = value.taxes;
            let value$10 = value.variant;
            return {
              NAME: "SalesReceiptItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$6 == null) ? value$6 : undefined,
                capacityPrecision: !(value$7 == null) ? value$7 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: !(value$8 == null) ? value$8 : undefined,
                taxes: value$9.map(value => ({
                  __typename: value.__typename,
                  rate: value.rate
                })),
                variant: !(value$10 == null) ? parse(value$10) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      discounts: value$19.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "SalesReceiptFooterDiscount":
            let value$1 = value.valueType;
            let tmp;
            switch (value$1) {
              case "Currency":
                tmp = "Currency";
                break;
              case "Percentage":
                tmp = "Percentage";
                break;
              default:
                tmp = {
                  NAME: "FutureAddedValue",
                  VAL: value$1
                };
            }
            return {
              NAME: "SalesReceiptFooterDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                value: value.value,
                valueType: tmp,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          case "SalesReceiptItemDiscount":
            let value$2 = value.appliedTo;
            let value$3 = value.valueType;
            let tmp$1;
            switch (value$3) {
              case "Currency":
                tmp$1 = "Currency";
                break;
              case "Percentage":
                tmp$1 = "Percentage";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$3
                };
            }
            return {
              NAME: "SalesReceiptItemDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                appliedTo: value$2.map(value => value),
                value: value.value,
                valueType: tmp$1,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      taxes: value$20.map(value => ({
        __typename: value.__typename,
        rate: value.rate,
        baseAmount: value.baseAmount,
        taxAmount: value.taxAmount
      }))
    }
  };
}
function serialize$2(value) {
  let value$1 = value.salesReceipt;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: value$2,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.discounts;
  let discounts = value$3.map(value => {
    if (value.NAME === "SalesReceiptFooterDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.name;
      let value$7 = value$1.id;
      return {
        __typename: "SalesReceiptFooterDiscount",
        id: value$7,
        name: value$6,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$8 = value.VAL;
    let value$9 = value$8.totalAmountExcludingTaxes;
    let value$10 = value$8.totalAmountIncludingTaxes;
    let value$11 = value$8.valueType;
    let valueType$1 = typeof value$11 === "object" ? value$11.VAL : value$11 === "Currency" ? "Currency" : "Percentage";
    let value$12 = value$8.value;
    let value$13 = value$8.appliedTo;
    let appliedTo = value$13.map(value => value);
    let value$14 = value$8.name;
    let value$15 = value$8.id;
    return {
      __typename: "SalesReceiptItemDiscount",
      id: value$15,
      name: value$14,
      appliedTo: appliedTo,
      value: value$12,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$10,
      totalAmountExcludingTaxes: value$9
    };
  });
  let value$4 = value$1.items;
  let items = value$4.map(value => {
    if (value.NAME === "SalesReceiptCompoundItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.ratio;
        let value$2 = value.rate;
        let value$3 = value.__typename;
        return {
          __typename: value$3,
          rate: value$2,
          ratio: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let taxesIncluded = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.totalAmountIncludingTaxes;
      let value$6 = value$1.totalAmountExcludingTaxes;
      let value$7 = value$1.totalPrice;
      let value$8 = value$1.price;
      let value$9 = value$1.capacityPrecision;
      let capacityPrecision = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.capacityUnit;
      let capacityUnit = value$10 !== undefined ? value$10 : null;
      let value$11 = value$1.quantity;
      let value$12 = value$1.category;
      let value$13 = value$1.name;
      let value$14 = value$1.id;
      return {
        __typename: "SalesReceiptCompoundItem",
        id: value$14,
        name: value$13,
        category: value$12,
        quantity: value$11,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$8,
        totalPrice: value$7,
        totalAmountExcludingTaxes: value$6,
        totalAmountIncludingTaxes: value$5,
        taxesIncluded: taxesIncluded,
        taxes: taxes,
        variant: variant
      };
    }
    let value$15 = value.VAL;
    let value$16 = value$15.variant;
    let variant$1 = value$16 !== undefined ? serialize(value$16) : null;
    let value$17 = value$15.taxes;
    let taxes$1 = value$17.map(value => {
      let value$1 = value.rate;
      let value$2 = value.__typename;
      return {
        __typename: value$2,
        rate: value$1
      };
    });
    let value$18 = value$15.taxesIncluded;
    let taxesIncluded$1 = value$18 !== undefined ? value$18 : null;
    let value$19 = value$15.totalPrice;
    let value$20 = value$15.price;
    let value$21 = value$15.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$15.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$15.quantity;
    let value$24 = value$15.category;
    let value$25 = value$15.name;
    let value$26 = value$15.id;
    return {
      __typename: "SalesReceiptItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      taxesIncluded: taxesIncluded$1,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$5 = value$1.device;
  let value$6 = value$5.slug;
  let value$7 = value$5.name;
  let value$8 = value$5.id;
  let value$9 = value$5.__typename;
  let device = {
    __typename: value$9,
    id: value$8,
    name: value$7,
    slug: value$6
  };
  let value$10 = value$1.staff;
  let value$11 = value$10.name;
  let value$12 = value$10.id;
  let value$13 = value$10.__typename;
  let staff = {
    __typename: value$13,
    id: value$12,
    name: value$11
  };
  let value$14 = value$1.shop;
  let value$15 = value$14.name;
  let value$16 = value$14.id;
  let value$17 = value$14.__typename;
  let shop = {
    __typename: value$17,
    id: value$16,
    name: value$15
  };
  let value$18 = value$1.price;
  let price;
  if (value$18 !== undefined) {
    let value$19 = value$18.name;
    let value$20 = value$18.id;
    let value$21 = value$18.__typename;
    price = {
      __typename: value$21,
      id: value$20,
      name: value$19
    };
  } else {
    price = null;
  }
  let value$22 = value$1.taxesIncluded;
  let value$23 = value$1.customer;
  let customer;
  if (value$23 !== undefined) {
    let value$24 = value$23.hasSubscribedToLoyaltyProgram;
    let value$25 = value$23.kind;
    let kind = value$25 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$26 = value$23.locations;
    let locations = value$26.map(value => {
      let value$1 = value.country;
      let country = value$1 !== undefined ? value$1 : null;
      let value$2 = value.postalCode;
      let postalCode = value$2 !== undefined ? value$2 : null;
      let value$3 = value.city;
      let city = value$3 !== undefined ? value$3 : null;
      let value$4 = value.address;
      let address = value$4 !== undefined ? value$4 : null;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        address: address,
        city: city,
        postalCode: postalCode,
        country: country
      };
    });
    let value$27 = value$23.phoneNumber;
    let phoneNumber = value$27 !== undefined ? value$27 : null;
    let value$28 = value$23.intraCommunityVAT;
    let intraCommunityVAT = value$28 !== undefined ? value$28 : null;
    let value$29 = value$23.email;
    let email = value$29 !== undefined ? value$29 : null;
    let value$30 = value$23.companyName;
    let companyName = value$30 !== undefined ? value$30 : null;
    let value$31 = value$23.lastName;
    let lastName = value$31 !== undefined ? value$31 : null;
    let value$32 = value$23.firstName;
    let firstName = value$32 !== undefined ? value$32 : null;
    let value$33 = value$23.id;
    let value$34 = value$23.__typename;
    customer = {
      __typename: value$34,
      id: value$33,
      firstName: firstName,
      lastName: lastName,
      companyName: companyName,
      email: email,
      intraCommunityVAT: intraCommunityVAT,
      phoneNumber: phoneNumber,
      locations: locations,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$24
    };
  } else {
    customer = null;
  }
  let value$35 = value$1.refundReceipts;
  let refundReceipts = value$35.map(value => {
    let value$1 = value.createdAt;
    let value$2 = Scalar.Datetime.serialize(value$1);
    let value$3 = value.name;
    let value$4 = value.id;
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      id: value$4,
      name: value$3,
      createdAt: value$2
    };
  });
  let value$36 = value$1.invoice;
  let invoice;
  if (value$36 !== undefined) {
    let value$37 = value$36.createdAt;
    let value$38 = Scalar.Datetime.serialize(value$37);
    let value$39 = value$36.name;
    let value$40 = value$36.id;
    let value$41 = value$36.__typename;
    invoice = {
      __typename: value$41,
      id: value$40,
      name: value$39,
      createdAt: value$38
    };
  } else {
    invoice = null;
  }
  let value$42 = value$1.payments;
  let payments = value$42.map(value => {
    let value$1 = value.amountReturned;
    let value$2 = value.amountReceived;
    let value$3 = value.method;
    let method_ = value$3 === "LESHABITUES" ? "LESHABITUES" : value$3 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$3 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$3 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$3 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$3 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$3 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$3 === "CHEQUE" ? "CHEQUE" : value$3 === "LYDIA" ? "LYDIA" : value$3 === "DEBIT_CARD" ? "DEBIT_CARD" : value$3 === "EUSKO_CASH" ? "EUSKO_CASH" : value$3 === "BARNABY" ? "BARNABY" : value$3 === "PAYPAL" ? "PAYPAL" : value$3 === "AMEX" ? "AMEX" : value$3 === "CASH" ? "CASH" : value$3 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$3 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$3 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
    let value$4 = value.id;
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      id: value$4,
      method: method_,
      amountReceived: value$2,
      amountReturned: value$1
    };
  });
  let value$43 = value$1.createdAt;
  let value$44 = Scalar.Datetime.serialize(value$43);
  let value$45 = value$1.totalAmountExcludingTaxes;
  let value$46 = value$1.totalAmountIncludingTaxes;
  let value$47 = value$1.name;
  let value$48 = value$1.id;
  let value$49 = value$1.__typename;
  let salesReceipt = {
    __typename: value$49,
    id: value$48,
    name: value$47,
    totalAmountIncludingTaxes: value$46,
    totalAmountExcludingTaxes: value$45,
    createdAt: value$44,
    payments: payments,
    invoice: invoice,
    refundReceipts: refundReceipts,
    customer: customer,
    taxesIncluded: value$22,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    discounts: discounts,
    taxes: taxes
  };
  return {
    salesReceipt: salesReceipt
  };
}
function serializeVariables$1(inp) {
  return {
    receiptId: inp.receiptId
  };
}
function makeVariables$1(receiptId, param) {
  return {
    receiptId: receiptId
  };
}
let SalesDetailsReceiptQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let SalesDetailsReceiptQuery_refetchQueryDescription = include$1.refetchQueryDescription;
let SalesDetailsReceiptQuery_useLazy = include$1.useLazy;
let SalesDetailsReceiptQuery_useLazyWithVariables = include$1.useLazyWithVariables;
let SalesDetailsReceiptQuery = {
  SalesDetailsReceiptQuery_inner: SalesDetailsReceiptQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: SalesDetailsReceiptQuery_refetchQueryDescription,
  use: use$1,
  useLazy: SalesDetailsReceiptQuery_useLazy,
  useLazyWithVariables: SalesDetailsReceiptQuery_useLazyWithVariables
};
let Raw$3 = {};
let query$3 = Client.gql(["query SalesDetailsCreditNoteQuery($creditNoteId: ID!)  {\ncreditNote(id: $creditNoteId)  {\n__typename  \nid  \nname  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ncreatedAt  \nparentInvoice  {\n__typename  \nid  \nname  \nissueDate  \n}\n\ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\nnote  \ntaxesIncluded  \nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on CreditNoteItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on CreditNoteCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\ndiscounts  {\n__typename\n...on CreditNoteItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on CreditNoteFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", ""], query);
function parse$3(value) {
  let value$1 = value.creditNote;
  let value$2 = value$1.parentInvoice;
  let value$3 = value$1.customerAddress;
  let value$4 = value$1.customerCity;
  let value$5 = value$1.customerPostalCode;
  let value$6 = value$1.customerCountry;
  let value$7 = value$1.customerEmail;
  let value$8 = value$1.customerIntraCommunityVAT;
  let value$9 = value$1.customerPhoneNumber;
  let value$10 = value$1.customer;
  let tmp;
  if (value$10 == null) {
    tmp = undefined;
  } else {
    let value$11 = value$10.kind;
    let tmp$1;
    switch (value$11) {
      case "BUSINESS":
        tmp$1 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$1 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = {
      __typename: value$10.__typename,
      id: value$10.id,
      kind: tmp$1,
      hasSubscribedToLoyaltyProgram: value$10.hasSubscribedToLoyaltyProgram
    };
  }
  let value$12 = value$1.note;
  let value$13 = value$1.price;
  let value$14 = value$1.shop;
  let value$15 = value$1.staff;
  let value$16 = value$1.device;
  let value$17 = value$1.items;
  let value$18 = value$1.discounts;
  let value$19 = value$1.taxes;
  return {
    creditNote: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      parentInvoice: !(value$2 == null) ? {
        __typename: value$2.__typename,
        id: value$2.id,
        name: value$2.name,
        issueDate: Scalar.Datetime.parse(value$2.issueDate)
      } : undefined,
      customerName: value$1.customerName,
      customerAddress: !(value$3 == null) ? value$3 : undefined,
      customerCity: !(value$4 == null) ? value$4 : undefined,
      customerPostalCode: !(value$5 == null) ? value$5 : undefined,
      customerCountry: !(value$6 == null) ? value$6 : undefined,
      customerEmail: !(value$7 == null) ? value$7 : undefined,
      customerIntraCommunityVAT: !(value$8 == null) ? value$8 : undefined,
      customerPhoneNumber: !(value$9 == null) ? value$9 : undefined,
      customer: tmp,
      note: !(value$12 == null) ? value$12 : undefined,
      taxesIncluded: value$1.taxesIncluded,
      price: !(value$13 == null) ? {
        __typename: value$13.__typename,
        id: value$13.id,
        name: value$13.name
      } : undefined,
      shop: {
        __typename: value$14.__typename,
        id: value$14.id,
        name: value$14.name
      },
      staff: !(value$15 == null) ? {
        __typename: value$15.__typename,
        id: value$15.id,
        name: value$15.name
      } : undefined,
      device: {
        __typename: value$16.__typename,
        id: value$16.id,
        name: value$16.name,
        slug: value$16.slug
      },
      items: value$17.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "CreditNoteCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxes;
            let value$4 = value.variant;
            return {
              NAME: "CreditNoteCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: value.taxesIncluded,
                taxes: value$3.map(value => ({
                  __typename: value.__typename,
                  name: value.name,
                  ratio: value.ratio
                })),
                variant: !(value$4 == null) ? parse(value$4) : undefined
              }
            };
          case "CreditNoteItem":
            let value$5 = value.capacityUnit;
            let value$6 = value.capacityPrecision;
            let value$7 = value.taxes;
            let value$8 = value.variant;
            return {
              NAME: "CreditNoteItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$5 == null) ? value$5 : undefined,
                capacityPrecision: !(value$6 == null) ? value$6 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: value.taxesIncluded,
                taxes: value$7.map(value => ({
                  __typename: value.__typename,
                  name: value.name
                })),
                variant: !(value$8 == null) ? parse(value$8) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      discounts: value$18.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "CreditNoteFooterDiscount":
            let value$1 = value.valueType;
            let tmp;
            switch (value$1) {
              case "Currency":
                tmp = "Currency";
                break;
              case "Percentage":
                tmp = "Percentage";
                break;
              default:
                tmp = {
                  NAME: "FutureAddedValue",
                  VAL: value$1
                };
            }
            return {
              NAME: "CreditNoteFooterDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                value: value.value,
                valueType: tmp,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          case "CreditNoteItemDiscount":
            let value$2 = value.appliedTo;
            let value$3 = value.valueType;
            let tmp$1;
            switch (value$3) {
              case "Currency":
                tmp$1 = "Currency";
                break;
              case "Percentage":
                tmp$1 = "Percentage";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$3
                };
            }
            return {
              NAME: "CreditNoteItemDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                appliedTo: value$2.map(value => value),
                value: value.value,
                valueType: tmp$1,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      taxes: value$19.map(value => {
        let value$1 = value.baseAmount;
        return {
          __typename: value.__typename,
          rate: value.rate,
          baseAmount: !(value$1 == null) ? value$1 : undefined,
          taxAmount: value.taxAmount
        };
      })
    }
  };
}
function serialize$3(value) {
  let value$1 = value.creditNote;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let baseAmount = value$2 !== undefined ? value$2 : null;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: baseAmount,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.discounts;
  let discounts = value$3.map(value => {
    if (value.NAME === "CreditNoteItemDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.appliedTo;
      let appliedTo = value$6.map(value => value);
      let value$7 = value$1.name;
      let value$8 = value$1.id;
      return {
        __typename: "CreditNoteItemDiscount",
        id: value$8,
        name: value$7,
        appliedTo: appliedTo,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$9 = value.VAL;
    let value$10 = value$9.totalAmountExcludingTaxes;
    let value$11 = value$9.totalAmountIncludingTaxes;
    let value$12 = value$9.valueType;
    let valueType$1 = typeof value$12 === "object" ? value$12.VAL : value$12 === "Currency" ? "Currency" : "Percentage";
    let value$13 = value$9.value;
    let value$14 = value$9.name;
    let value$15 = value$9.id;
    return {
      __typename: "CreditNoteFooterDiscount",
      id: value$15,
      name: value$14,
      value: value$13,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$11,
      totalAmountExcludingTaxes: value$10
    };
  });
  let value$4 = value$1.items;
  let items = value$4.map(value => {
    if (value.NAME === "CreditNoteCompoundItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.ratio;
        let value$2 = value.name;
        let value$3 = value.__typename;
        return {
          __typename: value$3,
          name: value$2,
          ratio: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let value$5 = value$1.totalAmountIncludingTaxes;
      let value$6 = value$1.totalAmountExcludingTaxes;
      let value$7 = value$1.totalPrice;
      let value$8 = value$1.price;
      let value$9 = value$1.capacityPrecision;
      let capacityPrecision = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.capacityUnit;
      let capacityUnit = value$10 !== undefined ? value$10 : null;
      let value$11 = value$1.quantity;
      let value$12 = value$1.category;
      let value$13 = value$1.name;
      let value$14 = value$1.id;
      return {
        __typename: "CreditNoteCompoundItem",
        id: value$14,
        name: value$13,
        category: value$12,
        quantity: value$11,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$8,
        totalPrice: value$7,
        totalAmountExcludingTaxes: value$6,
        totalAmountIncludingTaxes: value$5,
        taxesIncluded: value$4,
        taxes: taxes,
        variant: variant
      };
    }
    let value$15 = value.VAL;
    let value$16 = value$15.variant;
    let variant$1 = value$16 !== undefined ? serialize(value$16) : null;
    let value$17 = value$15.taxes;
    let taxes$1 = value$17.map(value => {
      let value$1 = value.name;
      let value$2 = value.__typename;
      return {
        __typename: value$2,
        name: value$1
      };
    });
    let value$18 = value$15.taxesIncluded;
    let value$19 = value$15.totalPrice;
    let value$20 = value$15.price;
    let value$21 = value$15.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$15.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$15.quantity;
    let value$24 = value$15.category;
    let value$25 = value$15.name;
    let value$26 = value$15.id;
    return {
      __typename: "CreditNoteItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      taxesIncluded: value$18,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$5 = value$1.device;
  let value$6 = value$5.slug;
  let value$7 = value$5.name;
  let value$8 = value$5.id;
  let value$9 = value$5.__typename;
  let device = {
    __typename: value$9,
    id: value$8,
    name: value$7,
    slug: value$6
  };
  let value$10 = value$1.staff;
  let staff;
  if (value$10 !== undefined) {
    let value$11 = value$10.name;
    let value$12 = value$10.id;
    let value$13 = value$10.__typename;
    staff = {
      __typename: value$13,
      id: value$12,
      name: value$11
    };
  } else {
    staff = null;
  }
  let value$14 = value$1.shop;
  let value$15 = value$14.name;
  let value$16 = value$14.id;
  let value$17 = value$14.__typename;
  let shop = {
    __typename: value$17,
    id: value$16,
    name: value$15
  };
  let value$18 = value$1.price;
  let price;
  if (value$18 !== undefined) {
    let value$19 = value$18.name;
    let value$20 = value$18.id;
    let value$21 = value$18.__typename;
    price = {
      __typename: value$21,
      id: value$20,
      name: value$19
    };
  } else {
    price = null;
  }
  let value$22 = value$1.taxesIncluded;
  let value$23 = value$1.note;
  let note = value$23 !== undefined ? value$23 : null;
  let value$24 = value$1.customer;
  let customer;
  if (value$24 !== undefined) {
    let value$25 = value$24.hasSubscribedToLoyaltyProgram;
    let value$26 = value$24.kind;
    let kind = value$26 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$27 = value$24.id;
    let value$28 = value$24.__typename;
    customer = {
      __typename: value$28,
      id: value$27,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$25
    };
  } else {
    customer = null;
  }
  let value$29 = value$1.customerPhoneNumber;
  let customerPhoneNumber = value$29 !== undefined ? value$29 : null;
  let value$30 = value$1.customerIntraCommunityVAT;
  let customerIntraCommunityVAT = value$30 !== undefined ? value$30 : null;
  let value$31 = value$1.customerEmail;
  let customerEmail = value$31 !== undefined ? value$31 : null;
  let value$32 = value$1.customerCountry;
  let customerCountry = value$32 !== undefined ? value$32 : null;
  let value$33 = value$1.customerPostalCode;
  let customerPostalCode = value$33 !== undefined ? value$33 : null;
  let value$34 = value$1.customerCity;
  let customerCity = value$34 !== undefined ? value$34 : null;
  let value$35 = value$1.customerAddress;
  let customerAddress = value$35 !== undefined ? value$35 : null;
  let value$36 = value$1.customerName;
  let value$37 = value$1.parentInvoice;
  let parentInvoice;
  if (value$37 !== undefined) {
    let value$38 = value$37.issueDate;
    let value$39 = Scalar.Datetime.serialize(value$38);
    let value$40 = value$37.name;
    let value$41 = value$37.id;
    let value$42 = value$37.__typename;
    parentInvoice = {
      __typename: value$42,
      id: value$41,
      name: value$40,
      issueDate: value$39
    };
  } else {
    parentInvoice = null;
  }
  let value$43 = value$1.createdAt;
  let value$44 = Scalar.Datetime.serialize(value$43);
  let value$45 = value$1.totalAmountExcludingTaxes;
  let value$46 = value$1.totalAmountIncludingTaxes;
  let value$47 = value$1.name;
  let value$48 = value$1.id;
  let value$49 = value$1.__typename;
  let creditNote = {
    __typename: value$49,
    id: value$48,
    name: value$47,
    totalAmountIncludingTaxes: value$46,
    totalAmountExcludingTaxes: value$45,
    createdAt: value$44,
    parentInvoice: parentInvoice,
    customerName: value$36,
    customerAddress: customerAddress,
    customerCity: customerCity,
    customerPostalCode: customerPostalCode,
    customerCountry: customerCountry,
    customerEmail: customerEmail,
    customerIntraCommunityVAT: customerIntraCommunityVAT,
    customerPhoneNumber: customerPhoneNumber,
    customer: customer,
    note: note,
    taxesIncluded: value$22,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    discounts: discounts,
    taxes: taxes
  };
  return {
    creditNote: creditNote
  };
}
function serializeVariables$2(inp) {
  return {
    creditNoteId: inp.creditNoteId
  };
}
function makeVariables$2(creditNoteId, param) {
  return {
    creditNoteId: creditNoteId
  };
}
let SalesDetailsCreditNoteQuery_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};
let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2
});
let use$2 = include$2.use;
let SalesDetailsCreditNoteQuery_refetchQueryDescription = include$2.refetchQueryDescription;
let SalesDetailsCreditNoteQuery_useLazy = include$2.useLazy;
let SalesDetailsCreditNoteQuery_useLazyWithVariables = include$2.useLazyWithVariables;
let SalesDetailsCreditNoteQuery = {
  SalesDetailsCreditNoteQuery_inner: SalesDetailsCreditNoteQuery_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  refetchQueryDescription: SalesDetailsCreditNoteQuery_refetchQueryDescription,
  use: use$2,
  useLazy: SalesDetailsCreditNoteQuery_useLazy,
  useLazyWithVariables: SalesDetailsCreditNoteQuery_useLazyWithVariables
};
let Raw$4 = {};
let query$4 = Client.gql(["query SalesDetailsRefundReceiptQuery($refundReceiptId: ID!)  {\nrefundReceipt(id: $refundReceiptId)  {\n__typename  \nid  \nname  \nreason  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ncreatedAt  \npayments  {\n__typename  \nid  \nmethod  \namountReceived  \namountReturned  \n}\n\ncustomer  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nemail  \nintraCommunityVAT  \nphoneNumber  \nlocations  {\n__typename  \naddress  \ncity  \npostalCode  \ncountry  \n}\n\nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on RefundReceiptItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on RefundReceiptCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\nsalesReceipt  {\n__typename  \nid  \nname  \ncreatedAt  \ntaxesIncluded  \ndiscounts  {\n__typename\n...on SalesReceiptItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on SalesReceiptFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", ""], query);
function parse$4(value) {
  let value$1 = value.refundReceipt;
  let value$2 = value$1.reason;
  let tmp;
  switch (value$2) {
    case "CANCELLATION_SALE":
      tmp = "CANCELLATION_SALE";
      break;
    case "CASHING_ERROR":
      tmp = "CASHING_ERROR";
      break;
    case "OTHER_REASON":
      tmp = "OTHER_REASON";
      break;
    case "PRODUCT_NOT_COMPLIANT_OR_DAMAGED":
      tmp = "PRODUCT_NOT_COMPLIANT_OR_DAMAGED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$3 = value$1.payments;
  let value$4 = value$1.customer;
  let tmp$1;
  if (value$4 == null) {
    tmp$1 = undefined;
  } else {
    let value$5 = value$4.firstName;
    let value$6 = value$4.lastName;
    let value$7 = value$4.companyName;
    let value$8 = value$4.email;
    let value$9 = value$4.intraCommunityVAT;
    let value$10 = value$4.phoneNumber;
    let value$11 = value$4.locations;
    let value$12 = value$4.kind;
    let tmp$2;
    switch (value$12) {
      case "BUSINESS":
        tmp$2 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$2 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$1 = {
      __typename: value$4.__typename,
      id: value$4.id,
      firstName: !(value$5 == null) ? value$5 : undefined,
      lastName: !(value$6 == null) ? value$6 : undefined,
      companyName: !(value$7 == null) ? value$7 : undefined,
      email: !(value$8 == null) ? value$8 : undefined,
      intraCommunityVAT: !(value$9 == null) ? value$9 : undefined,
      phoneNumber: !(value$10 == null) ? value$10 : undefined,
      locations: value$11.map(value => {
        let value$1 = value.address;
        let value$2 = value.city;
        let value$3 = value.postalCode;
        let value$4 = value.country;
        return {
          __typename: value.__typename,
          address: !(value$1 == null) ? value$1 : undefined,
          city: !(value$2 == null) ? value$2 : undefined,
          postalCode: !(value$3 == null) ? value$3 : undefined,
          country: !(value$4 == null) ? value$4 : undefined
        };
      }),
      kind: tmp$2,
      hasSubscribedToLoyaltyProgram: value$4.hasSubscribedToLoyaltyProgram
    };
  }
  let value$13 = value$1.price;
  let value$14 = value$1.shop;
  let value$15 = value$1.staff;
  let value$16 = value$1.device;
  let value$17 = value$1.items;
  let value$18 = value$1.salesReceipt;
  let value$19 = value$18.discounts;
  let value$20 = value$1.taxes;
  return {
    refundReceipt: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      reason: tmp,
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      payments: value$3.map(value => {
        let value$1 = value.method;
        let tmp;
        switch (value$1) {
          case "AMEX":
            tmp = "AMEX";
            break;
          case "BANK_TRANSFER":
            tmp = "BANK_TRANSFER";
            break;
          case "BARNABY":
            tmp = "BARNABY";
            break;
          case "CASH":
            tmp = "CASH";
            break;
          case "CHEQUE":
            tmp = "CHEQUE";
            break;
          case "CONTACTLESS_AMEX":
            tmp = "CONTACTLESS_AMEX";
            break;
          case "CONTACTLESS_DEBIT_CARD":
            tmp = "CONTACTLESS_DEBIT_CARD";
            break;
          case "CREDIT_MEMO":
            tmp = "CREDIT_MEMO";
            break;
          case "DEBIT_CARD":
            tmp = "DEBIT_CARD";
            break;
          case "DISTANCE_SELLING":
            tmp = "DISTANCE_SELLING";
            break;
          case "EUSKO_CASH":
            tmp = "EUSKO_CASH";
            break;
          case "EUSKO_DIGITAL":
            tmp = "EUSKO_DIGITAL";
            break;
          case "GIFT_VOUCHER":
            tmp = "GIFT_VOUCHER";
            break;
          case "LESHABITUES":
            tmp = "LESHABITUES";
            break;
          case "LYDIA":
            tmp = "LYDIA";
            break;
          case "PAYPAL":
            tmp = "PAYPAL";
            break;
          case "TICKET_RESTAURANT":
            tmp = "TICKET_RESTAURANT";
            break;
          case "TOWN_HALL_GIFT_VOUCHER":
            tmp = "TOWN_HALL_GIFT_VOUCHER";
            break;
          case "WINO_PAY":
            tmp = "WINO_PAY";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          method: tmp,
          amountReceived: value.amountReceived,
          amountReturned: value.amountReturned
        };
      }),
      customer: tmp$1,
      price: !(value$13 == null) ? {
        __typename: value$13.__typename,
        id: value$13.id,
        name: value$13.name
      } : undefined,
      shop: {
        __typename: value$14.__typename,
        id: value$14.id,
        name: value$14.name
      },
      staff: {
        __typename: value$15.__typename,
        id: value$15.id,
        name: value$15.name
      },
      device: {
        __typename: value$16.__typename,
        id: value$16.id,
        name: value$16.name,
        slug: value$16.slug
      },
      items: value$17.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "RefundReceiptCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxesIncluded;
            let value$4 = value.taxes;
            let value$5 = value.variant;
            return {
              NAME: "RefundReceiptCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: !(value$3 == null) ? value$3 : undefined,
                taxes: value$4.map(value => ({
                  __typename: value.__typename,
                  name: value.name,
                  ratio: value.ratio
                })),
                variant: !(value$5 == null) ? parse(value$5) : undefined
              }
            };
          case "RefundReceiptItem":
            let value$6 = value.capacityUnit;
            let value$7 = value.capacityPrecision;
            let value$8 = value.taxesIncluded;
            let value$9 = value.taxes;
            let value$10 = value.variant;
            return {
              NAME: "RefundReceiptItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$6 == null) ? value$6 : undefined,
                capacityPrecision: !(value$7 == null) ? value$7 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: !(value$8 == null) ? value$8 : undefined,
                taxes: value$9.map(value => ({
                  __typename: value.__typename,
                  name: value.name
                })),
                variant: !(value$10 == null) ? parse(value$10) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      salesReceipt: {
        __typename: value$18.__typename,
        id: value$18.id,
        name: value$18.name,
        createdAt: Scalar.Datetime.parse(value$18.createdAt),
        taxesIncluded: value$18.taxesIncluded,
        discounts: value$19.map(value => {
          let typename = value["__typename"];
          switch (typename) {
            case "SalesReceiptFooterDiscount":
              let value$1 = value.valueType;
              let tmp;
              switch (value$1) {
                case "Currency":
                  tmp = "Currency";
                  break;
                case "Percentage":
                  tmp = "Percentage";
                  break;
                default:
                  tmp = {
                    NAME: "FutureAddedValue",
                    VAL: value$1
                  };
              }
              return {
                NAME: "SalesReceiptFooterDiscount",
                VAL: {
                  __typename: value.__typename,
                  id: value.id,
                  name: value.name,
                  value: value.value,
                  valueType: tmp,
                  totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                  totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
                }
              };
            case "SalesReceiptItemDiscount":
              let value$2 = value.appliedTo;
              let value$3 = value.valueType;
              let tmp$1;
              switch (value$3) {
                case "Currency":
                  tmp$1 = "Currency";
                  break;
                case "Percentage":
                  tmp$1 = "Percentage";
                  break;
                default:
                  tmp$1 = {
                    NAME: "FutureAddedValue",
                    VAL: value$3
                  };
              }
              return {
                NAME: "SalesReceiptItemDiscount",
                VAL: {
                  __typename: value.__typename,
                  id: value.id,
                  name: value.name,
                  appliedTo: value$2.map(value => value),
                  value: value.value,
                  valueType: tmp$1,
                  totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                  totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
                }
              };
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
        })
      },
      taxes: value$20.map(value => {
        let value$1 = value.baseAmount;
        return {
          __typename: value.__typename,
          rate: value.rate,
          baseAmount: !(value$1 == null) ? value$1 : undefined,
          taxAmount: value.taxAmount
        };
      })
    }
  };
}
function serialize$4(value) {
  let value$1 = value.refundReceipt;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let baseAmount = value$2 !== undefined ? value$2 : null;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: baseAmount,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.salesReceipt;
  let value$4 = value$3.discounts;
  let discounts = value$4.map(value => {
    if (value.NAME === "SalesReceiptFooterDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.name;
      let value$7 = value$1.id;
      return {
        __typename: "SalesReceiptFooterDiscount",
        id: value$7,
        name: value$6,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$8 = value.VAL;
    let value$9 = value$8.totalAmountExcludingTaxes;
    let value$10 = value$8.totalAmountIncludingTaxes;
    let value$11 = value$8.valueType;
    let valueType$1 = typeof value$11 === "object" ? value$11.VAL : value$11 === "Currency" ? "Currency" : "Percentage";
    let value$12 = value$8.value;
    let value$13 = value$8.appliedTo;
    let appliedTo = value$13.map(value => value);
    let value$14 = value$8.name;
    let value$15 = value$8.id;
    return {
      __typename: "SalesReceiptItemDiscount",
      id: value$15,
      name: value$14,
      appliedTo: appliedTo,
      value: value$12,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$10,
      totalAmountExcludingTaxes: value$9
    };
  });
  let value$5 = value$3.taxesIncluded;
  let value$6 = value$3.createdAt;
  let value$7 = Scalar.Datetime.serialize(value$6);
  let value$8 = value$3.name;
  let value$9 = value$3.id;
  let value$10 = value$3.__typename;
  let salesReceipt = {
    __typename: value$10,
    id: value$9,
    name: value$8,
    createdAt: value$7,
    taxesIncluded: value$5,
    discounts: discounts
  };
  let value$11 = value$1.items;
  let items = value$11.map(value => {
    if (value.NAME === "RefundReceiptItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.name;
        let value$2 = value.__typename;
        return {
          __typename: value$2,
          name: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let taxesIncluded = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.totalPrice;
      let value$6 = value$1.price;
      let value$7 = value$1.capacityPrecision;
      let capacityPrecision = value$7 !== undefined ? value$7 : null;
      let value$8 = value$1.capacityUnit;
      let capacityUnit = value$8 !== undefined ? value$8 : null;
      let value$9 = value$1.quantity;
      let value$10 = value$1.category;
      let value$11 = value$1.name;
      let value$12 = value$1.id;
      return {
        __typename: "RefundReceiptItem",
        id: value$12,
        name: value$11,
        category: value$10,
        quantity: value$9,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$6,
        totalPrice: value$5,
        taxesIncluded: taxesIncluded,
        taxes: taxes,
        variant: variant
      };
    }
    let value$13 = value.VAL;
    let value$14 = value$13.variant;
    let variant$1 = value$14 !== undefined ? serialize(value$14) : null;
    let value$15 = value$13.taxes;
    let taxes$1 = value$15.map(value => {
      let value$1 = value.ratio;
      let value$2 = value.name;
      let value$3 = value.__typename;
      return {
        __typename: value$3,
        name: value$2,
        ratio: value$1
      };
    });
    let value$16 = value$13.taxesIncluded;
    let taxesIncluded$1 = value$16 !== undefined ? value$16 : null;
    let value$17 = value$13.totalAmountIncludingTaxes;
    let value$18 = value$13.totalAmountExcludingTaxes;
    let value$19 = value$13.totalPrice;
    let value$20 = value$13.price;
    let value$21 = value$13.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$13.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$13.quantity;
    let value$24 = value$13.category;
    let value$25 = value$13.name;
    let value$26 = value$13.id;
    return {
      __typename: "RefundReceiptCompoundItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      totalAmountExcludingTaxes: value$18,
      totalAmountIncludingTaxes: value$17,
      taxesIncluded: taxesIncluded$1,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$12 = value$1.device;
  let value$13 = value$12.slug;
  let value$14 = value$12.name;
  let value$15 = value$12.id;
  let value$16 = value$12.__typename;
  let device = {
    __typename: value$16,
    id: value$15,
    name: value$14,
    slug: value$13
  };
  let value$17 = value$1.staff;
  let value$18 = value$17.name;
  let value$19 = value$17.id;
  let value$20 = value$17.__typename;
  let staff = {
    __typename: value$20,
    id: value$19,
    name: value$18
  };
  let value$21 = value$1.shop;
  let value$22 = value$21.name;
  let value$23 = value$21.id;
  let value$24 = value$21.__typename;
  let shop = {
    __typename: value$24,
    id: value$23,
    name: value$22
  };
  let value$25 = value$1.price;
  let price;
  if (value$25 !== undefined) {
    let value$26 = value$25.name;
    let value$27 = value$25.id;
    let value$28 = value$25.__typename;
    price = {
      __typename: value$28,
      id: value$27,
      name: value$26
    };
  } else {
    price = null;
  }
  let value$29 = value$1.customer;
  let customer;
  if (value$29 !== undefined) {
    let value$30 = value$29.hasSubscribedToLoyaltyProgram;
    let value$31 = value$29.kind;
    let kind = value$31 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$32 = value$29.locations;
    let locations = value$32.map(value => {
      let value$1 = value.country;
      let country = value$1 !== undefined ? value$1 : null;
      let value$2 = value.postalCode;
      let postalCode = value$2 !== undefined ? value$2 : null;
      let value$3 = value.city;
      let city = value$3 !== undefined ? value$3 : null;
      let value$4 = value.address;
      let address = value$4 !== undefined ? value$4 : null;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        address: address,
        city: city,
        postalCode: postalCode,
        country: country
      };
    });
    let value$33 = value$29.phoneNumber;
    let phoneNumber = value$33 !== undefined ? value$33 : null;
    let value$34 = value$29.intraCommunityVAT;
    let intraCommunityVAT = value$34 !== undefined ? value$34 : null;
    let value$35 = value$29.email;
    let email = value$35 !== undefined ? value$35 : null;
    let value$36 = value$29.companyName;
    let companyName = value$36 !== undefined ? value$36 : null;
    let value$37 = value$29.lastName;
    let lastName = value$37 !== undefined ? value$37 : null;
    let value$38 = value$29.firstName;
    let firstName = value$38 !== undefined ? value$38 : null;
    let value$39 = value$29.id;
    let value$40 = value$29.__typename;
    customer = {
      __typename: value$40,
      id: value$39,
      firstName: firstName,
      lastName: lastName,
      companyName: companyName,
      email: email,
      intraCommunityVAT: intraCommunityVAT,
      phoneNumber: phoneNumber,
      locations: locations,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$30
    };
  } else {
    customer = null;
  }
  let value$41 = value$1.payments;
  let payments = value$41.map(value => {
    let value$1 = value.amountReturned;
    let value$2 = value.amountReceived;
    let value$3 = value.method;
    let method_ = value$3 === "LESHABITUES" ? "LESHABITUES" : value$3 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$3 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$3 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$3 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$3 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$3 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$3 === "CHEQUE" ? "CHEQUE" : value$3 === "LYDIA" ? "LYDIA" : value$3 === "DEBIT_CARD" ? "DEBIT_CARD" : value$3 === "EUSKO_CASH" ? "EUSKO_CASH" : value$3 === "BARNABY" ? "BARNABY" : value$3 === "PAYPAL" ? "PAYPAL" : value$3 === "AMEX" ? "AMEX" : value$3 === "CASH" ? "CASH" : value$3 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$3 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$3 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
    let value$4 = value.id;
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      id: value$4,
      method: method_,
      amountReceived: value$2,
      amountReturned: value$1
    };
  });
  let value$42 = value$1.createdAt;
  let value$43 = Scalar.Datetime.serialize(value$42);
  let value$44 = value$1.totalAmountExcludingTaxes;
  let value$45 = value$1.totalAmountIncludingTaxes;
  let value$46 = value$1.reason;
  let reason = value$46 === "OTHER_REASON" ? "OTHER_REASON" : value$46 === "PRODUCT_NOT_COMPLIANT_OR_DAMAGED" ? "PRODUCT_NOT_COMPLIANT_OR_DAMAGED" : value$46 === "CANCELLATION_SALE" ? "CANCELLATION_SALE" : "CASHING_ERROR";
  let value$47 = value$1.name;
  let value$48 = value$1.id;
  let value$49 = value$1.__typename;
  let refundReceipt = {
    __typename: value$49,
    id: value$48,
    name: value$47,
    reason: reason,
    totalAmountIncludingTaxes: value$45,
    totalAmountExcludingTaxes: value$44,
    createdAt: value$43,
    payments: payments,
    customer: customer,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    salesReceipt: salesReceipt,
    taxes: taxes
  };
  return {
    refundReceipt: refundReceipt
  };
}
function serializeVariables$3(inp) {
  return {
    refundReceiptId: inp.refundReceiptId
  };
}
function makeVariables$3(refundReceiptId, param) {
  return {
    refundReceiptId: refundReceiptId
  };
}
let SalesDetailsRefundReceiptQuery_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};
let include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3
});
let use$3 = include$3.use;
let SalesDetailsRefundReceiptQuery_refetchQueryDescription = include$3.refetchQueryDescription;
let SalesDetailsRefundReceiptQuery_useLazy = include$3.useLazy;
let SalesDetailsRefundReceiptQuery_useLazyWithVariables = include$3.useLazyWithVariables;
let SalesDetailsRefundReceiptQuery = {
  SalesDetailsRefundReceiptQuery_inner: SalesDetailsRefundReceiptQuery_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  refetchQueryDescription: SalesDetailsRefundReceiptQuery_refetchQueryDescription,
  use: use$3,
  useLazy: SalesDetailsRefundReceiptQuery_useLazy,
  useLazyWithVariables: SalesDetailsRefundReceiptQuery_useLazyWithVariables
};
let Raw$5 = {};
let query$5 = Client.gql(["query SalesDetailsDeliveryNoteQuery($deliveryNoteId: ID!)  {\ndeliveryNote(id: $deliveryNoteId)  {\n__typename  \nid  \nname  \nnote  \ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \nstatus  \ninvoices  {\n__typename  \nid  \narchivedAt  \nname  \nissueDate  \nstatus  \n}\n\ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on DeliveryNoteItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on DeliveryNoteCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\ndiscounts  {\n__typename\n...on DeliveryNoteItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on DeliveryNoteFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", ""], query);
function parse$5(value) {
  let value$1 = value.deliveryNote;
  let value$2 = value$1.note;
  let value$3 = value$1.customerAddress;
  let value$4 = value$1.customerCity;
  let value$5 = value$1.customerPostalCode;
  let value$6 = value$1.customerCountry;
  let value$7 = value$1.customerEmail;
  let value$8 = value$1.customerIntraCommunityVAT;
  let value$9 = value$1.customerPhoneNumber;
  let value$10 = value$1.customer;
  let tmp;
  if (value$10 == null) {
    tmp = undefined;
  } else {
    let value$11 = value$10.kind;
    let tmp$1;
    switch (value$11) {
      case "BUSINESS":
        tmp$1 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$1 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = {
      __typename: value$10.__typename,
      id: value$10.id,
      kind: tmp$1,
      hasSubscribedToLoyaltyProgram: value$10.hasSubscribedToLoyaltyProgram
    };
  }
  let value$12 = value$1.status;
  let tmp$2;
  switch (value$12) {
    case "DRAFT":
      tmp$2 = "DRAFT";
      break;
    case "PUBLISHED":
      tmp$2 = "PUBLISHED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$13 = value$1.invoices;
  let value$14 = value$1.price;
  let value$15 = value$1.shop;
  let value$16 = value$1.staff;
  let value$17 = value$1.device;
  let value$18 = value$1.items;
  let value$19 = value$1.discounts;
  let value$20 = value$1.taxes;
  return {
    deliveryNote: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      note: !(value$2 == null) ? value$2 : undefined,
      customerName: value$1.customerName,
      customerAddress: !(value$3 == null) ? value$3 : undefined,
      customerCity: !(value$4 == null) ? value$4 : undefined,
      customerPostalCode: !(value$5 == null) ? value$5 : undefined,
      customerCountry: !(value$6 == null) ? value$6 : undefined,
      customerEmail: !(value$7 == null) ? value$7 : undefined,
      customerIntraCommunityVAT: !(value$8 == null) ? value$8 : undefined,
      customerPhoneNumber: !(value$9 == null) ? value$9 : undefined,
      customer: tmp,
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      status: tmp$2,
      invoices: value$13.map(value => {
        let value$1 = value.archivedAt;
        let value$2 = value.status;
        let tmp;
        switch (value$2) {
          case "DRAFT":
            tmp = "DRAFT";
            break;
          case "PAID":
            tmp = "PAID";
            break;
          case "UNPAID":
            tmp = "UNPAID";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
          name: value.name,
          issueDate: Scalar.Datetime.parse(value.issueDate),
          status: tmp
        };
      }),
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      taxesIncluded: value$1.taxesIncluded,
      price: !(value$14 == null) ? {
        __typename: value$14.__typename,
        id: value$14.id,
        name: value$14.name
      } : undefined,
      shop: {
        __typename: value$15.__typename,
        id: value$15.id,
        name: value$15.name
      },
      staff: !(value$16 == null) ? {
        __typename: value$16.__typename,
        id: value$16.id,
        name: value$16.name
      } : undefined,
      device: {
        __typename: value$17.__typename,
        id: value$17.id,
        name: value$17.name,
        slug: value$17.slug
      },
      items: value$18.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "DeliveryNoteCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxes;
            let value$4 = value.variant;
            return {
              NAME: "DeliveryNoteCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: value.taxesIncluded,
                taxes: value$3.map(value => ({
                  __typename: value.__typename,
                  name: value.name,
                  ratio: value.ratio
                })),
                variant: !(value$4 == null) ? parse(value$4) : undefined
              }
            };
          case "DeliveryNoteItem":
            let value$5 = value.capacityUnit;
            let value$6 = value.capacityPrecision;
            let value$7 = value.taxes;
            let value$8 = value.variant;
            return {
              NAME: "DeliveryNoteItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$5 == null) ? value$5 : undefined,
                capacityPrecision: !(value$6 == null) ? value$6 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: value.taxesIncluded,
                taxes: value$7.map(value => ({
                  __typename: value.__typename,
                  name: value.name
                })),
                variant: !(value$8 == null) ? parse(value$8) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      discounts: value$19.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "DeliveryNoteFooterDiscount":
            let value$1 = value.valueType;
            let tmp;
            switch (value$1) {
              case "Currency":
                tmp = "Currency";
                break;
              case "Percentage":
                tmp = "Percentage";
                break;
              default:
                tmp = {
                  NAME: "FutureAddedValue",
                  VAL: value$1
                };
            }
            return {
              NAME: "DeliveryNoteFooterDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                value: value.value,
                valueType: tmp,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          case "DeliveryNoteItemDiscount":
            let value$2 = value.appliedTo;
            let value$3 = value.valueType;
            let tmp$1;
            switch (value$3) {
              case "Currency":
                tmp$1 = "Currency";
                break;
              case "Percentage":
                tmp$1 = "Percentage";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$3
                };
            }
            return {
              NAME: "DeliveryNoteItemDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                appliedTo: value$2.map(value => value),
                value: value.value,
                valueType: tmp$1,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      taxes: value$20.map(value => {
        let value$1 = value.baseAmount;
        return {
          __typename: value.__typename,
          rate: value.rate,
          baseAmount: !(value$1 == null) ? value$1 : undefined,
          taxAmount: value.taxAmount
        };
      })
    }
  };
}
function serialize$5(value) {
  let value$1 = value.deliveryNote;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let baseAmount = value$2 !== undefined ? value$2 : null;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: baseAmount,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.discounts;
  let discounts = value$3.map(value => {
    if (value.NAME === "DeliveryNoteItemDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.appliedTo;
      let appliedTo = value$6.map(value => value);
      let value$7 = value$1.name;
      let value$8 = value$1.id;
      return {
        __typename: "DeliveryNoteItemDiscount",
        id: value$8,
        name: value$7,
        appliedTo: appliedTo,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$9 = value.VAL;
    let value$10 = value$9.totalAmountExcludingTaxes;
    let value$11 = value$9.totalAmountIncludingTaxes;
    let value$12 = value$9.valueType;
    let valueType$1 = typeof value$12 === "object" ? value$12.VAL : value$12 === "Currency" ? "Currency" : "Percentage";
    let value$13 = value$9.value;
    let value$14 = value$9.name;
    let value$15 = value$9.id;
    return {
      __typename: "DeliveryNoteFooterDiscount",
      id: value$15,
      name: value$14,
      value: value$13,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$11,
      totalAmountExcludingTaxes: value$10
    };
  });
  let value$4 = value$1.items;
  let items = value$4.map(value => {
    if (value.NAME === "DeliveryNoteCompoundItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.ratio;
        let value$2 = value.name;
        let value$3 = value.__typename;
        return {
          __typename: value$3,
          name: value$2,
          ratio: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let value$5 = value$1.totalAmountIncludingTaxes;
      let value$6 = value$1.totalAmountExcludingTaxes;
      let value$7 = value$1.totalPrice;
      let value$8 = value$1.price;
      let value$9 = value$1.capacityPrecision;
      let capacityPrecision = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.capacityUnit;
      let capacityUnit = value$10 !== undefined ? value$10 : null;
      let value$11 = value$1.quantity;
      let value$12 = value$1.category;
      let value$13 = value$1.name;
      let value$14 = value$1.id;
      return {
        __typename: "DeliveryNoteCompoundItem",
        id: value$14,
        name: value$13,
        category: value$12,
        quantity: value$11,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$8,
        totalPrice: value$7,
        totalAmountExcludingTaxes: value$6,
        totalAmountIncludingTaxes: value$5,
        taxesIncluded: value$4,
        taxes: taxes,
        variant: variant
      };
    }
    let value$15 = value.VAL;
    let value$16 = value$15.variant;
    let variant$1 = value$16 !== undefined ? serialize(value$16) : null;
    let value$17 = value$15.taxes;
    let taxes$1 = value$17.map(value => {
      let value$1 = value.name;
      let value$2 = value.__typename;
      return {
        __typename: value$2,
        name: value$1
      };
    });
    let value$18 = value$15.taxesIncluded;
    let value$19 = value$15.totalPrice;
    let value$20 = value$15.price;
    let value$21 = value$15.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$15.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$15.quantity;
    let value$24 = value$15.category;
    let value$25 = value$15.name;
    let value$26 = value$15.id;
    return {
      __typename: "DeliveryNoteItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      taxesIncluded: value$18,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$5 = value$1.device;
  let value$6 = value$5.slug;
  let value$7 = value$5.name;
  let value$8 = value$5.id;
  let value$9 = value$5.__typename;
  let device = {
    __typename: value$9,
    id: value$8,
    name: value$7,
    slug: value$6
  };
  let value$10 = value$1.staff;
  let staff;
  if (value$10 !== undefined) {
    let value$11 = value$10.name;
    let value$12 = value$10.id;
    let value$13 = value$10.__typename;
    staff = {
      __typename: value$13,
      id: value$12,
      name: value$11
    };
  } else {
    staff = null;
  }
  let value$14 = value$1.shop;
  let value$15 = value$14.name;
  let value$16 = value$14.id;
  let value$17 = value$14.__typename;
  let shop = {
    __typename: value$17,
    id: value$16,
    name: value$15
  };
  let value$18 = value$1.price;
  let price;
  if (value$18 !== undefined) {
    let value$19 = value$18.name;
    let value$20 = value$18.id;
    let value$21 = value$18.__typename;
    price = {
      __typename: value$21,
      id: value$20,
      name: value$19
    };
  } else {
    price = null;
  }
  let value$22 = value$1.taxesIncluded;
  let value$23 = value$1.totalAmountExcludingTaxes;
  let value$24 = value$1.totalAmountIncludingTaxes;
  let value$25 = value$1.invoices;
  let invoices = value$25.map(value => {
    let value$1 = value.status;
    let status = value$1 === "UNPAID" ? "UNPAID" : value$1 === "PAID" ? "PAID" : "DRAFT";
    let value$2 = value.issueDate;
    let value$3 = Scalar.Datetime.serialize(value$2);
    let value$4 = value.name;
    let value$5 = value.archivedAt;
    let archivedAt = value$5 !== undefined ? Scalar.Datetime.serialize(value$5) : null;
    let value$6 = value.id;
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      id: value$6,
      archivedAt: archivedAt,
      name: value$4,
      issueDate: value$3,
      status: status
    };
  });
  let value$26 = value$1.status;
  let status = value$26 === "DRAFT" ? "DRAFT" : "PUBLISHED";
  let value$27 = value$1.createdAt;
  let value$28 = Scalar.Datetime.serialize(value$27);
  let value$29 = value$1.customer;
  let customer;
  if (value$29 !== undefined) {
    let value$30 = value$29.hasSubscribedToLoyaltyProgram;
    let value$31 = value$29.kind;
    let kind = value$31 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$32 = value$29.id;
    let value$33 = value$29.__typename;
    customer = {
      __typename: value$33,
      id: value$32,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$30
    };
  } else {
    customer = null;
  }
  let value$34 = value$1.customerPhoneNumber;
  let customerPhoneNumber = value$34 !== undefined ? value$34 : null;
  let value$35 = value$1.customerIntraCommunityVAT;
  let customerIntraCommunityVAT = value$35 !== undefined ? value$35 : null;
  let value$36 = value$1.customerEmail;
  let customerEmail = value$36 !== undefined ? value$36 : null;
  let value$37 = value$1.customerCountry;
  let customerCountry = value$37 !== undefined ? value$37 : null;
  let value$38 = value$1.customerPostalCode;
  let customerPostalCode = value$38 !== undefined ? value$38 : null;
  let value$39 = value$1.customerCity;
  let customerCity = value$39 !== undefined ? value$39 : null;
  let value$40 = value$1.customerAddress;
  let customerAddress = value$40 !== undefined ? value$40 : null;
  let value$41 = value$1.customerName;
  let value$42 = value$1.note;
  let note = value$42 !== undefined ? value$42 : null;
  let value$43 = value$1.name;
  let value$44 = value$1.id;
  let value$45 = value$1.__typename;
  let deliveryNote = {
    __typename: value$45,
    id: value$44,
    name: value$43,
    note: note,
    customerName: value$41,
    customerAddress: customerAddress,
    customerCity: customerCity,
    customerPostalCode: customerPostalCode,
    customerCountry: customerCountry,
    customerEmail: customerEmail,
    customerIntraCommunityVAT: customerIntraCommunityVAT,
    customerPhoneNumber: customerPhoneNumber,
    customer: customer,
    createdAt: value$28,
    status: status,
    invoices: invoices,
    totalAmountIncludingTaxes: value$24,
    totalAmountExcludingTaxes: value$23,
    taxesIncluded: value$22,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    discounts: discounts,
    taxes: taxes
  };
  return {
    deliveryNote: deliveryNote
  };
}
function serializeVariables$4(inp) {
  return {
    deliveryNoteId: inp.deliveryNoteId
  };
}
function makeVariables$4(deliveryNoteId, param) {
  return {
    deliveryNoteId: deliveryNoteId
  };
}
let SalesDetailsDeliveryNoteQuery_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4
};
let include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$5,
  Raw: Raw$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4
});
let use$4 = include$4.use;
let SalesDetailsDeliveryNoteQuery_refetchQueryDescription = include$4.refetchQueryDescription;
let SalesDetailsDeliveryNoteQuery_useLazy = include$4.useLazy;
let SalesDetailsDeliveryNoteQuery_useLazyWithVariables = include$4.useLazyWithVariables;
let SalesDetailsDeliveryNoteQuery = {
  SalesDetailsDeliveryNoteQuery_inner: SalesDetailsDeliveryNoteQuery_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  refetchQueryDescription: SalesDetailsDeliveryNoteQuery_refetchQueryDescription,
  use: use$4,
  useLazy: SalesDetailsDeliveryNoteQuery_useLazy,
  useLazyWithVariables: SalesDetailsDeliveryNoteQuery_useLazyWithVariables
};
let Raw$6 = {};
let query$6 = Client.gql(["query SalesDetailsQuoteQuery($quoteId: ID!)  {\nquote(id: $quoteId)  {\n__typename  \nid  \nname  \nnote  \ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \nstatus  \ninvoices  {\n__typename  \nid  \narchivedAt  \nname  \nissueDate  \nstatus  \n}\n\ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \nprice  {\n__typename  \nid  \nname  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nitems  {\n__typename\n...on QuoteItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n...on QuoteCompoundItem   {\n__typename  \nid  \nname  \ncategory  \nquantity  \ncapacityUnit  \ncapacityPrecision  \nprice  \ntotalPrice  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntaxesIncluded  \ntaxes  {\n__typename  \nname  \nratio  \n}\n\nvariant  {\n...SalesVariantFragment   \n}\n\n}\n\n}\n\ndiscounts  {\n__typename\n...on QuoteItemDiscount   {\n__typename  \nid  \nname  \nappliedTo  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n...on QuoteFooterDiscount   {\n__typename  \nid  \nname  \nvalue  \nvalueType  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \n}\n\n}\n\ntaxes  {\n__typename  \nrate  \nbaseAmount  \ntaxAmount  \n}\n\n}\n\n}\n", ""], query);
function parse$6(value) {
  let value$1 = value.quote;
  let value$2 = value$1.note;
  let value$3 = value$1.customerAddress;
  let value$4 = value$1.customerCity;
  let value$5 = value$1.customerPostalCode;
  let value$6 = value$1.customerCountry;
  let value$7 = value$1.customerEmail;
  let value$8 = value$1.customerIntraCommunityVAT;
  let value$9 = value$1.customerPhoneNumber;
  let value$10 = value$1.customer;
  let tmp;
  if (value$10 == null) {
    tmp = undefined;
  } else {
    let value$11 = value$10.kind;
    let tmp$1;
    switch (value$11) {
      case "BUSINESS":
        tmp$1 = "BUSINESS";
        break;
      case "CONSUMER":
        tmp$1 = "CONSUMER";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = {
      __typename: value$10.__typename,
      id: value$10.id,
      kind: tmp$1,
      hasSubscribedToLoyaltyProgram: value$10.hasSubscribedToLoyaltyProgram
    };
  }
  let value$12 = value$1.status;
  let tmp$2;
  switch (value$12) {
    case "ACCEPTED":
      tmp$2 = "ACCEPTED";
      break;
    case "PUBLISHED":
      tmp$2 = "PUBLISHED";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$13 = value$1.invoices;
  let value$14 = value$1.price;
  let value$15 = value$1.shop;
  let value$16 = value$1.staff;
  let value$17 = value$1.device;
  let value$18 = value$1.items;
  let value$19 = value$1.discounts;
  let value$20 = value$1.taxes;
  return {
    quote: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      note: !(value$2 == null) ? value$2 : undefined,
      customerName: value$1.customerName,
      customerAddress: !(value$3 == null) ? value$3 : undefined,
      customerCity: !(value$4 == null) ? value$4 : undefined,
      customerPostalCode: !(value$5 == null) ? value$5 : undefined,
      customerCountry: !(value$6 == null) ? value$6 : undefined,
      customerEmail: !(value$7 == null) ? value$7 : undefined,
      customerIntraCommunityVAT: !(value$8 == null) ? value$8 : undefined,
      customerPhoneNumber: !(value$9 == null) ? value$9 : undefined,
      customer: tmp,
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      status: tmp$2,
      invoices: value$13.map(value => {
        let value$1 = value.archivedAt;
        let value$2 = value.status;
        let tmp;
        switch (value$2) {
          case "DRAFT":
            tmp = "DRAFT";
            break;
          case "PAID":
            tmp = "PAID";
            break;
          case "UNPAID":
            tmp = "UNPAID";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          id: value.id,
          archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
          name: value.name,
          issueDate: Scalar.Datetime.parse(value.issueDate),
          status: tmp
        };
      }),
      totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
      taxesIncluded: value$1.taxesIncluded,
      price: !(value$14 == null) ? {
        __typename: value$14.__typename,
        id: value$14.id,
        name: value$14.name
      } : undefined,
      shop: {
        __typename: value$15.__typename,
        id: value$15.id,
        name: value$15.name
      },
      staff: !(value$16 == null) ? {
        __typename: value$16.__typename,
        id: value$16.id,
        name: value$16.name
      } : undefined,
      device: {
        __typename: value$17.__typename,
        id: value$17.id,
        name: value$17.name,
        slug: value$17.slug
      },
      items: value$18.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "QuoteCompoundItem":
            let value$1 = value.capacityUnit;
            let value$2 = value.capacityPrecision;
            let value$3 = value.taxesIncluded;
            let value$4 = value.taxes;
            let value$5 = value.variant;
            return {
              NAME: "QuoteCompoundItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$1 == null) ? value$1 : undefined,
                capacityPrecision: !(value$2 == null) ? value$2 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                taxesIncluded: !(value$3 == null) ? value$3 : undefined,
                taxes: value$4.map(value => ({
                  __typename: value.__typename,
                  name: value.name,
                  ratio: value.ratio
                })),
                variant: !(value$5 == null) ? parse(value$5) : undefined
              }
            };
          case "QuoteItem":
            let value$6 = value.capacityUnit;
            let value$7 = value.capacityPrecision;
            let value$8 = value.taxesIncluded;
            let value$9 = value.taxes;
            let value$10 = value.variant;
            return {
              NAME: "QuoteItem",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                category: value.category,
                quantity: value.quantity,
                capacityUnit: !(value$6 == null) ? value$6 : undefined,
                capacityPrecision: !(value$7 == null) ? value$7 : undefined,
                price: value.price,
                totalPrice: value.totalPrice,
                taxesIncluded: !(value$8 == null) ? value$8 : undefined,
                taxes: value$9.map(value => ({
                  __typename: value.__typename,
                  name: value.name
                })),
                variant: !(value$10 == null) ? parse(value$10) : undefined
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      discounts: value$19.map(value => {
        let typename = value["__typename"];
        switch (typename) {
          case "QuoteFooterDiscount":
            let value$1 = value.valueType;
            let tmp;
            switch (value$1) {
              case "Currency":
                tmp = "Currency";
                break;
              case "Percentage":
                tmp = "Percentage";
                break;
              default:
                tmp = {
                  NAME: "FutureAddedValue",
                  VAL: value$1
                };
            }
            return {
              NAME: "QuoteFooterDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                value: value.value,
                valueType: tmp,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          case "QuoteItemDiscount":
            let value$2 = value.appliedTo;
            let value$3 = value.valueType;
            let tmp$1;
            switch (value$3) {
              case "Currency":
                tmp$1 = "Currency";
                break;
              case "Percentage":
                tmp$1 = "Percentage";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$3
                };
            }
            return {
              NAME: "QuoteItemDiscount",
              VAL: {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                appliedTo: value$2.map(value => value),
                value: value.value,
                valueType: tmp$1,
                totalAmountIncludingTaxes: value.totalAmountIncludingTaxes,
                totalAmountExcludingTaxes: value.totalAmountExcludingTaxes
              }
            };
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      taxes: value$20.map(value => {
        let value$1 = value.baseAmount;
        return {
          __typename: value.__typename,
          rate: value.rate,
          baseAmount: !(value$1 == null) ? value$1 : undefined,
          taxAmount: value.taxAmount
        };
      })
    }
  };
}
function serialize$6(value) {
  let value$1 = value.quote;
  let value$2 = value$1.taxes;
  let taxes = value$2.map(value => {
    let value$1 = value.taxAmount;
    let value$2 = value.baseAmount;
    let baseAmount = value$2 !== undefined ? value$2 : null;
    let value$3 = value.rate;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      rate: value$3,
      baseAmount: baseAmount,
      taxAmount: value$1
    };
  });
  let value$3 = value$1.discounts;
  let discounts = value$3.map(value => {
    if (value.NAME === "QuoteItemDiscount") {
      let value$1 = value.VAL;
      let value$2 = value$1.totalAmountExcludingTaxes;
      let value$3 = value$1.totalAmountIncludingTaxes;
      let value$4 = value$1.valueType;
      let valueType = typeof value$4 === "object" ? value$4.VAL : value$4 === "Currency" ? "Currency" : "Percentage";
      let value$5 = value$1.value;
      let value$6 = value$1.appliedTo;
      let appliedTo = value$6.map(value => value);
      let value$7 = value$1.name;
      let value$8 = value$1.id;
      return {
        __typename: "QuoteItemDiscount",
        id: value$8,
        name: value$7,
        appliedTo: appliedTo,
        value: value$5,
        valueType: valueType,
        totalAmountIncludingTaxes: value$3,
        totalAmountExcludingTaxes: value$2
      };
    }
    let value$9 = value.VAL;
    let value$10 = value$9.totalAmountExcludingTaxes;
    let value$11 = value$9.totalAmountIncludingTaxes;
    let value$12 = value$9.valueType;
    let valueType$1 = typeof value$12 === "object" ? value$12.VAL : value$12 === "Currency" ? "Currency" : "Percentage";
    let value$13 = value$9.value;
    let value$14 = value$9.name;
    let value$15 = value$9.id;
    return {
      __typename: "QuoteFooterDiscount",
      id: value$15,
      name: value$14,
      value: value$13,
      valueType: valueType$1,
      totalAmountIncludingTaxes: value$11,
      totalAmountExcludingTaxes: value$10
    };
  });
  let value$4 = value$1.items;
  let items = value$4.map(value => {
    if (value.NAME === "QuoteItem") {
      let value$1 = value.VAL;
      let value$2 = value$1.variant;
      let variant = value$2 !== undefined ? serialize(value$2) : null;
      let value$3 = value$1.taxes;
      let taxes = value$3.map(value => {
        let value$1 = value.name;
        let value$2 = value.__typename;
        return {
          __typename: value$2,
          name: value$1
        };
      });
      let value$4 = value$1.taxesIncluded;
      let taxesIncluded = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.totalPrice;
      let value$6 = value$1.price;
      let value$7 = value$1.capacityPrecision;
      let capacityPrecision = value$7 !== undefined ? value$7 : null;
      let value$8 = value$1.capacityUnit;
      let capacityUnit = value$8 !== undefined ? value$8 : null;
      let value$9 = value$1.quantity;
      let value$10 = value$1.category;
      let value$11 = value$1.name;
      let value$12 = value$1.id;
      return {
        __typename: "QuoteItem",
        id: value$12,
        name: value$11,
        category: value$10,
        quantity: value$9,
        capacityUnit: capacityUnit,
        capacityPrecision: capacityPrecision,
        price: value$6,
        totalPrice: value$5,
        taxesIncluded: taxesIncluded,
        taxes: taxes,
        variant: variant
      };
    }
    let value$13 = value.VAL;
    let value$14 = value$13.variant;
    let variant$1 = value$14 !== undefined ? serialize(value$14) : null;
    let value$15 = value$13.taxes;
    let taxes$1 = value$15.map(value => {
      let value$1 = value.ratio;
      let value$2 = value.name;
      let value$3 = value.__typename;
      return {
        __typename: value$3,
        name: value$2,
        ratio: value$1
      };
    });
    let value$16 = value$13.taxesIncluded;
    let taxesIncluded$1 = value$16 !== undefined ? value$16 : null;
    let value$17 = value$13.totalAmountIncludingTaxes;
    let value$18 = value$13.totalAmountExcludingTaxes;
    let value$19 = value$13.totalPrice;
    let value$20 = value$13.price;
    let value$21 = value$13.capacityPrecision;
    let capacityPrecision$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$13.capacityUnit;
    let capacityUnit$1 = value$22 !== undefined ? value$22 : null;
    let value$23 = value$13.quantity;
    let value$24 = value$13.category;
    let value$25 = value$13.name;
    let value$26 = value$13.id;
    return {
      __typename: "QuoteCompoundItem",
      id: value$26,
      name: value$25,
      category: value$24,
      quantity: value$23,
      capacityUnit: capacityUnit$1,
      capacityPrecision: capacityPrecision$1,
      price: value$20,
      totalPrice: value$19,
      totalAmountExcludingTaxes: value$18,
      totalAmountIncludingTaxes: value$17,
      taxesIncluded: taxesIncluded$1,
      taxes: taxes$1,
      variant: variant$1
    };
  });
  let value$5 = value$1.device;
  let value$6 = value$5.slug;
  let value$7 = value$5.name;
  let value$8 = value$5.id;
  let value$9 = value$5.__typename;
  let device = {
    __typename: value$9,
    id: value$8,
    name: value$7,
    slug: value$6
  };
  let value$10 = value$1.staff;
  let staff;
  if (value$10 !== undefined) {
    let value$11 = value$10.name;
    let value$12 = value$10.id;
    let value$13 = value$10.__typename;
    staff = {
      __typename: value$13,
      id: value$12,
      name: value$11
    };
  } else {
    staff = null;
  }
  let value$14 = value$1.shop;
  let value$15 = value$14.name;
  let value$16 = value$14.id;
  let value$17 = value$14.__typename;
  let shop = {
    __typename: value$17,
    id: value$16,
    name: value$15
  };
  let value$18 = value$1.price;
  let price;
  if (value$18 !== undefined) {
    let value$19 = value$18.name;
    let value$20 = value$18.id;
    let value$21 = value$18.__typename;
    price = {
      __typename: value$21,
      id: value$20,
      name: value$19
    };
  } else {
    price = null;
  }
  let value$22 = value$1.taxesIncluded;
  let value$23 = value$1.totalAmountExcludingTaxes;
  let value$24 = value$1.totalAmountIncludingTaxes;
  let value$25 = value$1.invoices;
  let invoices = value$25.map(value => {
    let value$1 = value.status;
    let status = value$1 === "UNPAID" ? "UNPAID" : value$1 === "PAID" ? "PAID" : "DRAFT";
    let value$2 = value.issueDate;
    let value$3 = Scalar.Datetime.serialize(value$2);
    let value$4 = value.name;
    let value$5 = value.archivedAt;
    let archivedAt = value$5 !== undefined ? Scalar.Datetime.serialize(value$5) : null;
    let value$6 = value.id;
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      id: value$6,
      archivedAt: archivedAt,
      name: value$4,
      issueDate: value$3,
      status: status
    };
  });
  let value$26 = value$1.status;
  let status = value$26 === "ACCEPTED" ? "ACCEPTED" : "PUBLISHED";
  let value$27 = value$1.createdAt;
  let value$28 = Scalar.Datetime.serialize(value$27);
  let value$29 = value$1.customer;
  let customer;
  if (value$29 !== undefined) {
    let value$30 = value$29.hasSubscribedToLoyaltyProgram;
    let value$31 = value$29.kind;
    let kind = value$31 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$32 = value$29.id;
    let value$33 = value$29.__typename;
    customer = {
      __typename: value$33,
      id: value$32,
      kind: kind,
      hasSubscribedToLoyaltyProgram: value$30
    };
  } else {
    customer = null;
  }
  let value$34 = value$1.customerPhoneNumber;
  let customerPhoneNumber = value$34 !== undefined ? value$34 : null;
  let value$35 = value$1.customerIntraCommunityVAT;
  let customerIntraCommunityVAT = value$35 !== undefined ? value$35 : null;
  let value$36 = value$1.customerEmail;
  let customerEmail = value$36 !== undefined ? value$36 : null;
  let value$37 = value$1.customerCountry;
  let customerCountry = value$37 !== undefined ? value$37 : null;
  let value$38 = value$1.customerPostalCode;
  let customerPostalCode = value$38 !== undefined ? value$38 : null;
  let value$39 = value$1.customerCity;
  let customerCity = value$39 !== undefined ? value$39 : null;
  let value$40 = value$1.customerAddress;
  let customerAddress = value$40 !== undefined ? value$40 : null;
  let value$41 = value$1.customerName;
  let value$42 = value$1.note;
  let note = value$42 !== undefined ? value$42 : null;
  let value$43 = value$1.name;
  let value$44 = value$1.id;
  let value$45 = value$1.__typename;
  let quote = {
    __typename: value$45,
    id: value$44,
    name: value$43,
    note: note,
    customerName: value$41,
    customerAddress: customerAddress,
    customerCity: customerCity,
    customerPostalCode: customerPostalCode,
    customerCountry: customerCountry,
    customerEmail: customerEmail,
    customerIntraCommunityVAT: customerIntraCommunityVAT,
    customerPhoneNumber: customerPhoneNumber,
    customer: customer,
    createdAt: value$28,
    status: status,
    invoices: invoices,
    totalAmountIncludingTaxes: value$24,
    totalAmountExcludingTaxes: value$23,
    taxesIncluded: value$22,
    price: price,
    shop: shop,
    staff: staff,
    device: device,
    items: items,
    discounts: discounts,
    taxes: taxes
  };
  return {
    quote: quote
  };
}
function serializeVariables$5(inp) {
  return {
    quoteId: inp.quoteId
  };
}
function makeVariables$5(quoteId, param) {
  return {
    quoteId: quoteId
  };
}
let SalesDetailsQuoteQuery_inner = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5
};
let include$5 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$6,
  Raw: Raw$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5
});
let use$5 = include$5.use;
let SalesDetailsQuoteQuery_refetchQueryDescription = include$5.refetchQueryDescription;
let SalesDetailsQuoteQuery_useLazy = include$5.useLazy;
let SalesDetailsQuoteQuery_useLazyWithVariables = include$5.useLazyWithVariables;
let SalesDetailsQuoteQuery = {
  SalesDetailsQuoteQuery_inner: SalesDetailsQuoteQuery_inner,
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  refetchQueryDescription: SalesDetailsQuoteQuery_refetchQueryDescription,
  use: use$5,
  useLazy: SalesDetailsQuoteQuery_useLazy,
  useLazyWithVariables: SalesDetailsQuoteQuery_useLazyWithVariables
};
function SalesDetailsPage$SalesDetailsStatusBadge(props) {
  let saleType = props.saleType;
  let value = props.value;
  let styleSet = Sale.Status.Badge.toStyleSet(value, saleType);
  let label = Sale.Status.toLabel(undefined, saleType, value);
  return JsxRuntime.jsx(Badge.make, {
    children: label,
    iconSvg: styleSet.iconSvg,
    size: "normal",
    borderColor: styleSet.borderColor,
    backgroundColor: styleSet.bgColor,
    foregroundColor: styleSet.textColor
  });
}
let SalesDetailsStatusBadge = {
  make: SalesDetailsPage$SalesDetailsStatusBadge
};
let make = React.memo(props => {
  let refundReason = props.refundReason;
  let value = props.value;
  let styleSet = Sale.BusinessSecondaryStatus.Badge.toStyleSet(value);
  let tooltipContent;
  switch (value) {
    case "Refunded":
      tooltipContent = refundReason !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Reason") + I18n.t(":") + " ",
          bold: true
        }), JsxRuntime.jsx(Tooltip.Span.make, {
          text: Sale.RefundReceiptReason.toLabel(refundReason)
        })]
      }) : null;
      break;
    case "Delivered":
    case "Billed":
      tooltipContent = null;
      break;
  }
  let tooltipDisabled = value !== "Refunded" || Stdlib_Option.isNone(refundReason);
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Badge.make, {
      children: Sale.BusinessSecondaryStatus.toLabel(value),
      iconSvg: styleSet.iconSvg,
      size: "normal",
      borderColor: styleSet.borderColor,
      backgroundColor: styleSet.bgColor,
      foregroundColor: styleSet.textColor
    }),
    placement: "top",
    content: tooltipContent,
    disabled: tooltipDisabled
  });
});
let SalesDetailsSecondaryStatusBadge = {
  make: make
};
function invoiceTermsOfPayment(termsOfPayment) {
  if (termsOfPayment !== "paid" && termsOfPayment !== "unpaid" && termsOfPayment !== "") {
    return termsOfPayment;
  }
}
function invoiceItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "InvoiceItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function saleReceiptItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "SalesReceiptItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function creditNoteItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "CreditNoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function refundReceiptItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "SalesReceiptItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function deliveryNoteItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "DeliveryNoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function quoteItemDiscounts(itemId, discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (typeof discount !== "object") {
      return;
    }
    if (discount.NAME !== "QuoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    if (match.appliedTo.some(id => id === itemId)) {
      return {
        name: match.name,
        value: match.value,
        isPercentage: match.valueType === "Percentage"
      };
    }
  });
}
function invoicePricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "InvoiceItem") {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    } else {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    }
  });
}
function receiptPricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "SalesReceiptCompoundItem") {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    } else {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    }
  });
}
function creditNotePricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "CreditNoteCompoundItem") {
      return item.VAL.taxesIncluded;
    } else {
      return item.VAL.taxesIncluded;
    }
  });
}
function refundReceiptPricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "RefundReceiptItem") {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    } else {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    }
  });
}
function deliveryNotePricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "DeliveryNoteCompoundItem") {
      return item.VAL.taxesIncluded;
    } else {
      return item.VAL.taxesIncluded;
    }
  });
}
function quotePricelistTaxesIncluded(items) {
  return items.every(item => {
    if (item.NAME === "QuoteItem") {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    } else {
      return Stdlib_Option.getOr(item.VAL.taxesIncluded, false);
    }
  });
}
function productItemTax(name, ratio) {
  return Stdlib_Option.map(Stdlib_Float.fromString(name), rate => ({
    rate: rate,
    ratio: ratio
  }));
}
function productItemTaxFromRate(rate, ratio) {
  return {
    rate: rate,
    ratio: ratio
  };
}
function variant(data, hasPricelist, isCompoundItem) {
  if (hasPricelist && data === undefined) {
    if (isCompoundItem) {
      return "CompoundItem";
    } else {
      return "LibreItem";
    }
  } else {
    return {
      TAG: "Item",
      _0: data
    };
  }
}
function netAmount(amountReceived, amountReturned) {
  return BigJs.Big(amountReceived).minus(BigJs.Big(amountReturned)).toNumber();
}
function taxesExempted(taxesIncluded) {
  return !taxesIncluded;
}
function totalAmountBeforeDiscounts(discountAmounts, totalAmountExcludingTaxes, totalAmountIncludingTaxes, taxesIncluded) {
  let discountsSum = Stdlib_Array.reduce(discountAmounts, 0, (acc, param) => {
    let amount = taxesIncluded ? param[1] : param[0];
    return BigJs.Big(acc).plus(BigJs.Big(amount)).toNumber();
  });
  let baseTotal = taxesIncluded ? totalAmountIncludingTaxes : totalAmountExcludingTaxes;
  return BigJs.Big(baseTotal).plus(BigJs.Big(discountsSum)).toNumber();
}
function invoiceDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME !== "InvoiceFooterDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function receiptDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME !== "SalesReceiptFooterDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function creditNoteDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME === "CreditNoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function refundReceiptDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME !== "SalesReceiptFooterDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function deliveryNoteDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME === "DeliveryNoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function quoteDiscountAmounts(discounts) {
  return Stdlib_Array.filterMap(discounts, discount => {
    if (discount.NAME === "QuoteItemDiscount") {
      return;
    }
    let match = discount.VAL;
    return [match.totalAmountExcludingTaxes, match.totalAmountIncludingTaxes];
  });
}
function infoString(value) {
  return Stdlib_Option.getOr(Stdlib_Option.flatMap(value, str => {
    if (str.trim() !== "") {
      return str;
    }
  }), nonApplicableString);
}
function make$1(queryResult, id) {
  switch (queryResult.TAG) {
    case "InvoiceQueryResult":
      let invoice = queryResult._0.invoice;
      return {
        reference: {
          id: id,
          name: invoice.name,
          relatedReferences: {
            quote: Stdlib_Option.map(invoice.parentQuote, param => ({
              id: param.id,
              name: param.name,
              date: param.createdAt
            })),
            salesReceipt: Stdlib_Option.map(invoice.salesReceipt, param => ({
              id: param.id,
              name: param.name,
              date: param.createdAt
            })),
            deliveryNotes: Stdlib_Array.filterMap(invoice.deliveryNotes, param => {
              if (param.status === "PUBLISHED") {
                return {
                  id: param.id,
                  name: param.name,
                  date: param.date
                };
              }
            }),
            creditNotes: invoice.creditNotes.map(param => ({
              id: param.id,
              name: param.name,
              date: param.createdAt
            }))
          }
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(invoiceDiscountAmounts(invoice.discounts), invoice.totalAmountExcludingTaxes, invoice.totalAmountIncludingTaxes, invoicePricelistTaxesIncluded(invoice.items)),
        totalAmountIncludingTaxes: invoice.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: invoice.totalAmountExcludingTaxes,
        status: Sale.Status.fromRaw(invoice.dueDate, invoice.creditNotes.length !== 0, undefined, invoice.status),
        eInvoicingWorkflowState: invoice.electronicInvoicingWorkflowState,
        customerInvoicingAddress: ElectronicInvoicing.InvoicingEndpoint.make(invoice.customerInvoicingEndpointIdSchemeType, invoice.customerInvoicingEndpointIdSchemeCode, invoice.customerInvoicingEndpointId),
        termsOfPayment: invoiceTermsOfPayment(invoice.termsOfPayment),
        payments: invoice.payments.map(payment => ({
          id: payment.id,
          method: PaymentMethod.fromRawValue(payment.method),
          date: payment.date,
          amount: netAmount(payment.amountReceived, payment.amountReturned)
        })),
        date: invoice.issueDate,
        dueDate: invoice.dueDate,
        customer: invoice.customerName.trim() !== "" ? {
          id: Stdlib_Option.map(invoice.customer, customer => customer.id),
          name: invoice.customerName,
          address: infoString(invoice.customerAddress),
          city: infoString(invoice.customerCity),
          postalCode: infoString(invoice.customerPostalCode),
          country: infoString(invoice.customerCountry),
          email: infoString(invoice.customerEmail),
          intraCommunityVAT: infoString(invoice.customerIntraCommunityVAT),
          phoneNumber: infoString(invoice.customerPhoneNumber),
          isBusiness: Stdlib_Option.mapOr(invoice.customer, false, customer => customer.kind === "BUSINESS"),
          isLoyaltyMember: Stdlib_Option.mapOr(invoice.customer, false, customer => customer.hasSubscribedToLoyaltyProgram)
        } : undefined,
        pricelistName: Stdlib_Option.map(invoice.price, price => price.name),
        pricelistTaxesIncluded: invoicePricelistTaxesIncluded(invoice.items),
        taxesExempted: !invoice.taxesIncluded,
        note: invoice.note,
        shop: {
          id: invoice.shop.id,
          name: invoice.shop.name
        },
        device: DeviceName.decode(invoice.device.slug, invoice.device.name),
        staffName: invoice.staff.name,
        items: Stdlib_Array.filterMap(invoice.items, item => {
          if (item.NAME === "InvoiceItem") {
            let invoiceItem = item.VAL;
            let variantData = Stdlib_Option.map(invoiceItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: invoiceItem.id,
              name: invoiceItem.name,
              category: invoiceItem.category,
              quantity: invoiceItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(invoiceItem.capacityUnit, Stdlib_Option.flatMap(invoiceItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: invoiceItem.price,
              totalPrice: invoiceItem.totalPrice,
              taxes: Stdlib_Array.filterMap(invoiceItem.taxes, tax => productItemTax(tax.name, 1)),
              discounts: invoiceItemDiscounts(invoiceItem.id, invoice.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(invoice.price), false)
            };
          }
          let invoiceItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(invoiceItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: invoiceItem$1.id,
            name: invoiceItem$1.name,
            category: invoiceItem$1.category,
            quantity: invoiceItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(invoiceItem$1.capacityUnit, Stdlib_Option.flatMap(invoiceItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: invoiceItem$1.price,
            totalPrice: invoiceItem$1.totalPrice,
            taxes: Stdlib_Array.filterMap(invoiceItem$1.taxes, tax => productItemTax(tax.name, tax.ratio)),
            discounts: invoiceItemDiscounts(invoiceItem$1.id, invoice.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(invoice.price), true)
          };
        }),
        taxes: Stdlib_Array.filterMap(invoice.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: Stdlib_Option.getOr(tax.baseAmount, 0),
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(invoice.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "InvoiceFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
    case "ReceiptQueryResult":
      let salesReceipt = queryResult._0.salesReceipt;
      return {
        reference: {
          id: id,
          name: salesReceipt.name,
          relatedReferences: {
            invoices: Stdlib_Option.mapOr(salesReceipt.invoice, [], param => [{
              id: param.id,
              name: param.name,
              date: param.createdAt
            }]),
            refundReceipts: salesReceipt.refundReceipts.map(param => ({
              id: param.id,
              name: param.name,
              date: param.createdAt
            }))
          }
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(receiptDiscountAmounts(salesReceipt.discounts), salesReceipt.totalAmountExcludingTaxes, salesReceipt.totalAmountIncludingTaxes, receiptPricelistTaxesIncluded(salesReceipt.items)),
        totalAmountIncludingTaxes: salesReceipt.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: salesReceipt.totalAmountExcludingTaxes,
        status: Sale.Status.fromRaw(undefined, undefined, Stdlib_Option.isSome(salesReceipt.invoice), "PAID"),
        payments: salesReceipt.payments.map(payment => ({
          id: payment.id,
          method: PaymentMethod.fromRawValue(payment.method),
          date: salesReceipt.createdAt,
          amount: netAmount(payment.amountReceived, payment.amountReturned)
        })),
        date: salesReceipt.createdAt,
        customer: Stdlib_Option.flatMap(salesReceipt.customer, customer => {
          let name = Customer.makeName(customer.firstName, customer.lastName, customer.companyName);
          let location = customer.locations[0];
          return Stdlib_Option.map(name, name => ({
            id: customer.id,
            name: name,
            address: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.address), nonApplicableString),
            city: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.city), nonApplicableString),
            postalCode: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.postalCode), nonApplicableString),
            country: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.country), nonApplicableString),
            email: Stdlib_Option.getOr(customer.email, nonApplicableString),
            intraCommunityVAT: Stdlib_Option.getOr(customer.intraCommunityVAT, nonApplicableString),
            phoneNumber: Stdlib_Option.getOr(customer.phoneNumber, nonApplicableString),
            isBusiness: customer.kind === "BUSINESS",
            isLoyaltyMember: customer.hasSubscribedToLoyaltyProgram
          }));
        }),
        pricelistName: Stdlib_Option.map(salesReceipt.price, price => price.name),
        pricelistTaxesIncluded: receiptPricelistTaxesIncluded(salesReceipt.items),
        taxesExempted: !salesReceipt.taxesIncluded,
        shop: {
          id: salesReceipt.shop.id,
          name: salesReceipt.shop.name
        },
        device: DeviceName.decode(salesReceipt.device.slug, salesReceipt.device.name),
        staffName: salesReceipt.staff.name,
        items: Stdlib_Array.filterMap(salesReceipt.items, item => {
          if (item.NAME === "SalesReceiptCompoundItem") {
            let receiptItem = item.VAL;
            let variantData = Stdlib_Option.map(receiptItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: receiptItem.id,
              name: receiptItem.name,
              category: receiptItem.category,
              quantity: receiptItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(receiptItem.capacityUnit, Stdlib_Option.flatMap(receiptItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: receiptItem.price,
              totalPrice: receiptItem.totalPrice,
              taxes: receiptItem.taxes.map(tax => ({
                rate: tax.rate,
                ratio: tax.ratio
              })),
              discounts: saleReceiptItemDiscounts(receiptItem.id, salesReceipt.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(salesReceipt.price), true)
            };
          }
          let receiptItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(receiptItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: receiptItem$1.id,
            name: receiptItem$1.name,
            category: receiptItem$1.category,
            quantity: receiptItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(receiptItem$1.capacityUnit, Stdlib_Option.flatMap(receiptItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: receiptItem$1.price,
            totalPrice: receiptItem$1.totalPrice,
            taxes: receiptItem$1.taxes.map(tax => ({
              rate: tax.rate,
              ratio: 1
            })),
            discounts: saleReceiptItemDiscounts(receiptItem$1.id, salesReceipt.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(salesReceipt.price), false)
          };
        }),
        taxes: Stdlib_Array.filterMap(salesReceipt.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: tax.baseAmount,
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(salesReceipt.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "SalesReceiptFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
    case "CreditNoteQueryResult":
      let creditNote = queryResult._0.creditNote;
      return {
        reference: {
          id: id,
          name: creditNote.name,
          relatedReferences: {
            invoices: Stdlib_Option.mapOr(creditNote.parentInvoice, [], param => [{
              id: param.id,
              name: param.name,
              date: param.issueDate
            }])
          }
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(creditNoteDiscountAmounts(creditNote.discounts), creditNote.totalAmountExcludingTaxes, creditNote.totalAmountIncludingTaxes, creditNotePricelistTaxesIncluded(creditNote.items)),
        totalAmountIncludingTaxes: creditNote.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: creditNote.totalAmountExcludingTaxes,
        payments: [],
        date: creditNote.createdAt,
        customer: creditNote.customerName.trim() !== "" ? {
          id: Stdlib_Option.map(creditNote.customer, customer => customer.id),
          name: creditNote.customerName,
          address: infoString(creditNote.customerAddress),
          city: infoString(creditNote.customerCity),
          postalCode: infoString(creditNote.customerPostalCode),
          country: infoString(creditNote.customerCountry),
          email: infoString(creditNote.customerEmail),
          intraCommunityVAT: infoString(creditNote.customerIntraCommunityVAT),
          phoneNumber: infoString(creditNote.customerPhoneNumber),
          isBusiness: Stdlib_Option.mapOr(creditNote.customer, false, customer => customer.kind === "BUSINESS"),
          isLoyaltyMember: Stdlib_Option.mapOr(creditNote.customer, false, customer => customer.hasSubscribedToLoyaltyProgram)
        } : undefined,
        pricelistName: Stdlib_Option.map(creditNote.price, price => price.name),
        pricelistTaxesIncluded: creditNotePricelistTaxesIncluded(creditNote.items),
        taxesExempted: !creditNote.taxesIncluded,
        note: creditNote.note,
        shop: {
          id: creditNote.shop.id,
          name: creditNote.shop.name
        },
        device: DeviceName.decode(creditNote.device.slug, creditNote.device.name),
        staffName: Stdlib_Option.getOr(Stdlib_Option.map(creditNote.staff, staff => staff.name), nonApplicableString),
        items: Stdlib_Array.filterMap(creditNote.items, item => {
          if (item.NAME === "CreditNoteCompoundItem") {
            let creditNoteItem = item.VAL;
            let variantData = Stdlib_Option.map(creditNoteItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: creditNoteItem.id,
              name: creditNoteItem.name,
              category: creditNoteItem.category,
              quantity: creditNoteItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(creditNoteItem.capacityUnit, Stdlib_Option.flatMap(creditNoteItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: creditNoteItem.price,
              totalPrice: creditNoteItem.totalPrice,
              taxes: Stdlib_Array.filterMap(creditNoteItem.taxes, tax => productItemTax(tax.name, tax.ratio)),
              discounts: creditNoteItemDiscounts(creditNoteItem.id, creditNote.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(creditNote.price), true)
            };
          }
          let creditNoteItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(creditNoteItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: creditNoteItem$1.id,
            name: creditNoteItem$1.name,
            category: creditNoteItem$1.category,
            quantity: creditNoteItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(creditNoteItem$1.capacityUnit, Stdlib_Option.flatMap(creditNoteItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: creditNoteItem$1.price,
            totalPrice: creditNoteItem$1.totalPrice,
            taxes: Stdlib_Array.filterMap(creditNoteItem$1.taxes, tax => productItemTax(tax.name, 1)),
            discounts: creditNoteItemDiscounts(creditNoteItem$1.id, creditNote.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(creditNote.price), false)
          };
        }),
        taxes: Stdlib_Array.filterMap(creditNote.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: Stdlib_Option.getOr(tax.baseAmount, 0),
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(creditNote.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "CreditNoteFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
    case "RefundReceiptQueryResult":
      let refundReceipt = queryResult._0.refundReceipt;
      return {
        reference: {
          id: id,
          name: refundReceipt.name,
          relatedReferences: {
            salesReceipt: {
              id: refundReceipt.salesReceipt.id,
              name: refundReceipt.salesReceipt.name,
              date: refundReceipt.salesReceipt.createdAt
            }
          },
          refundReason: Sale.RefundReceiptReason.fromRaw(refundReceipt.reason)
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(refundReceiptDiscountAmounts(refundReceipt.salesReceipt.discounts), refundReceipt.totalAmountExcludingTaxes, refundReceipt.totalAmountIncludingTaxes, refundReceiptPricelistTaxesIncluded(refundReceipt.items)),
        totalAmountIncludingTaxes: refundReceipt.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: refundReceipt.totalAmountExcludingTaxes,
        payments: refundReceipt.payments.map(payment => ({
          id: payment.id,
          method: PaymentMethod.fromRawValue(payment.method),
          date: refundReceipt.createdAt,
          amount: netAmount(payment.amountReceived, payment.amountReturned)
        })),
        date: refundReceipt.createdAt,
        customer: Stdlib_Option.flatMap(refundReceipt.customer, customer => {
          let name = Customer.makeName(customer.firstName, customer.lastName, customer.companyName);
          let location = customer.locations[0];
          return Stdlib_Option.map(name, name => ({
            id: customer.id,
            name: name,
            address: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.address), nonApplicableString),
            city: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.city), nonApplicableString),
            postalCode: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.postalCode), nonApplicableString),
            country: Stdlib_Option.getOr(Stdlib_Option.flatMap(location, location => location.country), nonApplicableString),
            email: Stdlib_Option.getOr(customer.email, nonApplicableString),
            intraCommunityVAT: Stdlib_Option.getOr(customer.intraCommunityVAT, nonApplicableString),
            phoneNumber: Stdlib_Option.getOr(customer.phoneNumber, nonApplicableString),
            isBusiness: customer.kind === "BUSINESS",
            isLoyaltyMember: customer.hasSubscribedToLoyaltyProgram
          }));
        }),
        pricelistName: Stdlib_Option.map(refundReceipt.price, price => price.name),
        pricelistTaxesIncluded: refundReceiptPricelistTaxesIncluded(refundReceipt.items),
        taxesExempted: !refundReceipt.salesReceipt.taxesIncluded,
        shop: {
          id: refundReceipt.shop.id,
          name: refundReceipt.shop.name
        },
        device: DeviceName.decode(refundReceipt.device.slug, refundReceipt.device.name),
        staffName: refundReceipt.staff.name,
        items: Stdlib_Array.filterMap(refundReceipt.items, item => {
          if (item.NAME === "RefundReceiptItem") {
            let refundItem = item.VAL;
            let variantData = Stdlib_Option.map(refundItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: refundItem.id,
              name: refundItem.name,
              category: refundItem.category,
              quantity: refundItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(refundItem.capacityUnit, Stdlib_Option.flatMap(refundItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: refundItem.price,
              totalPrice: refundItem.totalPrice,
              taxes: Stdlib_Array.filterMap(refundItem.taxes, tax => productItemTax(tax.name, 1)),
              discounts: refundReceiptItemDiscounts(refundItem.id, refundReceipt.salesReceipt.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(refundReceipt.price), false)
            };
          }
          let refundItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(refundItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: refundItem$1.id,
            name: refundItem$1.name,
            category: refundItem$1.category,
            quantity: refundItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(refundItem$1.capacityUnit, Stdlib_Option.flatMap(refundItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: refundItem$1.price,
            totalPrice: refundItem$1.totalPrice,
            taxes: Stdlib_Array.filterMap(refundItem$1.taxes, tax => productItemTax(tax.name, tax.ratio)),
            discounts: refundReceiptItemDiscounts(refundItem$1.id, refundReceipt.salesReceipt.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(refundReceipt.price), true)
          };
        }),
        taxes: Stdlib_Array.filterMap(refundReceipt.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: Stdlib_Option.getOr(tax.baseAmount, 0),
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(refundReceipt.salesReceipt.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "SalesReceiptFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
    case "DeliveryNoteQueryResult":
      let deliveryNote = queryResult._0.deliveryNote;
      let match = deliveryNote.status;
      return {
        reference: {
          id: id,
          name: deliveryNote.name,
          relatedReferences: {
            invoices: Stdlib_Array.filterMap(deliveryNote.invoices, param => {
              if (param.status !== "DRAFT" && Stdlib_Option.isNone(param.archivedAt)) {
                return {
                  id: param.id,
                  name: param.name,
                  date: param.issueDate
                };
              }
            })
          }
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(deliveryNoteDiscountAmounts(deliveryNote.discounts), deliveryNote.totalAmountExcludingTaxes, deliveryNote.totalAmountIncludingTaxes, deliveryNotePricelistTaxesIncluded(deliveryNote.items)),
        totalAmountIncludingTaxes: deliveryNote.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: deliveryNote.totalAmountExcludingTaxes,
        status: match === "DRAFT" ? "Draft" : "Completed",
        payments: [],
        date: deliveryNote.createdAt,
        customer: deliveryNote.customerName.trim() !== "" ? {
          id: Stdlib_Option.map(deliveryNote.customer, customer => customer.id),
          name: deliveryNote.customerName,
          address: infoString(deliveryNote.customerAddress),
          city: infoString(deliveryNote.customerCity),
          postalCode: infoString(deliveryNote.customerPostalCode),
          country: infoString(deliveryNote.customerCountry),
          email: infoString(deliveryNote.customerEmail),
          intraCommunityVAT: infoString(deliveryNote.customerIntraCommunityVAT),
          phoneNumber: infoString(deliveryNote.customerPhoneNumber),
          isBusiness: Stdlib_Option.mapOr(deliveryNote.customer, false, param => param.kind === "BUSINESS"),
          isLoyaltyMember: Stdlib_Option.mapOr(deliveryNote.customer, false, param => param.hasSubscribedToLoyaltyProgram)
        } : undefined,
        pricelistName: Stdlib_Option.map(deliveryNote.price, price => price.name),
        pricelistTaxesIncluded: deliveryNotePricelistTaxesIncluded(deliveryNote.items),
        taxesExempted: !deliveryNote.taxesIncluded,
        note: deliveryNote.note,
        shop: {
          id: deliveryNote.shop.id,
          name: deliveryNote.shop.name
        },
        device: DeviceName.decode(deliveryNote.device.slug, deliveryNote.device.name),
        staffName: Stdlib_Option.getOr(Stdlib_Option.map(deliveryNote.staff, staff => staff.name), nonApplicableString),
        items: Stdlib_Array.filterMap(deliveryNote.items, item => {
          if (item.NAME === "DeliveryNoteCompoundItem") {
            let deliveryNoteItem = item.VAL;
            let variantData = Stdlib_Option.map(deliveryNoteItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: deliveryNoteItem.id,
              name: deliveryNoteItem.name,
              category: deliveryNoteItem.category,
              quantity: deliveryNoteItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(deliveryNoteItem.capacityUnit, Stdlib_Option.flatMap(deliveryNoteItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: deliveryNoteItem.price,
              totalPrice: deliveryNoteItem.totalPrice,
              taxes: Stdlib_Array.filterMap(deliveryNoteItem.taxes, tax => productItemTax(tax.name, tax.ratio)),
              discounts: deliveryNoteItemDiscounts(deliveryNoteItem.id, deliveryNote.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(deliveryNote.price), true)
            };
          }
          let deliveryNoteItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(deliveryNoteItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: deliveryNoteItem$1.id,
            name: deliveryNoteItem$1.name,
            category: deliveryNoteItem$1.category,
            quantity: deliveryNoteItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(deliveryNoteItem$1.capacityUnit, Stdlib_Option.flatMap(deliveryNoteItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: deliveryNoteItem$1.price,
            totalPrice: deliveryNoteItem$1.totalPrice,
            taxes: Stdlib_Array.filterMap(deliveryNoteItem$1.taxes, tax => productItemTax(tax.name, 1)),
            discounts: deliveryNoteItemDiscounts(deliveryNoteItem$1.id, deliveryNote.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(deliveryNote.price), false)
          };
        }),
        taxes: Stdlib_Array.filterMap(deliveryNote.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: Stdlib_Option.getOr(tax.baseAmount, 0),
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(deliveryNote.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "DeliveryNoteFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
    case "QuoteQueryResult":
      let quote = queryResult._0.quote;
      let match$1 = quote.status;
      return {
        reference: {
          id: id,
          name: quote.name,
          relatedReferences: {
            invoices: Stdlib_Array.filterMap(quote.invoices, param => {
              if (param.status !== "DRAFT" && Stdlib_Option.isNone(param.archivedAt)) {
                return {
                  id: param.id,
                  name: param.name,
                  date: param.issueDate
                };
              }
            })
          }
        },
        totalAmountBeforeDiscounts: totalAmountBeforeDiscounts(quoteDiscountAmounts(quote.discounts), quote.totalAmountExcludingTaxes, quote.totalAmountIncludingTaxes, quotePricelistTaxesIncluded(quote.items)),
        totalAmountIncludingTaxes: quote.totalAmountIncludingTaxes,
        totalAmountExcludingTaxes: quote.totalAmountExcludingTaxes,
        status: match$1 === "ACCEPTED" ? "Completed" : "Started",
        payments: [],
        date: quote.createdAt,
        customer: quote.customerName.trim() !== "" ? {
          id: Stdlib_Option.map(quote.customer, customer => customer.id),
          name: quote.customerName,
          address: infoString(quote.customerAddress),
          city: infoString(quote.customerCity),
          postalCode: infoString(quote.customerPostalCode),
          country: infoString(quote.customerCountry),
          email: infoString(quote.customerEmail),
          intraCommunityVAT: infoString(quote.customerIntraCommunityVAT),
          phoneNumber: infoString(quote.customerPhoneNumber),
          isBusiness: Stdlib_Option.mapOr(quote.customer, false, param => param.kind === "BUSINESS"),
          isLoyaltyMember: Stdlib_Option.mapOr(quote.customer, false, param => param.hasSubscribedToLoyaltyProgram)
        } : undefined,
        pricelistName: Stdlib_Option.map(quote.price, price => price.name),
        pricelistTaxesIncluded: quotePricelistTaxesIncluded(quote.items),
        taxesExempted: !quote.taxesIncluded,
        note: quote.note,
        shop: {
          id: quote.shop.id,
          name: quote.shop.name
        },
        device: DeviceName.decode(quote.device.slug, quote.device.name),
        staffName: Stdlib_Option.mapOr(quote.staff, nonApplicableString, staff => staff.name),
        items: Stdlib_Array.filterMap(quote.items, item => {
          if (item.NAME === "QuoteItem") {
            let quoteItem = item.VAL;
            let variantData = Stdlib_Option.map(quoteItem.variant, variant => ({
              id: variant.id,
              cku: variant.cku,
              name: variant.name,
              stockKeepingUnit: variant.stockKeepingUnit,
              priceLookUpCode: variant.priceLookUpCode,
              internalCode: variant.internalCode,
              product: {
                id: variant.product.id,
                kind: variant.product.kind,
                name: variant.product.name,
                producer: variant.product.producer,
                designation: variant.product.designation,
                family: variant.product.family,
                region: variant.product.region,
                country: variant.product.country,
                color: variant.product.color,
                wineType: variant.product.wineType,
                whiteWineType: variant.product.whiteWineType,
                beerType: variant.product.beerType
              },
              supplier: Stdlib_Option.map(variant.supplier, supplier => ({
                id: supplier.id,
                companyName: supplier.companyName
              }))
            }));
            return {
              id: quoteItem.id,
              name: quoteItem.name,
              category: quoteItem.category,
              quantity: quoteItem.quantity,
              bulkUnit: StockQuantity.BulkUnit.make(quoteItem.capacityUnit, Stdlib_Option.flatMap(quoteItem.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
              unitPrice: quoteItem.price,
              totalPrice: quoteItem.totalPrice,
              taxes: Stdlib_Array.filterMap(quoteItem.taxes, tax => productItemTax(tax.name, 1)),
              discounts: quoteItemDiscounts(quoteItem.id, quote.discounts),
              variant: variant(variantData, Stdlib_Option.isSome(quote.price), false)
            };
          }
          let quoteItem$1 = item.VAL;
          let variantData$1 = Stdlib_Option.map(quoteItem$1.variant, variant => ({
            id: variant.id,
            cku: variant.cku,
            name: variant.name,
            stockKeepingUnit: variant.stockKeepingUnit,
            priceLookUpCode: variant.priceLookUpCode,
            internalCode: variant.internalCode,
            product: {
              id: variant.product.id,
              kind: variant.product.kind,
              name: variant.product.name,
              producer: variant.product.producer,
              designation: variant.product.designation,
              family: variant.product.family,
              region: variant.product.region,
              country: variant.product.country,
              color: variant.product.color,
              wineType: variant.product.wineType,
              whiteWineType: variant.product.whiteWineType,
              beerType: variant.product.beerType
            },
            supplier: Stdlib_Option.map(variant.supplier, supplier => ({
              id: supplier.id,
              companyName: supplier.companyName
            }))
          }));
          return {
            id: quoteItem$1.id,
            name: quoteItem$1.name,
            category: quoteItem$1.category,
            quantity: quoteItem$1.quantity,
            bulkUnit: StockQuantity.BulkUnit.make(quoteItem$1.capacityUnit, Stdlib_Option.flatMap(quoteItem$1.capacityPrecision, precision => Stdlib_Int.fromString(precision, 10))),
            unitPrice: quoteItem$1.price,
            totalPrice: quoteItem$1.totalPrice,
            taxes: Stdlib_Array.filterMap(quoteItem$1.taxes, tax => productItemTax(tax.name, tax.ratio)),
            discounts: quoteItemDiscounts(quoteItem$1.id, quote.discounts),
            variant: variant(variantData$1, Stdlib_Option.isSome(quote.price), true)
          };
        }),
        taxes: Stdlib_Array.filterMap(quote.taxes, tax => {
          if (tax.rate > 0) {
            return {
              rate: tax.rate,
              baseAmount: Stdlib_Option.getOr(tax.baseAmount, 0),
              taxAmount: tax.taxAmount
            };
          }
        }),
        discounts: Stdlib_Array.filterMap(quote.discounts, discount => {
          if (typeof discount !== "object") {
            return;
          }
          if (discount.NAME !== "QuoteFooterDiscount") {
            return;
          }
          let match = discount.VAL;
          return {
            name: match.name,
            value: match.value,
            isPercentage: match.valueType === "Percentage"
          };
        })
      };
  }
}
let SaleDetailsData = {
  invoiceTermsOfPayment: invoiceTermsOfPayment,
  invoiceItemDiscounts: invoiceItemDiscounts,
  saleReceiptItemDiscounts: saleReceiptItemDiscounts,
  creditNoteItemDiscounts: creditNoteItemDiscounts,
  refundReceiptItemDiscounts: refundReceiptItemDiscounts,
  deliveryNoteItemDiscounts: deliveryNoteItemDiscounts,
  quoteItemDiscounts: quoteItemDiscounts,
  invoicePricelistTaxesIncluded: invoicePricelistTaxesIncluded,
  receiptPricelistTaxesIncluded: receiptPricelistTaxesIncluded,
  creditNotePricelistTaxesIncluded: creditNotePricelistTaxesIncluded,
  refundReceiptPricelistTaxesIncluded: refundReceiptPricelistTaxesIncluded,
  deliveryNotePricelistTaxesIncluded: deliveryNotePricelistTaxesIncluded,
  quotePricelistTaxesIncluded: quotePricelistTaxesIncluded,
  productItemTax: productItemTax,
  productItemTaxFromRate: productItemTaxFromRate,
  variant: variant,
  netAmount: netAmount,
  taxesExempted: taxesExempted,
  totalAmountBeforeDiscounts: totalAmountBeforeDiscounts,
  invoiceDiscountAmounts: invoiceDiscountAmounts,
  receiptDiscountAmounts: receiptDiscountAmounts,
  creditNoteDiscountAmounts: creditNoteDiscountAmounts,
  refundReceiptDiscountAmounts: refundReceiptDiscountAmounts,
  deliveryNoteDiscountAmounts: deliveryNoteDiscountAmounts,
  quoteDiscountAmounts: quoteDiscountAmounts,
  infoString: infoString,
  make: make$1
};
let styles = {
  ArticlesCard_discountCellText: {
    "color-kMwMTN": "color-x5auokd",
    "fontFamily-kMv6JI": "fontFamily-xvtss18",
    "fontSize-kGuDYH": "fontSize-xfifm61",
    "fontWeight-k63SB2": "fontWeight-x1s688f",
    "lineHeight-kLWn49": "lineHeight-xo5v014",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5933"
  },
  ArticlesCard_cartWrapper: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x1v2ro7d",
    "maxHeight-kskxy": "maxHeight-xi1lmxo",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5940"
  },
  ArticlesCard_cartTableWrapper: {
    "flex-kUk6DE": "flex-x98rzlu",
    "minHeight-kAzted": "minHeight-x2lwn1j",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5946"
  }
};
function svgFromSaleType(value) {
  let width = "18px";
  let height = "18px";
  switch (value) {
    case "SalesReceipt":
      return JsxRuntime.jsxs("svg", {
        children: [JsxRuntime.jsx("path", {
          d: "M3.5 4.1999C3.5 4.03422 3.63431 3.8999 3.8 3.8999H6.2C6.36569 3.8999 6.5 4.03422 6.5 4.1999C6.5 4.36559 6.36569 4.4999 6.2 4.4999H3.8C3.63431 4.4999 3.5 4.36559 3.5 4.1999Z",
          fill: "#767589"
        }), JsxRuntime.jsx("path", {
          d: "M3.8 6.2999C3.63431 6.2999 3.5 6.43422 3.5 6.5999C3.5 6.76559 3.63431 6.8999 3.8 6.8999H6.2C6.36569 6.8999 6.5 6.76559 6.5 6.5999C6.5 6.43422 6.36569 6.2999 6.2 6.2999H3.8Z",
          fill: "#767589"
        }), JsxRuntime.jsx("path", {
          d: "M1.06636 1.12586C1.10021 0.992936 1.21991 0.899902 1.35708 0.899902H9.2C9.28915 0.899902 9.37367 0.939547 9.43067 1.00809C9.48767 1.07663 9.51123 1.16698 9.49497 1.25462C8.89043 4.51321 8.89328 7.17843 9.49216 9.74612C9.51306 9.83573 9.49168 9.92997 9.43417 10.0018L8.64488 10.9874C8.58814 11.0583 8.50236 11.0996 8.41158 11.0999C8.32081 11.1002 8.23479 11.0593 8.17764 10.9888L7.61323 10.2923L7.05608 10.9875C6.99929 11.0584 6.91347 11.0997 6.82267 11.0999C6.73187 11.1001 6.64586 11.0592 6.58875 10.9886L6.02498 10.2917L5.46327 10.9882C5.40633 11.0588 5.3205 11.0999 5.2298 11.0999C5.13909 11.0999 5.05325 11.0589 4.99628 10.9883L4.43565 10.2936L3.88226 10.987C3.82556 11.0581 3.73968 11.0996 3.64877 11.0999C3.55786 11.1002 3.47171 11.0593 3.41454 10.9886L2.85029 10.2911L2.28506 10.9887C2.2279 11.0593 2.14188 11.1002 2.05109 11.0999C1.96029 11.0996 1.87451 11.0583 1.81776 10.9874L1.02523 9.99749C0.995662 9.96055 0.975247 9.91714 0.965655 9.87081C0.282728 6.57201 0.380433 3.81911 1.06636 1.12586ZM1.59171 1.4999C0.985016 4.01013 0.908222 6.58914 1.53874 9.67886L2.05334 10.3216L2.61736 9.62542C2.67435 9.55508 2.76005 9.51423 2.85057 9.51426C2.9411 9.5143 3.02677 9.55521 3.0837 9.62559L3.64619 10.3209L4.19985 9.62714C4.2566 9.55603 4.34254 9.51451 4.43352 9.51426C4.52449 9.51402 4.61067 9.55506 4.6678 9.62586L5.22967 10.3221L5.79109 9.62594C5.84799 9.55538 5.93374 9.51433 6.02438 9.51426C6.11502 9.51419 6.20084 9.55511 6.25784 9.62558L6.82089 10.3216L7.37785 9.62665C7.4346 9.55583 7.52037 9.51451 7.61113 9.51426C7.70188 9.51402 7.78787 9.55487 7.84501 9.62538L8.40931 10.3217L8.87522 9.7399C8.30791 7.2143 8.29978 4.6044 8.84118 1.4999H1.59171Z",
          fill: "#767589"
        })],
        height: height,
        width: width,
        viewBox: "0 0 9 11"
      });
    case "CreditNote":
      return JsxRuntime.jsx("svg", {
        children: JsxRuntime.jsx("path", {
          d: "M17.5771 4.44434C17.5771 4.05221 17.4568 3.66879 17.2314 3.34473C17.006 3.02052 16.6859 2.77034 16.3125 2.62891C15.9391 2.48749 15.5305 2.46187 15.1416 2.55469C14.7526 2.64758 14.4018 2.85517 14.1357 3.14844L14.1318 3.15332C14.0615 3.22879 13.976 3.28821 13.8818 3.3291C13.7875 3.36999 13.6856 3.3916 13.583 3.3916C13.4804 3.3916 13.3785 3.36998 13.2842 3.3291C13.1902 3.2883 13.1054 3.22857 13.0352 3.15332L13.0303 3.14844C12.7642 2.85517 12.4134 2.64758 12.0244 2.55469C11.6355 2.4619 11.2269 2.48751 10.8535 2.62891C10.4802 2.77035 10.16 3.02055 9.93457 3.34473C9.70925 3.66877 9.58887 4.05223 9.58887 4.44434C9.58905 5.29626 10.177 6.10228 10.7871 6.70606L13.583 9.27637L16.377 6.70606C16.663 6.42299 16.9709 6.04981 17.2031 5.6416C17.4377 5.22908 17.577 4.81505 17.5771 4.44434ZM17.2373 7.78321C16.8912 7.7736 16.5567 7.90112 16.3066 8.13477C16.299 8.14193 16.2892 8.14673 16.2812 8.15332L12.5283 11.6035C12.5122 11.6183 12.494 11.6303 12.4766 11.6426C12.0486 12.0498 11.4795 12.2783 10.8867 12.2783H9.08887C8.81295 12.2782 8.58904 12.0542 8.58887 11.7783C8.58887 11.5023 8.81284 11.2785 9.08887 11.2783H10.8867C11.2326 11.2783 11.5637 11.1416 11.8066 10.9014C12.0491 10.6614 12.1846 10.3369 12.1846 10C12.1845 9.66311 12.0492 9.33861 11.8066 9.09864C11.5637 8.8584 11.2326 8.72267 10.8867 8.72266H8.19043C7.75496 8.72266 7.47735 8.8635 7.33008 9.05762C7.31393 9.07892 7.29669 9.09972 7.27734 9.11817L2.61621 13.5625L5.5166 16.4297L6.57324 15.5137C6.96677 15.0334 7.56884 14.833 8.19043 14.833H11.7852C12.6522 14.833 13.4069 14.5242 13.9277 13.9355L13.959 13.9033L18.0928 9.99219L18.0947 9.99024C18.3446 9.75668 18.4893 9.43599 18.499 9.09864C18.5087 8.76126 18.3825 8.43252 18.1465 8.18555C17.9103 7.93861 17.5834 7.79288 17.2373 7.78321ZM18.5771 4.44532C18.577 5.05194 18.3551 5.63845 18.0723 6.13575C17.9334 6.37993 17.7744 6.61081 17.6094 6.82227C18.0878 6.90803 18.5309 7.14018 18.8701 7.49512C19.2895 7.9341 19.5163 8.52099 19.499 9.12696C19.4817 9.73195 19.2216 10.3033 18.7793 10.7178L18.7803 10.7188L14.6543 14.6201C13.918 15.4378 12.885 15.833 11.7852 15.833H8.19043C7.75489 15.833 7.47733 15.9748 7.33008 16.1689C7.30908 16.1966 7.28504 16.2224 7.25879 16.2451L6.22949 17.1357L6.74414 17.6445C6.94048 17.8387 6.94222 18.1552 6.74805 18.3516C6.55386 18.5478 6.23733 18.5496 6.04101 18.3555L0.648436 13.0225C0.452112 12.8283 0.450416 12.5118 0.64453 12.3154C0.838704 12.1191 1.15522 12.1174 1.35156 12.3115L1.9043 12.8584L6.5664 8.41211C6.95977 7.92536 7.565 7.72266 8.19043 7.72266H10.415L10.0986 7.43164C10.0942 7.42759 10.0902 7.42315 10.0859 7.41895C9.44212 6.78225 8.58904 5.72547 8.58887 4.44532C8.58873 3.84805 8.77172 3.26462 9.11328 2.77344C9.45479 2.28236 9.93901 1.9068 10.5 1.69434C11.0609 1.48195 11.6733 1.44273 12.2568 1.58203C12.7538 1.70071 13.2101 1.94474 13.583 2.28809C13.9559 1.94471 14.4122 1.70072 14.9092 1.58203C15.4927 1.4427 16.1051 1.48198 16.666 1.69434C17.227 1.90679 17.7112 2.28239 18.0527 2.77344C18.3943 3.26462 18.5773 3.84804 18.5771 4.44532Z",
          fill: "#767589"
        }),
        height: height,
        width: width,
        viewBox: "0 0 20 20"
      });
    case "RefundReceipt":
      return JsxRuntime.jsxs("svg", {
        children: [JsxRuntime.jsx("path", {
          d: "M8.96971 10.8V7.78889L7.95486 8.8342C7.8394 8.9529 7.64944 8.95546 7.53065 8.84006C7.41195 8.7246 7.40939 8.53464 7.52479 8.41584L9.05467 6.84085L9.10096 6.80217C9.15035 6.76853 9.20903 6.75005 9.26971 6.75002C9.35069 6.75002 9.42827 6.78282 9.48475 6.84085L11.0152 8.41584C11.1306 8.53468 11.1276 8.72462 11.0088 8.84006C10.8899 8.9555 10.7 8.95302 10.5846 8.8342L9.56971 7.78889V10.8C9.56971 10.9657 9.43539 11.1 9.26971 11.1C9.10408 11.1 8.96971 10.9657 8.96971 10.8Z",
          fill: "#767589"
        }), JsxRuntime.jsx("path", {
          d: "M10.1998 0.900024C10.2889 0.900024 10.3736 0.93988 10.4306 1.00842C10.4875 1.07689 10.5107 1.16702 10.4945 1.25452C10.341 2.08195 10.2271 2.87134 10.1517 3.62991C10.1117 4.03278 10.0825 4.42713 10.0644 4.81409C10.0566 4.97951 9.91636 5.10709 9.75094 5.09944C9.58543 5.09171 9.45727 4.95147 9.465 4.78596C9.48359 4.38802 9.51364 3.98299 9.55465 3.57014C9.62094 2.90272 9.71774 2.21449 9.84234 1.50002H2.59312C1.98629 4.0106 1.90848 6.58947 2.53922 9.67971L3.05308 10.3219L3.61734 9.62581L3.6648 9.57835C3.71719 9.5372 3.78266 9.51445 3.85055 9.51448C3.94099 9.51457 4.02686 9.55548 4.08375 9.62581L4.64566 10.3207L5.19937 9.62698C5.25609 9.55593 5.34226 9.51476 5.43316 9.51448C5.52409 9.51423 5.6104 9.55508 5.66754 9.62581L6.46324 10.6114C6.56722 10.7402 6.54683 10.9291 6.41812 11.0332C6.28927 11.1372 6.10034 11.1174 5.99625 10.9887L5.43492 10.2932L4.8818 10.9869C4.8251 11.058 4.73948 11.0997 4.64859 11.1C4.55768 11.1003 4.47139 11.0594 4.41422 10.9887L3.84937 10.2908L3.28453 10.9887C3.22738 11.0592 3.14152 11.1003 3.05074 11.1C2.95999 11.0997 2.87426 11.0584 2.81754 10.9875L2.02476 9.99788C1.99519 9.96094 1.97518 9.91706 1.96558 9.87073C1.28271 6.57205 1.38049 3.81935 2.06637 1.1262L2.08277 1.07815C2.13024 0.971288 2.23697 0.900024 2.35699 0.900024H10.1998Z",
          fill: "#767589"
        }), JsxRuntime.jsx("path", {
          d: "M7.19976 3.90002C7.36545 3.90002 7.49976 4.03434 7.49976 4.20002C7.49976 4.36571 7.36545 4.50002 7.19976 4.50002H4.79976C4.63408 4.50002 4.49976 4.36571 4.49976 4.20002C4.49976 4.03434 4.63408 3.90002 4.79976 3.90002H7.19976Z",
          fill: "#767589"
        }), JsxRuntime.jsx("path", {
          d: "M5.99976 6.30002C6.16545 6.30002 6.29976 6.43434 6.29976 6.60002C6.29976 6.76571 6.16545 6.90002 5.99976 6.90002H4.79976C4.63408 6.90002 4.49976 6.76571 4.49976 6.60002C4.49976 6.43434 4.63408 6.30002 4.79976 6.30002H5.99976Z",
          fill: "#767589"
        })],
        height: height,
        width: width,
        viewBox: "0 0 11 11"
      });
    case "DeliveryNote":
      return JsxRuntime.jsx("svg", {
        children: JsxRuntime.jsx("path", {
          d: "M8.5 0C8.63261 0 8.75975 0.0527163 8.85352 0.146484L12.8535 4.14648C12.9473 4.24025 13 4.36739 13 4.5V16.5C13 16.7761 12.7761 17 12.5 17H0.5C0.223858 17 0 16.7761 0 16.5V0.5C0 0.223858 0.223858 0 0.5 0H8.5ZM1 16H12V5H8.5C8.22386 5 8 4.77614 8 4.5V1H1V16ZM4.75781 11.1348C4.95927 10.946 5.27602 10.9568 5.46484 11.1582C5.65358 11.3597 5.6438 11.6764 5.44238 11.8652L4.0332 13.1855L3.1582 12.3652C2.95686 12.1765 2.94622 11.8597 3.13477 11.6582C3.32353 11.4569 3.64033 11.4462 3.8418 11.6348L4.0332 11.8145L4.75781 11.1348ZM9.5 12C9.77614 12 10 12.2239 10 12.5C10 12.7761 9.77614 13 9.5 13H7.5C7.22386 13 7 12.7761 7 12.5C7 12.2239 7.22386 12 7.5 12H9.5ZM4.75781 7.13477C4.95927 6.94601 5.27602 6.95679 5.46484 7.1582C5.65358 7.35967 5.6438 7.67641 5.44238 7.86523L4.0332 9.18555L3.1582 8.36523C2.95686 8.17647 2.94622 7.85967 3.13477 7.6582C3.32353 7.45686 3.64033 7.44622 3.8418 7.63477L4.0332 7.81445L4.75781 7.13477ZM9.5 8C9.77614 8 10 8.22386 10 8.5C10 8.77614 9.77614 9 9.5 9H7.5C7.22386 9 7 8.77614 7 8.5C7 8.22386 7.22386 8 7.5 8H9.5ZM9 4H11.293L9 1.70703V4Z",
          fill: "#767589"
        }),
        height: height,
        width: width,
        viewBox: "0 0 13 17"
      });
    case "Invoice":
    case "Quote":
      break;
  }
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("path", {
      d: "M18 13.833C17.9999 13.732 17.959 13.6339 17.8848 13.5605C17.8102 13.487 17.7076 13.4443 17.5996 13.4443H8.59961C8.49179 13.4444 8.38987 13.4871 8.31543 13.5605C8.24117 13.6339 8.20028 13.732 8.2002 13.833V14.7227C8.20011 15.1821 8.05882 15.626 7.80273 16H16.7002C17.0467 15.9999 17.3778 15.8641 17.6211 15.624C17.8641 15.384 17.9999 15.0594 18 14.7227V13.833ZM12.2002 8C12.4762 8.00011 12.7002 8.22392 12.7002 8.5C12.7002 8.77608 12.4762 8.99989 12.2002 9H7.7002C7.42405 9 7.2002 8.77614 7.2002 8.5C7.2002 8.22386 7.42405 8 7.7002 8H12.2002ZM12.2002 4.44434C12.4762 4.44444 12.7001 4.66831 12.7002 4.94434C12.7002 5.22041 12.4762 5.44423 12.2002 5.44434H7.7002C7.42405 5.44434 7.2002 5.22048 7.2002 4.94434C7.20025 4.66824 7.42409 4.44434 7.7002 4.44434H12.2002ZM3.59961 2.27734C3.59949 1.94063 3.4647 1.61599 3.22168 1.37598C2.97836 1.13572 2.64652 1 2.2998 1C1.9533 1.00005 1.62216 1.13594 1.37891 1.37598C1.13589 1.61599 1.00012 1.94063 1 2.27734V4.05566C1.00003 4.15675 1.04092 4.25473 1.11523 4.32812C1.18978 4.40174 1.29233 4.44434 1.40039 4.44434H3.59961V2.27734ZM4.59961 14.7227C4.59973 15.0594 4.7355 15.384 4.97852 15.624C5.22183 15.8642 5.55372 16 5.90039 16C6.24687 15.9999 6.57808 15.8641 6.82129 15.624C7.06431 15.384 7.20008 15.0594 7.2002 14.7227V13.833C7.20028 13.4628 7.34916 13.1085 7.6123 12.8486C7.8752 12.5891 8.23055 12.4444 8.59961 12.4443H15.2998V2.27734C15.2997 1.94063 15.1649 1.616 14.9219 1.37598C14.7089 1.16562 14.4281 1.03514 14.1289 1.00586L14 1H4.20312C4.45913 1.37397 4.59952 1.81794 4.59961 2.27734V14.7227ZM16.2998 12.4443H17.5996C17.9689 12.4443 18.3249 12.5889 18.5879 12.8486C18.851 13.1085 18.9999 13.4628 19 13.833V14.7227C18.9999 15.3286 18.7561 15.9084 18.3242 16.335C17.8925 16.7614 17.3081 16.9999 16.7002 17H5.90039C5.29238 17 4.70719 16.7614 4.27539 16.335C3.84366 15.9084 3.59973 15.3285 3.59961 14.7227V5.44434H1.40039C1.03109 5.44434 0.675121 5.29979 0.412109 5.04004C0.14891 4.78009 2.90966e-05 4.426 0 4.05566V2.27734C0.000116376 1.67142 0.243926 1.0916 0.675781 0.665039C1.10753 0.238618 1.69187 5.10557e-05 2.2998 0H14L14.2266 0.0107422C14.7517 0.062199 15.2462 0.291865 15.624 0.665039C16.0559 1.09161 16.2997 1.67138 16.2998 2.27734V12.4443Z",
      fill: "#767589"
    }),
    height: height,
    width: width,
    viewBox: "0 0 19 17"
  });
}
function isDatetimeBackdated(datetime) {
  if (datetime.getUTCHours() === 0 && datetime.getUTCMinutes() === 0 && datetime.getUTCSeconds() === 0) {
    return datetime.getUTCMilliseconds() === 0;
  } else {
    return false;
  }
}
function formatResourceName(value, saleType, isDraft) {
  return Sale.toLabel(undefined, saleType) + ` ` + (isDraft ? "" : I18n.t("no.")) + value;
}
function isDatetimeBackdated$1(datetime) {
  if (datetime.getUTCHours() === 0 && datetime.getUTCMinutes() === 0 && datetime.getUTCSeconds() === 0) {
    return datetime.getUTCMilliseconds() === 0;
  } else {
    return false;
  }
}
function SalesDetailsPage$ViewPage$SalesDetailsAmountAndPaymentsCard(props) {
  let payments = props.payments;
  let status = props.status;
  let taxesExempted = props.taxesExempted;
  let taxesIncluded = props.taxesIncluded;
  let saleType = props.saleType;
  let desktopScreenSize = Media.use(Breakpoints.huge);
  let paymentsDefaultExpanded = payments.length > 1 && payments.length <= 3;
  let match = Sale.toRevenueImpactTotalAmounts(saleType, props.totalAmountIncludingTaxes, props.totalAmountExcludingTaxes);
  let totalAmountExcludingTaxes = match[1];
  let totalAmountIncludingTaxes = match[0];
  let isNegativeTotal = totalAmountIncludingTaxes < 0 || totalAmountExcludingTaxes < 0;
  let totalLabelTone = isNegativeTotal ? "danger" : "neutral";
  let totalAmount = taxesIncluded ? totalAmountIncludingTaxes : totalAmountExcludingTaxes;
  let amount = I18n.currencyFormat(undefined, "EUR", undefined, undefined, totalAmount);
  let formattedTotalAmount = taxesExempted ? amount : amount + (" " + (taxesIncluded ? I18n.t("VAT incl.") : I18n.t("VAT excl.")));
  let totalValueTooltipText = taxesExempted ? I18n.t("VAT exemption") : !taxesIncluded ? I18n.currencyFormat(undefined, "EUR", undefined, undefined, totalAmountIncludingTaxes) + (" " + I18n.t("VAT incl.")) : undefined;
  let primaryStatusBadge = status !== undefined ? JsxRuntime.jsx(SalesDetailsPage$SalesDetailsStatusBadge, {
    value: status,
    saleType: saleType
  }) : saleType === "RefundReceipt" ? JsxRuntime.jsx(make, {
    value: "Refunded",
    refundReason: props.refundReason
  }) : null;
  let secondaryStatusBadge = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [props.statusDelivered ? JsxRuntime.jsx(make, {
      value: "Delivered"
    }) : null, props.statusBilled ? JsxRuntime.jsx(make, {
      value: "Billed"
    }) : null]
  });
  let tmp;
  if (saleType !== "CreditNote") {
    let tmp$1;
    if (payments.length !== 0) {
      let visiblePayments = payments.slice(0, 2);
      let overflowCount = payments.length - 2 | 0;
      tmp$1 = JsxRuntime.jsx(CanaryDisclosure.make, {
        children: payments.map((payment, index) => {
          let lineNumber = index + 1 | 0;
          let indexString = lineNumber < 10 ? `0` + lineNumber.toString() : lineNumber.toString();
          let formattedIndex = "#" + indexString;
          let formattedDate = DateHelpers.formateToShortDate(payment.date);
          let formattedTime = isDatetimeBackdated$1(payment.date) ? "(" + I18n.t("backdated") + ")" : I18n.t("at") + " " + DateHelpers.formateToShortTime(undefined, payment.date);
          let match = Sale.toRevenueImpactTotalAmounts(saleType, payment.amount, payment.amount);
          let formattedAmount = I18n.currencyFormat(undefined, "EUR", undefined, undefined, match[0]);
          let tmp;
          if (desktopScreenSize) {
            let newrecord = {
              ...{
                style: {
                  display: "flex",
                  width: "30px"
                }
              }
            };
            tmp = JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(TextStyle.make, {
              children: formattedIndex,
              weight: "semibold",
              size: "xsmall",
              lineHeight: "none",
              wrap: false
            }), newrecord));
          } else {
            tmp = null;
          }
          let newrecord$1 = {
            ...{
              style: {
                display: "flex",
                gap: "3px",
                width: "120px"
              }
            }
          };
          let newrecord$2 = {
            ...{
              style: {
                display: "flex",
                justifyContent: "flex-end",
                width: "85px"
              }
            }
          };
          return JsxRuntime.jsx(CanaryDisclosure.TableLine.make, {
            children: JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsxs(Inline.make, {
                children: [tmp, JsxRuntime.jsxs("div", (newrecord$1.children = [JsxRuntime.jsx(TextStyle.make, {
                  children: formattedDate,
                  size: "xxsmall",
                  lineHeight: "none",
                  wrap: false
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: formattedTime,
                  variation: "normal",
                  size: "xxsmall",
                  lineHeight: "none",
                  wrap: false
                })], newrecord$1)), JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(TextStyle.make, {
                  children: formattedAmount,
                  weight: "semibold",
                  size: "xxsmall",
                  lineHeight: "none",
                  wrap: false
                }), newrecord$2))],
                space: "medium"
              }), JsxRuntime.jsx(PaymentMethod.Badge.make, {
                value: payment.method,
                size: "normal",
                shortened: true,
                bordered: true
              })],
              space: "medium",
              align: "spaceBetween"
            })
          }, payment.id);
        }),
        title: I18n.t("Payments"),
        headerEndElement: JsxRuntime.jsxs(Inline.make, {
          children: [visiblePayments.map(payment => JsxRuntime.jsx(PaymentMethod.Badge.make, {
            value: payment.method,
            size: "normal",
            shortened: true,
            bordered: true
          }, payment.id)), overflowCount > 0 ? JsxRuntime.jsx(Badge.make, {
            children: `+` + overflowCount.toString(),
            size: "normal",
            borderColor: "#D7D7E0",
            backgroundColor: "#F8F8FB",
            foregroundColor: "#25243A"
          }) : null],
          space: "small"
        }),
        defaultExpanded: paymentsDefaultExpanded,
        hideTopSeparator: true
      });
    } else {
      tmp$1 = saleType !== "DeliveryNote" && saleType !== "Quote" ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(CanarySurface.make, {
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsx(Title.make, {
                children: I18n.t("No payment"),
                level: 4,
                align: "center",
                weight: "medium",
                color: "#25243A"
              }), JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Invoice is awaiting payment"),
                align: "center",
                size: "small"
              })]
            }),
            spaceX: "large",
            spaceY: "xlarge"
          })
        }),
        spaceTop: "xmedium"
      }) : null;
    }
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(CanaryDisclosure.make, {
        title: I18n.t("Statuses"),
        headerEndElement: JsxRuntime.jsxs(Inline.make, {
          children: [primaryStatusBadge, secondaryStatusBadge],
          space: "small"
        }),
        hideTopSeparator: true
      }), tmp$1]
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(CanaryStatsCount.make, {
        size: "xlarge",
        tone: "neutral-ghost",
        labelBold: true,
        label: I18n.t("Total"),
        value: formattedTotalAmount,
        valueTone: totalLabelTone,
        valueTooltipText: totalValueTooltipText
      }), tmp],
      space: "medium"
    })
  });
}
let SalesDetailsAmountAndPaymentsCard = {
  isDatetimeBackdated: isDatetimeBackdated$1,
  make: SalesDetailsPage$ViewPage$SalesDetailsAmountAndPaymentsCard
};
function SalesDetailsPage$ViewPage$SalesDetailsDatesCard(props) {
  let termsOfPayment = props.termsOfPayment;
  let dueDate = props.dueDate;
  let date = props.date;
  let subtitleElement;
  if (termsOfPayment !== undefined) {
    let formattedTerms = I18n.template(I18n.t("Payment under {{terms}}"), {
      terms: Primitive_option.valFromOption(termsOfPayment)
    }, undefined);
    subtitleElement = JsxRuntime.jsx(Title.make, {
      children: formattedTerms,
      level: 5,
      italic: true,
      color: "#767589"
    });
  } else {
    subtitleElement = null;
  }
  let formattedDate = DateHelpers.formateToShortDate(date);
  let formattedDueDate = Stdlib_Option.map(dueDate, DateHelpers.formateToShortDate);
  let mainDateLabel;
  mainDateLabel = props.saleType === "DeliveryNote" ? I18n.t("Delivery") : I18n.t("Issue");
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(CanaryStatsCount.make, {
        size: "medium",
        tone: "neutral-ghost",
        label: mainDateLabel,
        value: formattedDate,
        valueTooltipText: DateHelpers.formateToShortTime(undefined, date)
      }), formattedDueDate !== undefined ? JsxRuntime.jsx(CanaryStatsCount.make, {
        size: "medium",
        tone: "neutral-ghost",
        label: I18n.t("Due"),
        value: formattedDueDate,
        valueTooltipText: Stdlib_Option.map(dueDate, date => DateHelpers.formateToShortTime(undefined, date))
      }) : null],
      space: "medium",
      wrap: true
    }),
    title: I18n.t("Dates"),
    headerElement: subtitleElement
  });
}
let SalesDetailsDatesCard = {
  make: SalesDetailsPage$ViewPage$SalesDetailsDatesCard
};
let modalStyles = {
  modalContent: {
    "maxHeight-kskxy": "maxHeight-x1phlbz0",
    "overflowY-kORKVm": "overflowY-x1odjw0f",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6326"
  },
  referenceRow: {
    "borderBottomColor-kL6WhQ": "borderBottomColor-xczolg2",
    "borderBottomStyle-kfdmCh": "borderBottomStyle-x1q0q8m5",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-xso031l",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    "padding-kmVPX3": "padding-xc7ga6q",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6330"
  },
  referenceRowLast: {
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-x1qhh985",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6339"
  },
  referenceInfo: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x195vfkc",
    $$css: "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6342"
  }
};
function SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard$RelatedReferenceListingModal(props) {
  let references = props.references;
  let saleType = props.saleType;
  let modalTitle = Sale.toLabel(true, saleType);
  let newrecord = {
    ...{
      className: "maxHeight-x1phlbz0 overflowY-x1odjw0f",
      "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6326"
    }
  };
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Stack.make, {
        children: references.map((reference, index) => {
          let formattedDate = DateHelpers.formateToShortDate(reference.date);
          let formattedTime = isDatetimeBackdated(reference.date) ? "(" + I18n.t("backdated") + ")" : I18n.t("at") + " " + DateHelpers.formateToShortTime(undefined, reference.date);
          let formattedDatetime = formattedDate + " " + formattedTime;
          let isLast = index === (references.length - 1 | 0);
          let newrecord = {
            ...{
              0: {
                className: "borderBottomColor-xczolg2 borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l alignItems-x6s0dn4 display-x78zum5 justifyContent-x1qughib padding-xc7ga6q",
                "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6330"
              },
              1: {
                className: "borderBottomColor-xczolg2 borderBottomStyle-x1q0q8m5 alignItems-x6s0dn4 display-x78zum5 justifyContent-x1qughib padding-xc7ga6q borderBottomWidth-x1qhh985",
                "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6330; wino-gc:src/app/Sales/SalesDetailsPage.res.js:6339"
              }
            }[!!isLast << 0]
          };
          let newrecord$1 = {
            ...{
              className: "display-x78zum5 flexDirection-xdt5ytf gap-x195vfkc",
              "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:6342"
            }
          };
          newrecord.children = [JsxRuntime.jsxs("div", (newrecord$1.children = [JsxRuntime.jsx(TextStyle.make, {
            children: reference.name,
            weight: "semibold",
            size: "small"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: formattedDatetime,
            variation: "normal",
            size: "xsmall"
          })], newrecord$1)), JsxRuntime.jsx(Button.make, {
            tone: {
              NAME: "neutral",
              VAL: {
                accent: true
              }
            },
            size: "small",
            icon: "legacy_queue_arrow_right",
            href: SalesRoutes.showRoute(saleType, reference.id)
          })];
          return JsxRuntime.jsxs("div", newrecord, reference.id);
        }),
        space: "none"
      }), newrecord)),
      spaceX: "large",
      spaceY: "normal"
    }),
    opened: true,
    title: modalTitle,
    hideFooter: true,
    onRequestClose: props.onRequestClose
  });
}
let RelatedReferenceListingModal = {
  modalStyles: modalStyles,
  make: SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard$RelatedReferenceListingModal
};
function SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard(props) {
  let relatedReferences = props.relatedReferences;
  let match = React.useState(() => {});
  let setShowAllModalState = match[1];
  let showAllModalState = match[0];
  let invoices = Stdlib_Option.getOr(relatedReferences.invoices, []).toSorted((current, next) => Primitive_float.compare(next.date.getTime(), current.date.getTime()));
  let creditNotes = Stdlib_Option.getOr(relatedReferences.creditNotes, []).toSorted((current, next) => Primitive_float.compare(next.date.getTime(), current.date.getTime()));
  let refundReceipts = Stdlib_Option.getOr(relatedReferences.refundReceipts, []).toSorted((current, next) => Primitive_float.compare(next.date.getTime(), current.date.getTime()));
  let deliveryNotes = Stdlib_Option.getOr(relatedReferences.deliveryNotes, []).toSorted((current, next) => Primitive_float.compare(next.date.getTime(), current.date.getTime()));
  let relatedReferenceItems = Stdlib_Array.filterMap([Stdlib_Option.map(invoices[0], reference => ({
    id: reference.id,
    name: reference.name,
    comment: Sale.toLabel(undefined, "Invoice"),
    href: SalesRoutes.showRoute("Invoice", reference.id),
    saleType: "Invoice",
    allReferences: invoices
  })), Stdlib_Option.map(relatedReferences.quote, reference => ({
    id: reference.id,
    name: reference.name,
    comment: Sale.toLabel(undefined, "Quote"),
    href: SalesRoutes.showRoute("Quote", reference.id)
  })), Stdlib_Option.map(relatedReferences.salesReceipt, reference => ({
    id: reference.id,
    name: reference.name,
    comment: Sale.toLabel(undefined, "SalesReceipt"),
    href: SalesRoutes.showRoute("SalesReceipt", reference.id)
  })), Stdlib_Option.map(creditNotes[0], reference => ({
    id: reference.id,
    name: reference.name,
    comment: Sale.toLabel(undefined, "CreditNote"),
    href: SalesRoutes.showRoute("CreditNote", reference.id),
    saleType: "CreditNote",
    allReferences: creditNotes
  })), Stdlib_Option.map(refundReceipts[0], reference => ({
    id: reference.id,
    name: reference.name,
    comment: Sale.toLabel(undefined, "RefundReceipt"),
    href: SalesRoutes.showRoute("RefundReceipt", reference.id),
    saleType: "RefundReceipt",
    allReferences: refundReceipts
  })), Stdlib_Option.map(deliveryNotes[0], reference => ({
    id: reference.id,
    name: reference.name,
    comment: I18n.t("Delivery note"),
    href: SalesRoutes.showRoute("DeliveryNote", reference.id),
    saleType: "DeliveryNote",
    allReferences: deliveryNotes
  }))], item => item);
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsx(Stack.make, {
      children: relatedReferenceItems.length !== 0 ? relatedReferenceItems.map(item => {
        let hasMultipleReferences = Stdlib_Option.mapOr(item.allReferences, false, references => references.length > 1);
        let tmp;
        if (hasMultipleReferences) {
          let saleType = item.saleType;
          if (saleType !== undefined) {
            let allReferences = item.allReferences;
            tmp = allReferences !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [JsxRuntime.jsx(CountBadge.make, {
                children: "×" + allReferences.length.toString(),
                variation: "outline",
                tone: "neutral"
              }), JsxRuntime.jsx(CanarySeparator.make, {
                orientation: "vertical",
                size: "medium",
                spacing: "xs"
              }), JsxRuntime.jsx(Button.make, {
                label: I18n.t("View all"),
                size: "small",
                icon: "maximize_v2",
                onPress: () => setShowAllModalState(param => [saleType, allReferences])
              }), showAllModalState !== undefined ? JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard$RelatedReferenceListingModal, {
                saleType: showAllModalState[0],
                references: showAllModalState[1],
                onRequestClose: () => setShowAllModalState(param => {})
              }) : null]
            }) : null;
          } else {
            tmp = null;
          }
        } else {
          tmp = null;
        }
        let href = item.href;
        return JsxRuntime.jsx(CanaryToolbarDocument.make, {
          title: item.name,
          comment: item.comment,
          actionElements: JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [tmp, href !== undefined && !hasMultipleReferences ? JsxRuntime.jsx(Button.make, {
              tone: {
                NAME: "neutral",
                VAL: {
                  accent: true
                }
              },
              size: "small",
              icon: "legacy_queue_arrow_right",
              href: href
            }) : null]
          })
        }, item.id);
      }) : JsxRuntime.jsx(CanarySurface.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Title.make, {
            children: I18n.t("No related document"),
            level: 4,
            align: "center",
            weight: "medium",
            color: "#25243A"
          }),
          spaceX: "large",
          spaceY: "xlarge"
        })
      }),
      space: "normal"
    }),
    title: I18n.t("Related documents")
  });
}
let SalesDetailsRelatedReferenceCard = {
  RelatedReferenceListingModal: RelatedReferenceListingModal,
  make: SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard
};
function formatPostalCityLine(postalCode, city) {
  let city$1 = city.trim();
  let postalCode$1 = postalCode.trim();
  if (city$1 !== nonApplicableString && postalCode$1 !== nonApplicableString) {
    return postalCode$1 + `, ` + city$1;
  } else if (city$1 !== nonApplicableString) {
    return city$1;
  } else if (postalCode$1 !== nonApplicableString) {
    return postalCode$1;
  } else {
    return nonApplicableString;
  }
}
function SalesDetailsPage$ViewPage$SalesDetailsCustomerCard(props) {
  let customer = props.customer;
  let saleType = props.saleType;
  let tmp;
  if (customer !== undefined) {
    let customerKindLabel = Customer.Kind.toLabel(customer.isBusiness ? "Business" : "Individual");
    let formattedPostalCityLine = formatPostalCityLine(customer.postalCode, customer.city);
    let formattedPhoneNumber = I18n.phoneNumberFormat(customer.phoneNumber);
    let variation = value => {
      if (value === nonApplicableString) {
        return "placeholder";
      } else {
        return "neutral";
      }
    };
    tmp = JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: customer.name,
            weight: "strong",
            size: "small",
            lineHeight: "medium"
          }), JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: customerKindLabel,
              variation: "normal",
              size: "small",
              wrap: false
            }), JsxRuntime.jsx(Customer.Badge.make, {
              business: customer.isBusiness,
              loyaltyProgramMember: customer.isLoyaltyMember,
              compact: true
            })],
            space: "xsmall",
            alignY: "center",
            wrap: false
          }), JsxRuntime.jsx(TextStyle.make, {
            children: customer.address,
            variation: variation(customer.address),
            size: "small",
            lineHeight: "medium"
          }), JsxRuntime.jsx(TextStyle.make, {
            children: formattedPostalCityLine,
            variation: variation(formattedPostalCityLine),
            size: "small",
            wrap: false
          })],
          space: "xxsmall"
        }),
        spaceY: "xsmall"
      }), JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(CanarySeparator.make, {
          orientation: "vertical",
          size: "auto",
          spacing: "xl"
        }), JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: customer.country,
              variation: variation(customer.country),
              size: "small",
              wrap: false
            }), JsxRuntime.jsx(TextStyle.make, {
              children: customer.intraCommunityVAT,
              variation: variation(customer.intraCommunityVAT),
              size: "small",
              wrap: false
            }), JsxRuntime.jsx(TextStyle.make, {
              children: customer.email,
              variation: variation(customer.email),
              size: "small",
              lineHeight: "medium"
            }), JsxRuntime.jsx(TextStyle.make, {
              children: formattedPhoneNumber,
              variation: variation(formattedPhoneNumber),
              size: "small",
              wrap: false
            })],
            space: "xxsmall"
          }),
          spaceY: "xsmall"
        })],
        space: "none"
      })],
      wrap: false
    });
  } else {
    tmp = JsxRuntime.jsx(CanarySurface.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Title.make, {
          children: I18n.t(saleType === "Invoice" || saleType === "CreditNote" || saleType === "DeliveryNote" ? "No customer registered" : "Walk-in customer"),
          level: 4,
          align: "center",
          weight: "medium",
          color: "#25243A"
        }),
        spaceX: "large",
        spaceY: "xlarge"
      })
    });
  }
  let tmp$1;
  if (customer !== undefined) {
    let id = customer.id;
    tmp$1 = id !== undefined ? JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      tooltipText: I18n.t("See customer"),
      icon: "arrow_right",
      href: CustomerRoutes.showRoute(id)
    }) : null;
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: tmp,
    title: I18n.t("Customer"),
    headerEndElement: tmp$1
  });
}
let SalesDetailsCustomerCard = {
  formatPostalCityLine: formatPostalCityLine,
  make: SalesDetailsPage$ViewPage$SalesDetailsCustomerCard
};
function SalesDetailsPage$ViewPage$SalesDetailsInfoAndConditionsCard(props) {
  let taxesIncluded = props.taxesIncluded;
  let scope = Auth.useScope();
  let formattedPricelistName = Stdlib_Option.map(props.pricelistName, pricelistName => {
    let taxLabel = taxesIncluded ? I18n.t("VAT incl.") : I18n.t("VAT excl.");
    return pricelistName + ` - ` + taxLabel;
  });
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(CanaryInformationList.Line.make, {
    label: I18n.t("Shop"),
    valueElement: JsxRuntime.jsx(CanaryInformationList.ValueBadge.make, {
      value: props.shopName,
      backgroundColor: "rgba(255, 255, 255, 1)"
    }),
    hideCopyButton: true
  }) : null;
  let tmp$1;
  switch (props.saleType) {
    case "SalesReceipt":
    case "RefundReceipt":
      tmp$1 = null;
      break;
    default:
      tmp$1 = JsxRuntime.jsx(InputTextAreaField.make, {
        label: I18n.t("Note"),
        disabled: true,
        placeholder: I18n.t("No memo"),
        value: Stdlib_Option.getOr(props.note, "")
      });
  }
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(CanaryInformationList.make, {
        children: [tmp, JsxRuntime.jsx(CanaryInformationList.Line.make, {
          label: I18n.t("Price list"),
          valueElement: Stdlib_Option.map(formattedPricelistName, value => JsxRuntime.jsx(CanaryInformationList.ValueBadge.make, {
            value: value
          })),
          hideCopyButton: true
        })]
      }), JsxRuntime.jsxs(CanaryInformationList.make, {
        title: I18n.t("Source"),
        children: [JsxRuntime.jsx(CanaryInformationList.Line.make, {
          label: I18n.t("Device"),
          value: props.deviceLabel,
          hideCopyButton: true
        }), JsxRuntime.jsx(CanaryInformationList.Line.make, {
          label: I18n.t("Seller"),
          value: props.staffName,
          hideCopyButton: true
        })]
      }), tmp$1],
      space: "large"
    }),
    title: I18n.t("sales_details_page.info_and_conditions_card.title")
  });
}
let SalesDetailsInfoAndConditionsCard = {
  make: SalesDetailsPage$ViewPage$SalesDetailsInfoAndConditionsCard
};
function formatCurrency(value) {
  return I18n.currencyFormat(undefined, "EUR", 2, 2, value);
}
function formatDiscountValue(value, isPercentage) {
  if (isPercentage) {
    return "-" + I18n.percentFormat(undefined, undefined, 1, value / 100);
  } else {
    return "-" + formatCurrency(value);
  }
}
function formatTaxRates(taxes) {
  let formattedRates = taxes.map(tax => I18n.percentFormat(undefined, undefined, 1, tax.rate / 100));
  let len = formattedRates.length;
  if (len === 1) {
    return formattedRates[0];
  }
  if (len === 0) {
    return "-";
  }
  let lastRate = Stdlib_Option.getOr(formattedRates[formattedRates.length - 1 | 0], "");
  let otherRates = formattedRates.slice(0, formattedRates.length - 1 | 0);
  return otherRates.join(" ; ") + " " + I18n.t("and") + " " + lastRate;
}
function tableColumns(taxesIncluded, taxesExempted) {
  return [{
    key: "product",
    name: I18n.t("Product and description"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 200
      },
      width: taxesExempted ? {
        NAME: "fr",
        VAL: 1
      } : {
        NAME: "fr",
        VAL: 2.5
      },
      alignY: "flexStart"
    },
    render: param => {
      let data = param.data;
      let match = data.variant;
      let productCellElement;
      let exit = 0;
      if (typeof match !== "object") {
        exit = 1;
      } else {
        let variant = match._0;
        if (variant !== undefined) {
          let information_productName = variant.product.name;
          let information_variantName = variant.name;
          let information_sku = variant.stockKeepingUnit;
          let information_plu = Stdlib_Option.map(variant.priceLookUpCode, plu => plu.toString());
          let information_internalCode = variant.internalCode;
          let information_color = variant.product.color;
          let information_producerName = variant.product.producer;
          let information_designation = variant.product.designation;
          let information_productFamily = variant.product.family;
          let information_wineType = variant.product.wineType;
          let information_whiteWineType = variant.product.whiteWineType;
          let information_beerType = variant.product.beerType;
          let information_region = variant.product.region;
          let information_country = Stdlib_Option.getOr(variant.product.country, "");
          let information_categoryName = data.category;
          let information_supplierName = Stdlib_Option.map(variant.supplier, supplier => supplier.companyName);
          let information = {
            productName: information_productName,
            variantName: information_variantName,
            sku: information_sku,
            plu: information_plu,
            internalCode: information_internalCode,
            color: information_color,
            producerName: information_producerName,
            designation: information_designation,
            productFamily: information_productFamily,
            wineType: information_wineType,
            whiteWineType: information_whiteWineType,
            beerType: information_beerType,
            region: information_region,
            country: information_country,
            categoryName: information_categoryName,
            supplierName: information_supplierName
          };
          productCellElement = JsxRuntime.jsx(ProductReferenceTableCell.make, {
            redirectRoute: CatalogRoutes.variantRoute(variant.cku),
            productKind: variant.product.kind,
            information: information
          });
        } else {
          productCellElement = JsxRuntime.jsx(LabelTableCell.make, {
            label: data.name,
            inPrimaryColumn: true
          });
        }
      }
      if (exit === 1) {
        let match$1 = data.variant;
        let sublabel;
        sublabel = typeof match$1 !== "object" ? match$1 === "CompoundItem" ? I18n.t("Compound item") : I18n.t("Free-text item") : "";
        productCellElement = JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(LabelTableCell.make, {
            label: data.name,
            sublabel: sublabel,
            sublabelVariation: "primary",
            sublabelBold: true,
            sublabelItalic: true,
            inPrimaryColumn: true
          }),
          spaceLeft: "normal"
        });
      }
      if (data.discounts.length !== 0) {
        return JsxRuntime.jsxs(Stack.make, {
          children: [productCellElement, JsxRuntime.jsx("div", {
            children: data.discounts.map(discount => {
              let newrecord = {
                ...{
                  className: "color-x5auokd fontFamily-xvtss18 fontSize-xfifm61 fontWeight-x1s688f lineHeight-xo5v014",
                  "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5933"
                }
              };
              return JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsx("span", (newrecord.children = discount.name, newrecord)),
                spaceBottom: "small",
                spaceLeft: "normal"
              }, discount.name);
            })
          })],
          space: "xnormal"
        });
      } else {
        return productCellElement;
      }
    }
  }, {
    key: "quantity",
    name: I18n.t("Qty"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 50
      },
      width: {
        NAME: "fr",
        VAL: 0.5
      },
      alignX: "center",
      alignY: "flexStart"
    },
    render: param => {
      let match = param.data;
      let label = StockQuantity.formatStock(match.bulkUnit, match.quantity);
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelBold: true,
        align: "center"
      });
    }
  }, {
    key: "unit-price",
    name: taxesExempted ? I18n.t("U. price") : taxesIncluded ? I18n.t("U. price incl.") : I18n.t("U. price excl."),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 80
      },
      width: taxesExempted ? {
        NAME: "fr",
        VAL: 0.3
      } : undefined,
      alignX: "flexEnd",
      alignY: "flexStart"
    },
    render: param => {
      let match = param.data;
      let taxes = match.taxes;
      let unitPrice = match.unitPrice;
      let label = StockQuantity.formatUnitPrice(match.bulkUnit, undefined, true, unitPrice);
      let sublabel;
      if (taxesIncluded && !taxesExempted) {
        let unitPriceExcludingTaxes;
        let exit = 0;
        let tmp = match.variant;
        if (typeof tmp !== "object" && tmp === "CompoundItem") {
          unitPriceExcludingTaxes = PriceCalculator.Retail.CompoundTax.removeBack(unitPrice, taxes);
        } else {
          exit = 1;
        }
        if (exit === 1) {
          let taxRate = Stdlib_Option.mapOr(taxes[0], 0, tax => tax.rate);
          unitPriceExcludingTaxes = PriceCalculator.Retail.Tax.removeBack(unitPrice, taxRate);
        }
        sublabel = formatCurrency(unitPriceExcludingTaxes) + " " + I18n.t("HT");
      } else {
        sublabel = undefined;
      }
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        sublabel: sublabel,
        align: "end"
      });
    }
  }, {
    key: "vat-rate",
    name: I18n.t("VAT rate"),
    layout: {
      hidden: taxesExempted,
      minWidth: {
        NAME: "px",
        VAL: 40
      },
      width: {
        NAME: "fr",
        VAL: 1.1
      },
      alignX: "center",
      alignY: "flexStart"
    },
    render: param => {
      let label = formatTaxRates(param.data.taxes);
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelVariation: "normal",
        maxLines: 2,
        align: "center"
      });
    }
  }, {
    key: "total",
    name: taxesExempted ? I18n.t("Total") : taxesIncluded ? I18n.t("Total incl.") : I18n.t("Total excl."),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      },
      width: {
        NAME: "fr",
        VAL: 0.5
      },
      alignX: "flexEnd",
      alignY: "flexStart"
    },
    render: param => {
      let data = param.data;
      if (data.discounts.length === 0) {
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: formatCurrency(data.totalPrice),
          labelBold: true,
          align: "end"
        });
      }
      let hasFullPercentDiscount = data.discounts.some(discount => {
        if (discount.isPercentage) {
          return discount.value === 100;
        } else {
          return false;
        }
      });
      return JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(LabelTableCell.make, {
          label: formatCurrency(data.totalPrice),
          labelBold: true,
          labelStrikethrough: hasFullPercentDiscount,
          align: "end"
        }), JsxRuntime.jsx("div", {
          children: data.discounts.map(discount => {
            let newrecord = {
              ...{
                className: "color-x5auokd fontFamily-xvtss18 fontSize-xfifm61 fontWeight-x1s688f lineHeight-xo5v014",
                "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5933"
              }
            };
            return JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx("span", (newrecord.children = formatDiscountValue(discount.value, discount.isPercentage), newrecord)),
              spaceBottom: "small"
            }, discount.name);
          })
        })],
        space: "xnormal",
        align: "end"
      });
    }
  }];
}
function SalesDetailsPage$ViewPage$SalesDetailsArticlesCard$SalesDetailsArticlesFooter(props) {
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(SaleCartSummaryAmounts.make, {
        discounts: props.discounts.map(discount => ({
          name: discount.name,
          value: discount.value,
          isPercentage: discount.isPercentage
        })),
        taxes: props.taxes.map(tax => ({
          rate: tax.rate,
          baseAmount: tax.baseAmount,
          taxAmount: tax.taxAmount
        })),
        totalAmountBeforeDiscounts: props.totalAmountBeforeDiscounts,
        totalAmountExcludingTaxes: props.totalAmountExcludingTaxes,
        totalAmountIncludingTaxes: props.totalAmountIncludingTaxes,
        taxesIncluded: props.taxesIncluded,
        taxesExempted: props.taxesExempted
      }),
      space: "normal",
      align: "end"
    }),
    spaceX: "large",
    spaceTop: "normal",
    spaceBottom: "large"
  });
}
let SalesDetailsArticlesFooter = {
  make: SalesDetailsPage$ViewPage$SalesDetailsArticlesCard$SalesDetailsArticlesFooter
};
function totalItemsCount(items) {
  return Stdlib_Array.reduce(items, 0, (acc, item) => acc + item.quantity | 0);
}
let infoBannerElement = JsxRuntime.jsxs(NextBanner.make, {
  children: [JsxRuntime.jsx(NextBanner.Text.make, {
    text: I18n.t("sales_details_page.articles_card.header_banner.old_dashboard.missing_data_text.part_1")
  }), " ", JsxRuntime.jsx(NextBanner.Text.make, {
    text: I18n.t("sales_details_page.articles_card.header_banner.old_dashboard.missing_data_text.part_2"),
    bold: true
  })],
  variation: "info",
  maxLines: 1
});
function subtitleElement(totalCount) {
  let formattedItemsCount = totalCount.toString().padStart(totalCount > 0 ? 2 : 1, "0");
  return JsxRuntime.jsx(CountBadge.make, {
    children: formattedItemsCount,
    size: "small",
    variation: "outline",
    tone: "neutral"
  });
}
function SalesDetailsPage$ViewPage$SalesDetailsArticlesCard(props) {
  let taxesExempted = props.taxesExempted;
  let taxesIncluded = props.taxesIncluded;
  let items = props.items;
  let totalItemsCount$1 = totalItemsCount(items);
  let oldDashboardInvoiceGenerated = props.device === "DashboardWinoFr";
  let tableColumns$1 = tableColumns(taxesIncluded, taxesExempted);
  let newrecord = {
    ...{
      className: "display-x78zum5 flexDirection-xdt5ytf gap-x1v2ro7d maxHeight-xi1lmxo",
      "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5940"
    }
  };
  let newrecord$1 = {
    ...{
      className: "flex-x98rzlu minHeight-x2lwn1j",
      "data-style-src": "wino-gc:src/app/Sales/SalesDetailsPage.res.js:5946"
    }
  };
  newrecord.children = [oldDashboardInvoiceGenerated ? infoBannerElement : null, JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(Table.make, {
    columns: tableColumns$1,
    rows: items,
    keyExtractor: article => article.id
  }), newrecord$1)), JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsArticlesCard$SalesDetailsArticlesFooter, {
    discounts: props.discounts,
    taxes: props.taxes,
    totalAmountBeforeDiscounts: props.totalAmountBeforeDiscounts,
    totalAmountExcludingTaxes: props.totalAmountExcludingTaxes,
    totalAmountIncludingTaxes: props.totalAmountIncludingTaxes,
    taxesIncluded: taxesIncluded,
    taxesExempted: taxesExempted
  })];
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs("div", newrecord),
    title: I18n.t("Articles"),
    headerElement: subtitleElement(totalItemsCount$1)
  });
}
let SalesDetailsArticlesCard = {
  formatCurrency: formatCurrency,
  formatDiscountValue: formatDiscountValue,
  formatTaxRates: formatTaxRates,
  tableColumns: tableColumns,
  SalesDetailsArticlesFooter: SalesDetailsArticlesFooter,
  totalItemsCount: totalItemsCount,
  infoBannerElement: infoBannerElement,
  subtitleElement: subtitleElement,
  make: SalesDetailsPage$ViewPage$SalesDetailsArticlesCard
};
function SalesDetailsPage$ViewPage(props) {
  let electronicInvoicingFeatureState = props.electronicInvoicingFeatureState;
  let saleData = props.saleData;
  let saleType = props.saleType;
  let loyaltyEnabled = Loyalty.useAddonActivated(saleData.shop.id);
  let saleData$1;
  if (loyaltyEnabled) {
    saleData$1 = saleData;
  } else {
    let newrecord = {
      ...saleData
    };
    newrecord.customer = Stdlib_Option.map(saleData.customer, customer => {
      let newrecord = {
        ...customer
      };
      newrecord.isLoyaltyMember = false;
      return newrecord;
    });
    saleData$1 = newrecord;
  }
  let match = saleData$1.reference.relatedReferences.deliveryNotes;
  let statusDelivered = match !== undefined ? match.length !== 0 : false;
  let match$1 = saleData$1.reference.relatedReferences.invoices;
  let statusBilled = (match$1 !== undefined ? match$1.length !== 0 : false) && (saleType === "DeliveryNote" || saleType === "Quote");
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(NextResourceDetailsPage.Column.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsAmountAndPaymentsCard, {
          saleType: saleType,
          totalAmountIncludingTaxes: saleData$1.totalAmountIncludingTaxes,
          totalAmountExcludingTaxes: saleData$1.totalAmountExcludingTaxes,
          taxesIncluded: saleData$1.pricelistTaxesIncluded,
          taxesExempted: saleData$1.taxesExempted,
          statusDelivered: statusDelivered,
          statusBilled: statusBilled,
          status: saleData$1.status,
          refundReason: saleData$1.reference.refundReason,
          payments: saleData$1.payments
        }), View._if(saleType === "Invoice", () => JsxRuntime.jsx(ElectronicInvoicingWorkflowState.CardContainer.make, {
          featureState: electronicInvoicingFeatureState,
          data: saleData$1.eInvoicingWorkflowState,
          customerInvoicingAddress: saleData$1.customerInvoicingAddress
        })), JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsDatesCard, {
          date: saleData$1.date,
          dueDate: saleData$1.dueDate,
          termsOfPayment: saleData$1.termsOfPayment,
          saleType: saleType
        }), JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsRelatedReferenceCard, {
          relatedReferences: saleData$1.reference.relatedReferences
        }), JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsCustomerCard, {
          saleType: saleType,
          customer: saleData$1.customer
        }), JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsInfoAndConditionsCard, {
          saleType: saleType,
          shopName: saleData$1.shop.name,
          pricelistName: saleData$1.pricelistName,
          taxesIncluded: saleData$1.pricelistTaxesIncluded,
          deviceLabel: DeviceName.format(saleData$1.device),
          staffName: saleData$1.staffName,
          note: saleData$1.note
        })],
        space: "medium"
      })
    }), JsxRuntime.jsx(NextResourceDetailsPage.Column.make, {
      children: JsxRuntime.jsx(SalesDetailsPage$ViewPage$SalesDetailsArticlesCard, {
        items: saleData$1.items,
        taxes: saleData$1.taxes,
        discounts: saleData$1.discounts,
        totalAmountBeforeDiscounts: saleData$1.totalAmountBeforeDiscounts,
        totalAmountExcludingTaxes: saleData$1.totalAmountExcludingTaxes,
        totalAmountIncludingTaxes: saleData$1.totalAmountIncludingTaxes,
        taxesIncluded: saleData$1.pricelistTaxesIncluded,
        taxesExempted: saleData$1.taxesExempted,
        device: saleData$1.device
      })
    })]
  });
}
let ViewPage = {
  styles: styles,
  svgFromSaleType: svgFromSaleType,
  isDatetimeBackdated: isDatetimeBackdated,
  formatResourceName: formatResourceName,
  detailsPageHref: SalesRoutes.showRoute,
  SalesDetailsAmountAndPaymentsCard: SalesDetailsAmountAndPaymentsCard,
  SalesDetailsDatesCard: SalesDetailsDatesCard,
  SalesDetailsRelatedReferenceCard: SalesDetailsRelatedReferenceCard,
  SalesDetailsCustomerCard: SalesDetailsCustomerCard,
  SalesDetailsInfoAndConditionsCard: SalesDetailsInfoAndConditionsCard,
  SalesDetailsArticlesCard: SalesDetailsArticlesCard,
  make: SalesDetailsPage$ViewPage
};
function make$2(saleData, saleType, loyaltyEnabled) {
  return {
    resourceName: formatResourceName(saleData.reference.name, saleType, Primitive_object.equal(saleData.status, "Draft")),
    subtitle: Stdlib_Option.mapOr(saleData.customer, I18n.t(saleType === "Invoice" ? "No customer registered" : "Walk-in customer"), customer => customer.name),
    subtitleBadgeElement: Stdlib_Option.mapOr(saleData.customer, null, customer => JsxRuntime.jsx(Customer.Badge.make, {
      business: customer.isBusiness,
      loyaltyProgramMember: loyaltyEnabled && customer.isLoyaltyMember
    }))
  };
}
let SalesDetailsHeader = {
  make: make$2
};
function mergeQueryResults(salesQueryResult, electronicInvoicingQueryResult, skip) {
  if (skip) {
    return salesQueryResult;
  }
  if (typeof electronicInvoicingQueryResult === "object") {
    return salesQueryResult;
  }
  electronicInvoicingQueryResult === "NotAsked";
  if (typeof salesQueryResult !== "object") {
    return "Loading";
  }
  if (salesQueryResult.TAG === "Reloading") {
    return salesQueryResult;
  }
  let error = salesQueryResult._0;
  if (error.TAG === "Ok") {
    return "Loading";
  } else {
    return {
      TAG: "Done",
      _0: {
        TAG: "Error",
        _0: error._0
      }
    };
  }
}
function loadingOperations(saleType) {
  switch (saleType) {
    case "Invoice":
      return [query$1];
    case "SalesReceipt":
      return [query$2];
    case "CreditNote":
      return [query$3];
    case "RefundReceipt":
      return [query$4];
    case "DeliveryNote":
      return [query$5];
    case "Quote":
      return [query$6];
  }
}
function useInvoiceQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function useSaleReceiptQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function useCreditNoteQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function useRefundReceiptQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function useDeliveryNoteQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function useQuoteQueryAsyncResultFn(variables, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$5(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, variables));
}
function SalesDetailsPage(props) {
  let __useQuoteQueryAsyncResult = props.useQuoteQueryAsyncResult;
  let __useDeliveryNoteQueryAsyncResult = props.useDeliveryNoteQueryAsyncResult;
  let __useRefundReceiptQueryAsyncResult = props.useRefundReceiptQueryAsyncResult;
  let __useCreditNoteQueryAsyncResult = props.useCreditNoteQueryAsyncResult;
  let __useSaleReceiptQueryAsyncResult = props.useSaleReceiptQueryAsyncResult;
  let __useInvoiceQueryAsyncResult = props.useInvoiceQueryAsyncResult;
  let id = props.id;
  let saleType = props.saleType;
  let useInvoiceQueryAsyncResult = __useInvoiceQueryAsyncResult !== undefined ? __useInvoiceQueryAsyncResult : useInvoiceQueryAsyncResultFn;
  let useSaleReceiptQueryAsyncResult = __useSaleReceiptQueryAsyncResult !== undefined ? __useSaleReceiptQueryAsyncResult : useSaleReceiptQueryAsyncResultFn;
  let useCreditNoteQueryAsyncResult = __useCreditNoteQueryAsyncResult !== undefined ? __useCreditNoteQueryAsyncResult : useCreditNoteQueryAsyncResultFn;
  let useRefundReceiptQueryAsyncResult = __useRefundReceiptQueryAsyncResult !== undefined ? __useRefundReceiptQueryAsyncResult : useRefundReceiptQueryAsyncResultFn;
  let useDeliveryNoteQueryAsyncResult = __useDeliveryNoteQueryAsyncResult !== undefined ? __useDeliveryNoteQueryAsyncResult : useDeliveryNoteQueryAsyncResultFn;
  let useQuoteQueryAsyncResult = __useQuoteQueryAsyncResult !== undefined ? __useQuoteQueryAsyncResult : useQuoteQueryAsyncResultFn;
  let shops = Auth.useShops();
  let invoiceQueryAsyncResult = useInvoiceQueryAsyncResult({
    invoiceId: id
  }, saleType !== "Invoice");
  let receiptQueryAsyncResult = useSaleReceiptQueryAsyncResult({
    receiptId: id
  }, saleType !== "SalesReceipt");
  let creditNoteQueryAsyncResult = useCreditNoteQueryAsyncResult({
    creditNoteId: id
  }, saleType !== "CreditNote");
  let refundReceiptQueryAsyncResult = useRefundReceiptQueryAsyncResult({
    refundReceiptId: id
  }, saleType !== "RefundReceipt");
  let deliveryNoteQueryAsyncResult = useDeliveryNoteQueryAsyncResult({
    deliveryNoteId: id
  }, saleType !== "DeliveryNote");
  let quoteQueryAsyncResult = useQuoteQueryAsyncResult({
    quoteId: id
  }, saleType !== "Quote");
  let saleData;
  switch (saleType) {
    case "Invoice":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(invoiceQueryAsyncResult, queryResult => make$1({
        TAG: "InvoiceQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
    case "SalesReceipt":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(receiptQueryAsyncResult, queryResult => make$1({
        TAG: "ReceiptQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
    case "CreditNote":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(creditNoteQueryAsyncResult, queryResult => make$1({
        TAG: "CreditNoteQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
    case "RefundReceipt":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(refundReceiptQueryAsyncResult, queryResult => make$1({
        TAG: "RefundReceiptQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
    case "DeliveryNote":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(deliveryNoteQueryAsyncResult, queryResult => make$1({
        TAG: "DeliveryNoteQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
    case "Quote":
      saleData = AsyncResult.mapError(AsyncResult.mapOk(quoteQueryAsyncResult, queryResult => make$1({
        TAG: "QuoteQueryResult",
        _0: queryResult
      }, id)), param => {});
      break;
  }
  let saleShopId;
  let exit = 0;
  let saleData$1;
  if (typeof saleData !== "object") {
    saleShopId = undefined;
  } else if (saleData.TAG === "Reloading") {
    let saleData$2 = saleData._0;
    if (saleData$2.TAG === "Ok") {
      saleData$1 = saleData$2._0;
      exit = 1;
    } else {
      saleShopId = undefined;
    }
  } else {
    let saleData$3 = saleData._0;
    if (saleData$3.TAG === "Ok") {
      saleData$1 = saleData$3._0;
      exit = 1;
    } else {
      saleShopId = undefined;
    }
  }
  if (exit === 1) {
    saleShopId = Stdlib_Option.map(shops.find(shop => shop.id === saleData$1.shop.id), shop => shop.id);
  }
  let electronicInvoicingFeatureState = ElectronicInvoicing.useActiveFeatureState(saleShopId);
  let saleData$4 = mergeQueryResults(saleData, electronicInvoicingFeatureState, saleType !== "Invoice");
  let tmp;
  let exit$1 = 0;
  let saleData$5;
  if (typeof saleData$4 !== "object") {
    tmp = null;
  } else if (saleData$4.TAG === "Reloading") {
    let saleData$6 = saleData$4._0;
    if (saleData$6.TAG === "Ok") {
      saleData$5 = saleData$6._0;
      exit$1 = 1;
    } else {
      tmp = null;
    }
  } else {
    let saleData$7 = saleData$4._0;
    if (saleData$7.TAG === "Ok") {
      saleData$5 = saleData$7._0;
      exit$1 = 1;
    } else {
      tmp = null;
    }
  }
  if (exit$1 === 1) {
    tmp = JsxRuntime.jsx(SalesDetailsPage$ViewPage, {
      saleType: saleType,
      saleData: saleData$5,
      electronicInvoicingFeatureState: electronicInvoicingFeatureState
    }, id);
  }
  return JsxRuntime.jsx(NextResourceDetailsPage.make, {
    children: tmp,
    header: AsyncResult.mapOk(saleData$4, saleData => make$2(saleData, saleType, Loyalty.isAddonActivated(shops, saleData.shop.id))),
    resourceTypeLabel: Sale.toLabel(undefined, saleType),
    resourceNameSvg: svgFromSaleType(saleType),
    loadingOperations: loadingOperations(saleType)
  });
}
let ElectronicInvoicingWorkflowStateResultFragment;
let make$3 = SalesDetailsPage;
export { ElectronicInvoicingWorkflowStateResultFragment, nonApplicableString, SalesVariantFragment, SalesDetailsInvoiceQuery, SalesDetailsReceiptQuery, SalesDetailsCreditNoteQuery, SalesDetailsRefundReceiptQuery, SalesDetailsDeliveryNoteQuery, SalesDetailsQuoteQuery, SalesDetailsStatusBadge, SalesDetailsSecondaryStatusBadge, SaleDetailsData, ViewPage, SalesDetailsHeader, mergeQueryResults, loadingOperations, useInvoiceQueryAsyncResultFn, useSaleReceiptQueryAsyncResultFn, useCreditNoteQueryAsyncResultFn, useRefundReceiptQueryAsyncResultFn, useDeliveryNoteQueryAsyncResultFn, useQuoteQueryAsyncResultFn, make$3 as make };
/* query Not a pure module */